!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.OsmRequest = e() : t.OsmRequest = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 42);
  }([function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          h,
          f,
          p,
          d = {}.hasOwnProperty;
      p = n(2), f = p.isObject, h = p.isFunction, l = p.isEmpty, s = null, e = null, r = null, i = null, o = null, u = null, c = null, a = null, t.exports = function () {
        function t(t) {
          this.parent = t, this.parent && (this.options = this.parent.options, this.stringify = this.parent.stringify), this.children = [], s || (s = n(7), e = n(8), r = n(9), i = n(10), o = n(11), u = n(16), c = n(17), a = n(18));
        }

        return t.prototype.element = function (t, e, n) {
          var r, i, o, s, a, u, c, p, y, g;
          if (u = null, null == e && (e = {}), e = e.valueOf(), f(e) || (y = [e, n], n = y[0], e = y[1]), null != t && (t = t.valueOf()), Array.isArray(t)) for (o = 0, c = t.length; o < c; o++) {
            i = t[o], u = this.element(i);
          } else if (h(t)) u = this.element(t.apply());else if (f(t)) {
            for (a in t) {
              if (d.call(t, a)) if (g = t[a], h(g) && (g = g.apply()), f(g) && l(g) && (g = null), !this.options.ignoreDecorators && this.stringify.convertAttKey && 0 === a.indexOf(this.stringify.convertAttKey)) u = this.attribute(a.substr(this.stringify.convertAttKey.length), g);else if (!this.options.separateArrayItems && Array.isArray(g)) for (s = 0, p = g.length; s < p; s++) {
                i = g[s], r = {}, r[a] = i, u = this.element(r);
              } else f(g) ? (u = this.element(a), u.element(g)) : u = this.element(a, g);
            }
          } else u = !this.options.ignoreDecorators && this.stringify.convertTextKey && 0 === t.indexOf(this.stringify.convertTextKey) ? this.text(n) : !this.options.ignoreDecorators && this.stringify.convertCDataKey && 0 === t.indexOf(this.stringify.convertCDataKey) ? this.cdata(n) : !this.options.ignoreDecorators && this.stringify.convertCommentKey && 0 === t.indexOf(this.stringify.convertCommentKey) ? this.comment(n) : !this.options.ignoreDecorators && this.stringify.convertRawKey && 0 === t.indexOf(this.stringify.convertRawKey) ? this.raw(n) : !this.options.ignoreDecorators && this.stringify.convertPIKey && 0 === t.indexOf(this.stringify.convertPIKey) ? this.instruction(t.substr(this.stringify.convertPIKey.length), n) : this.node(t, e, n);
          if (null == u) throw new Error("Could not create any elements with: " + t);
          return u;
        }, t.prototype.insertBefore = function (t, e, n) {
          var r, i, o;
          if (this.isRoot) throw new Error("Cannot insert elements at root level");
          return i = this.parent.children.indexOf(this), o = this.parent.children.splice(i), r = this.parent.element(t, e, n), Array.prototype.push.apply(this.parent.children, o), r;
        }, t.prototype.insertAfter = function (t, e, n) {
          var r, i, o;
          if (this.isRoot) throw new Error("Cannot insert elements at root level");
          return i = this.parent.children.indexOf(this), o = this.parent.children.splice(i + 1), r = this.parent.element(t, e, n), Array.prototype.push.apply(this.parent.children, o), r;
        }, t.prototype.remove = function () {
          var t;
          if (this.isRoot) throw new Error("Cannot remove the root element");
          return t = this.parent.children.indexOf(this), [].splice.apply(this.parent.children, [t, t - t + 1].concat([])), this.parent;
        }, t.prototype.node = function (t, e, n) {
          var r, i;
          return null != t && (t = t.valueOf()), e || (e = {}), e = e.valueOf(), f(e) || (i = [e, n], n = i[0], e = i[1]), r = new s(this, t, e), null != n && r.text(n), this.children.push(r), r;
        }, t.prototype.text = function (t) {
          var e;
          return e = new c(this, t), this.children.push(e), this;
        }, t.prototype.cdata = function (t) {
          var n;
          return n = new e(this, t), this.children.push(n), this;
        }, t.prototype.comment = function (t) {
          var e;
          return e = new r(this, t), this.children.push(e), this;
        }, t.prototype.commentBefore = function (t) {
          var e, n;
          return e = this.parent.children.indexOf(this), n = this.parent.children.splice(e), this.parent.comment(t), Array.prototype.push.apply(this.parent.children, n), this;
        }, t.prototype.commentAfter = function (t) {
          var e, n;
          return e = this.parent.children.indexOf(this), n = this.parent.children.splice(e + 1), this.parent.comment(t), Array.prototype.push.apply(this.parent.children, n), this;
        }, t.prototype.raw = function (t) {
          var e;
          return e = new u(this, t), this.children.push(e), this;
        }, t.prototype.instruction = function (t, e) {
          var n, r, i, o, s;
          if (null != t && (t = t.valueOf()), null != e && (e = e.valueOf()), Array.isArray(t)) for (o = 0, s = t.length; o < s; o++) {
            n = t[o], this.instruction(n);
          } else if (f(t)) for (n in t) {
            d.call(t, n) && (r = t[n], this.instruction(n, r));
          } else h(e) && (e = e.apply()), i = new a(this, t, e), this.children.push(i);
          return this;
        }, t.prototype.instructionBefore = function (t, e) {
          var n, r;
          return n = this.parent.children.indexOf(this), r = this.parent.children.splice(n), this.parent.instruction(t, e), Array.prototype.push.apply(this.parent.children, r), this;
        }, t.prototype.instructionAfter = function (t, e) {
          var n, r;
          return n = this.parent.children.indexOf(this), r = this.parent.children.splice(n + 1), this.parent.instruction(t, e), Array.prototype.push.apply(this.parent.children, r), this;
        }, t.prototype.declaration = function (t, e, n) {
          var r, o;
          return r = this.document(), o = new i(r, t, e, n), r.children[0] instanceof i ? r.children[0] = o : r.children.unshift(o), r.root() || r;
        }, t.prototype.doctype = function (t, e) {
          var n, r, i, s, a, u, c, l, h, f;

          for (r = this.document(), i = new o(r, t, e), h = r.children, s = a = 0, c = h.length; a < c; s = ++a) {
            if ((n = h[s]) instanceof o) return r.children[s] = i, i;
          }

          for (f = r.children, s = u = 0, l = f.length; u < l; s = ++u) {
            if (n = f[s], n.isRoot) return r.children.splice(s, 0, i), i;
          }

          return r.children.push(i), i;
        }, t.prototype.up = function () {
          if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
          return this.parent;
        }, t.prototype.root = function () {
          var t;

          for (t = this; t;) {
            if (t.isDocument) return t.rootObject;
            if (t.isRoot) return t;
            t = t.parent;
          }
        }, t.prototype.document = function () {
          var t;

          for (t = this; t;) {
            if (t.isDocument) return t;
            t = t.parent;
          }
        }, t.prototype.end = function (t) {
          return this.document().end(t);
        }, t.prototype.prev = function () {
          var t;
          if ((t = this.parent.children.indexOf(this)) < 1) throw new Error("Already at the first node");
          return this.parent.children[t - 1];
        }, t.prototype.next = function () {
          var t;
          if (-1 === (t = this.parent.children.indexOf(this)) || t === this.parent.children.length - 1) throw new Error("Already at the last node");
          return this.parent.children[t + 1];
        }, t.prototype.importDocument = function (t) {
          var e;
          return e = t.root().clone(), e.parent = this, e.isRoot = !1, this.children.push(e), this;
        }, t.prototype.ele = function (t, e, n) {
          return this.element(t, e, n);
        }, t.prototype.nod = function (t, e, n) {
          return this.node(t, e, n);
        }, t.prototype.txt = function (t) {
          return this.text(t);
        }, t.prototype.dat = function (t) {
          return this.cdata(t);
        }, t.prototype.com = function (t) {
          return this.comment(t);
        }, t.prototype.ins = function (t, e) {
          return this.instruction(t, e);
        }, t.prototype.doc = function () {
          return this.document();
        }, t.prototype.dec = function (t, e, n) {
          return this.declaration(t, e, n);
        }, t.prototype.dtd = function (t, e) {
          return this.doctype(t, e);
        }, t.prototype.e = function (t, e, n) {
          return this.element(t, e, n);
        }, t.prototype.n = function (t, e, n) {
          return this.node(t, e, n);
        }, t.prototype.t = function (t) {
          return this.text(t);
        }, t.prototype.d = function (t) {
          return this.cdata(t);
        }, t.prototype.c = function (t) {
          return this.comment(t);
        }, t.prototype.r = function (t) {
          return this.raw(t);
        }, t.prototype.i = function (t, e) {
          return this.instruction(t, e);
        }, t.prototype.u = function () {
          return this.up();
        }, t.prototype.importXMLBuilder = function (t) {
          return this.importDocument(t);
        }, t;
      }();
    }).call(this);
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e) {
    (function () {
      var e,
          n,
          r,
          i,
          o,
          s,
          a = [].slice,
          u = {}.hasOwnProperty;
      e = function e() {
        var t, e, n, r, o, s;
        if (s = arguments[0], o = 2 <= arguments.length ? a.call(arguments, 1) : [], i(Object.assign)) Object.assign.apply(null, arguments);else for (t = 0, n = o.length; t < n; t++) {
          if (null != (r = o[t])) for (e in r) {
            u.call(r, e) && (s[e] = r[e]);
          }
        }
        return s;
      }, i = function i(t) {
        return !!t && "[object Function]" === Object.prototype.toString.call(t);
      }, o = function o(t) {
        var e;
        return !!t && ("function" == (e = typeof t) || "object" === e);
      }, n = function n(t) {
        return i(Array.isArray) ? Array.isArray(t) : "[object Array]" === Object.prototype.toString.call(t);
      }, r = function r(t) {
        var e;
        if (n(t)) return !t.length;

        for (e in t) {
          if (u.call(t, e)) return !1;
        }

        return !0;
      }, s = function s(t) {
        var e, n;
        return o(t) && (n = Object.getPrototypeOf(t)) && (e = n.constructor) && "function" == typeof e && e instanceof e && Function.prototype.toString.call(e) === Function.prototype.toString.call(Object);
      }, t.exports.assign = e, t.exports.isFunction = i, t.exports.isObject = o, t.exports.isArray = n, t.exports.isEmpty = r, t.exports.isPlainObject = s;
    }).call(this);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if (!(this instanceof r)) return new r(t);
      c.call(this, t), l.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", i);
    }

    function i() {
      this.allowHalfOpen || this._writableState.ended || s(o, this);
    }

    function o(t) {
      t.end();
    }

    var s = n(21).nextTick,
        a = Object.keys || function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e;
    };

    t.exports = r;
    var u = n(6);
    u.inherits = n(5);
    var c = n(36),
        l = n(27);
    u.inherits(r, c);

    for (var h = a(l.prototype), f = 0; f < h.length; f++) {
      var p = h[f];
      r.prototype[p] || (r.prototype[p] = l.prototype[p]);
    }

    Object.defineProperty(r.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), r.prototype._destroy = function (t, e) {
      this.push(null), this.end(), s(e, t);
    };
  }, function (t, e, n) {
    (function (e) {
      function n(t, e) {
        return function () {
          return e.apply(t, Array.prototype.slice.call(arguments, 0));
        };
      }

      function r(t, e) {
        return Array.prototype.slice.call(t, e || 0);
      }

      function i(t, e) {
        s(t, function (t, n) {
          return e(t, n), !1;
        });
      }

      function o(t, e) {
        var n = a(t) ? [] : {};
        return s(t, function (t, r) {
          return n[r] = e(t, r), !1;
        }), n;
      }

      function s(t, e) {
        if (a(t)) {
          for (var n = 0; n < t.length; n++) {
            if (e(t[n], n)) return t[n];
          }
        } else for (var r in t) {
          if (t.hasOwnProperty(r) && e(t[r], r)) return t[r];
        }
      }

      function a(t) {
        return null != t && "function" != typeof t && "number" == typeof t.length;
      }

      function u(t) {
        return t && "[object Function]" === {}.toString.call(t);
      }

      function c(t) {
        return t && "[object Object]" === {}.toString.call(t);
      }

      var l = function () {
        return Object.assign ? Object.assign : function (t, e, n, r) {
          for (var o = 1; o < arguments.length; o++) {
            i(Object(arguments[o]), function (e, n) {
              t[n] = e;
            });
          }

          return t;
        };
      }(),
          h = function () {
        function t() {}

        return Object.create ? function (t, e, n, i) {
          var o = r(arguments, 1);
          return l.apply(this, [Object.create(t)].concat(o));
        } : function (e, n, i, o) {
          var s = r(arguments, 1);
          return t.prototype = e, l.apply(this, [new t()].concat(s));
        };
      }(),
          f = function () {
        return String.prototype.trim ? function (t) {
          return String.prototype.trim.call(t);
        } : function (t) {
          return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
      }(),
          p = "undefined" != typeof window ? window : e;

      t.exports = {
        assign: l,
        create: h,
        trim: f,
        bind: n,
        slice: r,
        each: i,
        map: o,
        pluck: s,
        isList: a,
        isFunction: u,
        isObject: c,
        Global: p
      };
    }).call(e, n(1));
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : t.exports = function (t, e) {
      t.super_ = e;

      var n = function n() {};

      n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
    };
  }, function (t, e, n) {
    (function (t) {
      function n(t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === g(t);
      }

      function r(t) {
        return "boolean" == typeof t;
      }

      function i(t) {
        return null === t;
      }

      function o(t) {
        return null == t;
      }

      function s(t) {
        return "number" == typeof t;
      }

      function a(t) {
        return "string" == typeof t;
      }

      function u(t) {
        return "symbol" == typeof t;
      }

      function c(t) {
        return void 0 === t;
      }

      function l(t) {
        return "[object RegExp]" === g(t);
      }

      function h(t) {
        return "object" == typeof t && null !== t;
      }

      function f(t) {
        return "[object Date]" === g(t);
      }

      function p(t) {
        return "[object Error]" === g(t) || t instanceof Error;
      }

      function d(t) {
        return "function" == typeof t;
      }

      function y(t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }

      function g(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = n, e.isBoolean = r, e.isNull = i, e.isNullOrUndefined = o, e.isNumber = s, e.isString = a, e.isSymbol = u, e.isUndefined = c, e.isRegExp = l, e.isObject = h, e.isDate = f, e.isError = p, e.isFunction = d, e.isPrimitive = y, e.isBuffer = t.isBuffer;
    }).call(e, n(25).Buffer);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a = function a(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          u.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          u = {}.hasOwnProperty;

      s = n(2), o = s.isObject, i = s.isFunction, r = n(0), e = n(32), t.exports = function (t) {
        function n(t, e, r) {
          if (n.__super__.constructor.call(this, t), null == e) throw new Error("Missing element name");
          this.name = this.stringify.eleName(e), this.attributes = {}, null != r && this.attribute(r), t.isDocument && (this.isRoot = !0, this.documentObject = t, t.rootObject = this);
        }

        return a(n, t), n.prototype.clone = function () {
          var t, e, n, r;
          n = Object.create(this), n.isRoot && (n.documentObject = null), n.attributes = {}, r = this.attributes;

          for (e in r) {
            u.call(r, e) && (t = r[e], n.attributes[e] = t.clone());
          }

          return n.children = [], this.children.forEach(function (t) {
            var e;
            return e = t.clone(), e.parent = n, n.children.push(e);
          }), n;
        }, n.prototype.attribute = function (t, n) {
          var r, s;
          if (null != t && (t = t.valueOf()), o(t)) for (r in t) {
            u.call(t, r) && (s = t[r], this.attribute(r, s));
          } else i(n) && (n = n.apply()), this.options.skipNullAttributes && null == n || (this.attributes[t] = new e(this, t, n));
          return this;
        }, n.prototype.removeAttribute = function (t) {
          var e, n, r;
          if (null == t) throw new Error("Missing attribute name");
          if (t = t.valueOf(), Array.isArray(t)) for (n = 0, r = t.length; n < r; n++) {
            e = t[n], delete this.attributes[e];
          } else delete this.attributes[t];
          return this;
        }, n.prototype.toString = function (t) {
          return this.options.writer.set(t).element(this);
        }, n.prototype.att = function (t, e) {
          return this.attribute(t, e);
        }, n.prototype.a = function (t, e) {
          return this.attribute(t, e);
        }, n;
      }(r);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing CDATA text");
          this.text = this.stringify.cdata(n);
        }

        return r(e, t), e.prototype.clone = function () {
          return Object.create(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).cdata(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing comment text");
          this.text = this.stringify.comment(n);
        }

        return r(e, t), e.prototype.clone = function () {
          return Object.create(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).comment(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i = function i(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          o.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          o = {}.hasOwnProperty;

      r = n(2).isObject, e = n(0), t.exports = function (t) {
        function e(t, n, i, o) {
          var s;
          e.__super__.constructor.call(this, t), r(n) && (s = n, n = s.version, i = s.encoding, o = s.standalone), n || (n = "1.0"), this.version = this.stringify.xmlVersion(n), null != i && (this.encoding = this.stringify.xmlEncoding(i)), null != o && (this.standalone = this.stringify.xmlStandalone(o));
        }

        return i(e, t), e.prototype.toString = function (t) {
          return this.options.writer.set(t).declaration(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a,
          u = function u(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          c.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          c = {}.hasOwnProperty;

      a = n(2).isObject, s = n(0), e = n(12), i = n(13), r = n(14), o = n(15), t.exports = function (t) {
        function n(t, e, r) {
          var i, o;
          n.__super__.constructor.call(this, t), this.documentObject = t, a(e) && (i = e, e = i.pubID, r = i.sysID), null == r && (o = [e, r], r = o[0], e = o[1]), null != e && (this.pubID = this.stringify.dtdPubID(e)), null != r && (this.sysID = this.stringify.dtdSysID(r));
        }

        return u(n, t), n.prototype.element = function (t, e) {
          var n;
          return n = new r(this, t, e), this.children.push(n), this;
        }, n.prototype.attList = function (t, n, r, i, o) {
          var s;
          return s = new e(this, t, n, r, i, o), this.children.push(s), this;
        }, n.prototype.entity = function (t, e) {
          var n;
          return n = new i(this, !1, t, e), this.children.push(n), this;
        }, n.prototype.pEntity = function (t, e) {
          var n;
          return n = new i(this, !0, t, e), this.children.push(n), this;
        }, n.prototype.notation = function (t, e) {
          var n;
          return n = new o(this, t, e), this.children.push(n), this;
        }, n.prototype.toString = function (t) {
          return this.options.writer.set(t).docType(this);
        }, n.prototype.ele = function (t, e) {
          return this.element(t, e);
        }, n.prototype.att = function (t, e, n, r, i) {
          return this.attList(t, e, n, r, i);
        }, n.prototype.ent = function (t, e) {
          return this.entity(t, e);
        }, n.prototype.pent = function (t, e) {
          return this.pEntity(t, e);
        }, n.prototype.not = function (t, e) {
          return this.notation(t, e);
        }, n.prototype.up = function () {
          return this.root() || this.documentObject;
        }, n;
      }(s);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n, r, i, o, s) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing DTD element name");
          if (null == r) throw new Error("Missing DTD attribute name");
          if (!i) throw new Error("Missing DTD attribute type");
          if (!o) throw new Error("Missing DTD attribute default");
          if (0 !== o.indexOf("#") && (o = "#" + o), !o.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
          if (s && !o.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT");
          this.elementName = this.stringify.eleName(n), this.attributeName = this.stringify.attName(r), this.attributeType = this.stringify.dtdAttType(i), this.defaultValue = this.stringify.dtdAttDefault(s), this.defaultValueType = o;
        }

        return r(e, t), e.prototype.toString = function (t) {
          return this.options.writer.set(t).dtdAttList(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i = function i(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          o.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          o = {}.hasOwnProperty;

      r = n(2).isObject, e = n(0), t.exports = function (t) {
        function e(t, n, i, o) {
          if (e.__super__.constructor.call(this, t), null == i) throw new Error("Missing entity name");
          if (null == o) throw new Error("Missing entity value");

          if (this.pe = !!n, this.name = this.stringify.eleName(i), r(o)) {
            if (!o.pubID && !o.sysID) throw new Error("Public and/or system identifiers are required for an external entity");
            if (o.pubID && !o.sysID) throw new Error("System identifier is required for a public external entity");
            if (null != o.pubID && (this.pubID = this.stringify.dtdPubID(o.pubID)), null != o.sysID && (this.sysID = this.stringify.dtdSysID(o.sysID)), null != o.nData && (this.nData = this.stringify.dtdNData(o.nData)), this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity");
          } else this.value = this.stringify.dtdEntityValue(o);
        }

        return i(e, t), e.prototype.toString = function (t) {
          return this.options.writer.set(t).dtdEntity(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n, r) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing DTD element name");
          r || (r = "(#PCDATA)"), Array.isArray(r) && (r = "(" + r.join(",") + ")"), this.name = this.stringify.eleName(n), this.value = this.stringify.dtdElementValue(r);
        }

        return r(e, t), e.prototype.toString = function (t) {
          return this.options.writer.set(t).dtdElement(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n, r) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing notation name");
          if (!r.pubID && !r.sysID) throw new Error("Public or system identifiers are required for an external entity");
          this.name = this.stringify.eleName(n), null != r.pubID && (this.pubID = this.stringify.dtdPubID(r.pubID)), null != r.sysID && (this.sysID = this.stringify.dtdSysID(r.sysID));
        }

        return r(e, t), e.prototype.toString = function (t) {
          return this.options.writer.set(t).dtdNotation(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing raw text");
          this.value = this.stringify.raw(n);
        }

        return r(e, t), e.prototype.clone = function () {
          return Object.create(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).raw(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing element text");
          this.value = this.stringify.eleText(n);
        }

        return r(e, t), e.prototype.clone = function () {
          return Object.create(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).text(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r = function r(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          i.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          i = {}.hasOwnProperty;

      e = n(0), t.exports = function (t) {
        function e(t, n, r) {
          if (e.__super__.constructor.call(this, t), null == n) throw new Error("Missing instruction target");
          this.target = this.stringify.insTarget(n), r && (this.value = this.stringify.insValue(r));
        }

        return r(e, t), e.prototype.clone = function () {
          return Object.create(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).processingInstruction(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e) {
    function n() {
      this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
    }

    function r(t) {
      return "function" == typeof t;
    }

    function i(t) {
      return "number" == typeof t;
    }

    function o(t) {
      return "object" == typeof t && null !== t;
    }

    function s(t) {
      return void 0 === t;
    }

    t.exports = n, n.EventEmitter = n, n.prototype._events = void 0, n.prototype._maxListeners = void 0, n.defaultMaxListeners = 10, n.prototype.setMaxListeners = function (t) {
      if (!i(t) || t < 0 || isNaN(t)) throw TypeError("n must be a positive number");
      return this._maxListeners = t, this;
    }, n.prototype.emit = function (t) {
      var e, n, i, a, u, c;

      if (this._events || (this._events = {}), "error" === t && (!this._events.error || o(this._events.error) && !this._events.error.length)) {
        if ((e = arguments[1]) instanceof Error) throw e;
        var l = new Error('Uncaught, unspecified "error" event. (' + e + ")");
        throw l.context = e, l;
      }

      if (n = this._events[t], s(n)) return !1;
      if (r(n)) switch (arguments.length) {
        case 1:
          n.call(this);
          break;

        case 2:
          n.call(this, arguments[1]);
          break;

        case 3:
          n.call(this, arguments[1], arguments[2]);
          break;

        default:
          a = Array.prototype.slice.call(arguments, 1), n.apply(this, a);
      } else if (o(n)) for (a = Array.prototype.slice.call(arguments, 1), c = n.slice(), i = c.length, u = 0; u < i; u++) {
        c[u].apply(this, a);
      }
      return !0;
    }, n.prototype.addListener = function (t, e) {
      var i;
      if (!r(e)) throw TypeError("listener must be a function");
      return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", t, r(e.listener) ? e.listener : e), this._events[t] ? o(this._events[t]) ? this._events[t].push(e) : this._events[t] = [this._events[t], e] : this._events[t] = e, o(this._events[t]) && !this._events[t].warned && (i = s(this._maxListeners) ? n.defaultMaxListeners : this._maxListeners) && i > 0 && this._events[t].length > i && (this._events[t].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[t].length), "function" == typeof console.trace && console.trace()), this;
    }, n.prototype.on = n.prototype.addListener, n.prototype.once = function (t, e) {
      function n() {
        this.removeListener(t, n), i || (i = !0, e.apply(this, arguments));
      }

      if (!r(e)) throw TypeError("listener must be a function");
      var i = !1;
      return n.listener = e, this.on(t, n), this;
    }, n.prototype.removeListener = function (t, e) {
      var n, i, s, a;
      if (!r(e)) throw TypeError("listener must be a function");
      if (!this._events || !this._events[t]) return this;
      if (n = this._events[t], s = n.length, i = -1, n === e || r(n.listener) && n.listener === e) delete this._events[t], this._events.removeListener && this.emit("removeListener", t, e);else if (o(n)) {
        for (a = s; a-- > 0;) {
          if (n[a] === e || n[a].listener && n[a].listener === e) {
            i = a;
            break;
          }
        }

        if (i < 0) return this;
        1 === n.length ? (n.length = 0, delete this._events[t]) : n.splice(i, 1), this._events.removeListener && this.emit("removeListener", t, e);
      }
      return this;
    }, n.prototype.removeAllListeners = function (t) {
      var e, n;
      if (!this._events) return this;
      if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[t] && delete this._events[t], this;

      if (0 === arguments.length) {
        for (e in this._events) {
          "removeListener" !== e && this.removeAllListeners(e);
        }

        return this.removeAllListeners("removeListener"), this._events = {}, this;
      }

      if (n = this._events[t], r(n)) this.removeListener(t, n);else if (n) for (; n.length;) {
        this.removeListener(t, n[n.length - 1]);
      }
      return delete this._events[t], this;
    }, n.prototype.listeners = function (t) {
      return this._events && this._events[t] ? r(this._events[t]) ? [this._events[t]] : this._events[t].slice() : [];
    }, n.prototype.listenerCount = function (t) {
      if (this._events) {
        var e = this._events[t];
        if (r(e)) return 1;
        if (e) return e.length;
      }

      return 0;
    }, n.listenerCount = function (t, e) {
      return t.listenerCount(e);
    };
  }, function (t, e) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function i(t) {
      if (l === setTimeout) return setTimeout(t, 0);
      if ((l === n || !l) && setTimeout) return l = setTimeout, setTimeout(t, 0);

      try {
        return l(t, 0);
      } catch (e) {
        try {
          return l.call(null, t, 0);
        } catch (e) {
          return l.call(this, t, 0);
        }
      }
    }

    function o(t) {
      if (h === clearTimeout) return clearTimeout(t);
      if ((h === r || !h) && clearTimeout) return h = clearTimeout, clearTimeout(t);

      try {
        return h(t);
      } catch (e) {
        try {
          return h.call(null, t);
        } catch (e) {
          return h.call(this, t);
        }
      }
    }

    function s() {
      y && p && (y = !1, p.length ? d = p.concat(d) : g = -1, d.length && a());
    }

    function a() {
      if (!y) {
        var t = i(s);
        y = !0;

        for (var e = d.length; e;) {
          for (p = d, d = []; ++g < e;) {
            p && p[g].run();
          }

          g = -1, e = d.length;
        }

        p = null, y = !1, o(t);
      }
    }

    function u(t, e) {
      this.fun = t, this.array = e;
    }

    function c() {}

    var l,
        h,
        f = t.exports = {};
    !function () {
      try {
        l = "function" == typeof setTimeout ? setTimeout : n;
      } catch (t) {
        l = n;
      }

      try {
        h = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (t) {
        h = r;
      }
    }();
    var p,
        d = [],
        y = !1,
        g = -1;
    f.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      d.push(new u(t, e)), 1 !== d.length || y || i(a);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = c, f.addListener = c, f.once = c, f.off = c, f.removeListener = c, f.removeAllListeners = c, f.emit = c, f.prependListener = c, f.prependOnceListener = c, f.listeners = function (t) {
      return [];
    }, f.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, f.cwd = function () {
      return "/";
    }, f.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, f.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      function n(t, n, r, i) {
        if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
        var o,
            s,
            a = arguments.length;

        switch (a) {
          case 0:
          case 1:
            return e.nextTick(t);

          case 2:
            return e.nextTick(function () {
              t.call(null, n);
            });

          case 3:
            return e.nextTick(function () {
              t.call(null, n, r);
            });

          case 4:
            return e.nextTick(function () {
              t.call(null, n, r, i);
            });

          default:
            for (o = new Array(a - 1), s = 0; s < o.length;) {
              o[s++] = arguments[s];
            }

            return e.nextTick(function () {
              t.apply(null, o);
            });
        }
      }

      !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: n
      } : t.exports = e;
    }).call(e, n(20));
  }, function (t, e, n) {
    function r(t, e) {
      for (var n in t) {
        e[n] = t[n];
      }
    }

    function i(t, e, n) {
      return s(t, e, n);
    }

    var o = n(25),
        s = o.Buffer;
    s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? t.exports = o : (r(o, e), e.Buffer = i), r(s, i), i.from = function (t, e, n) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return s(t, e, n);
    }, i.alloc = function (t, e, n) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var r = s(t);
      return void 0 !== e ? "string" == typeof n ? r.fill(e, n) : r.fill(e) : r.fill(0), r;
    }, i.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return s(t);
    }, i.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return o.SlowBuffer(t);
    };
  }, function (t, e) {
    (function () {
      e.defaults = {
        .1: {
          explicitCharkey: !1,
          trim: !0,
          normalize: !0,
          normalizeTags: !1,
          attrkey: "@",
          charkey: "#",
          explicitArray: !1,
          ignoreAttrs: !1,
          mergeAttrs: !1,
          explicitRoot: !1,
          validator: null,
          xmlns: !1,
          explicitChildren: !1,
          childkey: "@@",
          charsAsChildren: !1,
          includeWhiteChars: !1,
          async: !1,
          strict: !0,
          attrNameProcessors: null,
          attrValueProcessors: null,
          tagNameProcessors: null,
          valueProcessors: null,
          emptyTag: ""
        },
        .2: {
          explicitCharkey: !1,
          trim: !1,
          normalize: !1,
          normalizeTags: !1,
          attrkey: "$",
          charkey: "_",
          explicitArray: !0,
          ignoreAttrs: !1,
          mergeAttrs: !1,
          explicitRoot: !0,
          validator: null,
          xmlns: !1,
          explicitChildren: !1,
          preserveChildrenOrder: !1,
          childkey: "$$",
          charsAsChildren: !1,
          includeWhiteChars: !1,
          async: !1,
          strict: !0,
          attrNameProcessors: null,
          attrValueProcessors: null,
          tagNameProcessors: null,
          valueProcessors: null,
          rootName: "root",
          xmldec: {
            version: "1.0",
            encoding: "UTF-8",
            standalone: !0
          },
          doctype: null,
          renderOpts: {
            pretty: !0,
            indent: "  ",
            newline: "\n"
          },
          headless: !1,
          chunkSize: 1e4,
          emptyTag: "",
          cdata: !1
        }
      };
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          h,
          f,
          p,
          d,
          y = function y(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          g.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          g = {}.hasOwnProperty;

      u = n(10), c = n(11), e = n(8), r = n(9), l = n(7), f = n(16), p = n(17), h = n(18), i = n(12), o = n(14), s = n(13), a = n(15), d = n(34), t.exports = function (t) {
        function n(t) {
          n.__super__.constructor.call(this, t);
        }

        return y(n, t), n.prototype.document = function (t) {
          var e, n, i, o, s;

          for (this.textispresent = !1, o = "", s = t.children, n = 0, i = s.length; n < i; n++) {
            e = s[n], o += function () {
              switch (!1) {
                case !(e instanceof u):
                  return this.declaration(e);

                case !(e instanceof c):
                  return this.docType(e);

                case !(e instanceof r):
                  return this.comment(e);

                case !(e instanceof h):
                  return this.processingInstruction(e);

                default:
                  return this.element(e, 0);
              }
            }.call(this);
          }

          return this.pretty && o.slice(-this.newline.length) === this.newline && (o = o.slice(0, -this.newline.length)), o;
        }, n.prototype.attribute = function (t) {
          return " " + t.name + '="' + t.value + '"';
        }, n.prototype.cdata = function (t, e) {
          return this.space(e) + "<![CDATA[" + t.text + "]]>" + this.newline;
        }, n.prototype.comment = function (t, e) {
          return this.space(e) + "\x3c!-- " + t.text + " --\x3e" + this.newline;
        }, n.prototype.declaration = function (t, e) {
          var n;
          return n = this.space(e), n += '<?xml version="' + t.version + '"', null != t.encoding && (n += ' encoding="' + t.encoding + '"'), null != t.standalone && (n += ' standalone="' + t.standalone + '"'), n += this.spacebeforeslash + "?>", n += this.newline;
        }, n.prototype.docType = function (t, n) {
          var u, c, l, f, p;

          if (n || (n = 0), f = this.space(n), f += "<!DOCTYPE " + t.root().name, t.pubID && t.sysID ? f += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.sysID && (f += ' SYSTEM "' + t.sysID + '"'), t.children.length > 0) {
            for (f += " [", f += this.newline, p = t.children, c = 0, l = p.length; c < l; c++) {
              u = p[c], f += function () {
                switch (!1) {
                  case !(u instanceof i):
                    return this.dtdAttList(u, n + 1);

                  case !(u instanceof o):
                    return this.dtdElement(u, n + 1);

                  case !(u instanceof s):
                    return this.dtdEntity(u, n + 1);

                  case !(u instanceof a):
                    return this.dtdNotation(u, n + 1);

                  case !(u instanceof e):
                    return this.cdata(u, n + 1);

                  case !(u instanceof r):
                    return this.comment(u, n + 1);

                  case !(u instanceof h):
                    return this.processingInstruction(u, n + 1);

                  default:
                    throw new Error("Unknown DTD node type: " + u.constructor.name);
                }
              }.call(this);
            }

            f += "]";
          }

          return f += this.spacebeforeslash + ">", f += this.newline;
        }, n.prototype.element = function (t, n) {
          var i, o, s, a, u, c, d, y, m, v, w, b, _;

          n || (n = 0), _ = !1, this.textispresent ? (this.newline = "", this.pretty = !1) : (this.newline = this.newlinedefault, this.pretty = this.prettydefault), b = this.space(n), y = "", y += b + "<" + t.name, m = t.attributes;

          for (d in m) {
            g.call(m, d) && (i = m[d], y += this.attribute(i));
          }

          if (0 === t.children.length || t.children.every(function (t) {
            return "" === t.value;
          })) this.allowEmpty ? y += "></" + t.name + ">" + this.newline : y += this.spacebeforeslash + "/>" + this.newline;else if (this.pretty && 1 === t.children.length && null != t.children[0].value) y += ">", y += t.children[0].value, y += "</" + t.name + ">" + this.newline;else {
            if (this.dontprettytextnodes) for (v = t.children, s = 0, u = v.length; s < u; s++) {
              if (o = v[s], null != o.value) {
                this.textispresent++, _ = !0;
                break;
              }
            }

            for (this.textispresent && (this.newline = "", this.pretty = !1, b = this.space(n)), y += ">" + this.newline, w = t.children, a = 0, c = w.length; a < c; a++) {
              o = w[a], y += function () {
                switch (!1) {
                  case !(o instanceof e):
                    return this.cdata(o, n + 1);

                  case !(o instanceof r):
                    return this.comment(o, n + 1);

                  case !(o instanceof l):
                    return this.element(o, n + 1);

                  case !(o instanceof f):
                    return this.raw(o, n + 1);

                  case !(o instanceof p):
                    return this.text(o, n + 1);

                  case !(o instanceof h):
                    return this.processingInstruction(o, n + 1);

                  default:
                    throw new Error("Unknown XML node type: " + o.constructor.name);
                }
              }.call(this);
            }

            _ && this.textispresent--, this.textispresent || (this.newline = this.newlinedefault, this.pretty = this.prettydefault), y += b + "</" + t.name + ">" + this.newline;
          }
          return y;
        }, n.prototype.processingInstruction = function (t, e) {
          var n;
          return n = this.space(e) + "<?" + t.target, t.value && (n += " " + t.value), n += this.spacebeforeslash + "?>" + this.newline;
        }, n.prototype.raw = function (t, e) {
          return this.space(e) + t.value + this.newline;
        }, n.prototype.text = function (t, e) {
          return this.space(e) + t.value + this.newline;
        }, n.prototype.dtdAttList = function (t, e) {
          var n;
          return n = this.space(e) + "<!ATTLIST " + t.elementName + " " + t.attributeName + " " + t.attributeType, "#DEFAULT" !== t.defaultValueType && (n += " " + t.defaultValueType), t.defaultValue && (n += ' "' + t.defaultValue + '"'), n += this.spacebeforeslash + ">" + this.newline;
        }, n.prototype.dtdElement = function (t, e) {
          return this.space(e) + "<!ELEMENT " + t.name + " " + t.value + this.spacebeforeslash + ">" + this.newline;
        }, n.prototype.dtdEntity = function (t, e) {
          var n;
          return n = this.space(e) + "<!ENTITY", t.pe && (n += " %"), n += " " + t.name, t.value ? n += ' "' + t.value + '"' : (t.pubID && t.sysID ? n += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.sysID && (n += ' SYSTEM "' + t.sysID + '"'), t.nData && (n += " NDATA " + t.nData)), n += this.spacebeforeslash + ">" + this.newline;
        }, n.prototype.dtdNotation = function (t, e) {
          var n;
          return n = this.space(e) + "<!NOTATION " + t.name, t.pubID && t.sysID ? n += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.pubID ? n += ' PUBLIC "' + t.pubID + '"' : t.sysID && (n += ' SYSTEM "' + t.sysID + '"'), n += this.spacebeforeslash + ">" + this.newline;
        }, n.prototype.openNode = function (t, e) {
          var n, r, i, o;

          if (e || (e = 0), t instanceof l) {
            i = this.space(e) + "<" + t.name, o = t.attributes;

            for (r in o) {
              g.call(o, r) && (n = o[r], i += this.attribute(n));
            }

            return i += (t.children ? ">" : "/>") + this.newline;
          }

          return i = this.space(e) + "<!DOCTYPE " + t.rootNodeName, t.pubID && t.sysID ? i += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.sysID && (i += ' SYSTEM "' + t.sysID + '"'), i += (t.children ? " [" : ">") + this.newline;
        }, n.prototype.closeNode = function (t, e) {
          switch (e || (e = 0), !1) {
            case !(t instanceof l):
              return this.space(e) + "</" + t.name + ">" + this.newline;

            case !(t instanceof c):
              return this.space(e) + "]>" + this.newline;
          }
        }, n;
      }(d);
    }).call(this);
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      function r() {
        return o.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function i(t, e) {
        if (r() < e) throw new RangeError("Invalid typed array length");
        return o.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e), t.__proto__ = o.prototype) : (null === t && (t = new o(e)), t.length = e), t;
      }

      function o(t, e, n) {
        if (!(o.TYPED_ARRAY_SUPPORT || this instanceof o)) return new o(t, e, n);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return c(this, t);
        }

        return s(this, t, e, n);
      }

      function s(t, e, n, r) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? f(t, e, n, r) : "string" == typeof e ? l(t, e, n) : p(t, e);
      }

      function a(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function u(t, e, n, r) {
        return a(e), e <= 0 ? i(t, e) : void 0 !== n ? "string" == typeof r ? i(t, e).fill(n, r) : i(t, e).fill(n) : i(t, e);
      }

      function c(t, e) {
        if (a(e), t = i(t, e < 0 ? 0 : 0 | d(e)), !o.TYPED_ARRAY_SUPPORT) for (var n = 0; n < e; ++n) {
          t[n] = 0;
        }
        return t;
      }

      function l(t, e, n) {
        if ("string" == typeof n && "" !== n || (n = "utf8"), !o.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
        var r = 0 | g(e, n);
        t = i(t, r);
        var s = t.write(e, n);
        return s !== r && (t = t.slice(0, s)), t;
      }

      function h(t, e) {
        var n = e.length < 0 ? 0 : 0 | d(e.length);
        t = i(t, n);

        for (var r = 0; r < n; r += 1) {
          t[r] = 255 & e[r];
        }

        return t;
      }

      function f(t, e, n, r) {
        if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError("'offset' is out of bounds");
        if (e.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
        return e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r), o.TYPED_ARRAY_SUPPORT ? (t = e, t.__proto__ = o.prototype) : t = h(t, e), t;
      }

      function p(t, e) {
        if (o.isBuffer(e)) {
          var n = 0 | d(e.length);
          return t = i(t, n), 0 === t.length ? t : (e.copy(t, 0, 0, n), t);
        }

        if (e) {
          if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || H(e.length) ? i(t, 0) : h(t, e);
          if ("Buffer" === e.type && Q(e.data)) return h(t, e.data);
        }

        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }

      function d(t) {
        if (t >= r()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + r().toString(16) + " bytes");
        return 0 | t;
      }

      function y(t) {
        return +t != t && (t = 0), o.alloc(+t);
      }

      function g(t, e) {
        if (o.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var n = t.length;
        if (0 === n) return 0;

        for (var r = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;

            case "utf8":
            case "utf-8":
            case void 0:
              return X(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;

            case "hex":
              return n >>> 1;

            case "base64":
              return z(t).length;

            default:
              if (r) return X(t).length;
              e = ("" + e).toLowerCase(), r = !0;
          }
        }
      }

      function m(t, e, n) {
        var r = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if (n >>>= 0, e >>>= 0, n <= e) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return P(this, e, n);

            case "utf8":
            case "utf-8":
              return S(this, e, n);

            case "ascii":
              return N(this, e, n);

            case "latin1":
            case "binary":
              return I(this, e, n);

            case "base64":
              return C(this, e, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return B(this, e, n);

            default:
              if (r) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), r = !0;
          }
        }
      }

      function v(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r;
      }

      function w(t, e, n, r, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
          if (i) return -1;
          n = t.length - 1;
        } else if (n < 0) {
          if (!i) return -1;
          n = 0;
        }

        if ("string" == typeof e && (e = o.from(e, r)), o.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, n, r, i);
        if ("number" == typeof e) return e &= 255, o.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : b(t, [e], n, r, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function b(t, e, n, r, i) {
        function o(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }

        var s = 1,
            a = t.length,
            u = e.length;

        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (t.length < 2 || e.length < 2) return -1;
          s = 2, a /= 2, u /= 2, n /= 2;
        }

        var c;

        if (i) {
          var l = -1;

          for (c = n; c < a; c++) {
            if (o(t, c) === o(e, -1 === l ? 0 : c - l)) {
              if (-1 === l && (l = c), c - l + 1 === u) return l * s;
            } else -1 !== l && (c -= c - l), l = -1;
          }
        } else for (n + u > a && (n = a - u), c = n; c >= 0; c--) {
          for (var h = !0, f = 0; f < u; f++) {
            if (o(t, c + f) !== o(e, f)) {
              h = !1;
              break;
            }
          }

          if (h) return c;
        }

        return -1;
      }

      function _(t, e, n, r) {
        n = Number(n) || 0;
        var i = t.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        r > o / 2 && (r = o / 2);

        for (var s = 0; s < r; ++s) {
          var a = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(a)) return s;
          t[n + s] = a;
        }

        return s;
      }

      function E(t, e, n, r) {
        return W(X(e, t.length - n), t, n, r);
      }

      function T(t, e, n, r) {
        return W(G(e), t, n, r);
      }

      function A(t, e, n, r) {
        return T(t, e, n, r);
      }

      function x(t, e, n, r) {
        return W(z(e), t, n, r);
      }

      function D(t, e, n, r) {
        return W(J(e, t.length - n), t, n, r);
      }

      function C(t, e, n) {
        return 0 === e && n === t.length ? $.fromByteArray(t) : $.fromByteArray(t.slice(e, n));
      }

      function S(t, e, n) {
        n = Math.min(t.length, n);

        for (var r = [], i = e; i < n;) {
          var o = t[i],
              s = null,
              a = o > 239 ? 4 : o > 223 ? 3 : o > 191 ? 2 : 1;

          if (i + a <= n) {
            var u, c, l, h;

            switch (a) {
              case 1:
                o < 128 && (s = o);
                break;

              case 2:
                u = t[i + 1], 128 == (192 & u) && (h = (31 & o) << 6 | 63 & u) > 127 && (s = h);
                break;

              case 3:
                u = t[i + 1], c = t[i + 2], 128 == (192 & u) && 128 == (192 & c) && (h = (15 & o) << 12 | (63 & u) << 6 | 63 & c) > 2047 && (h < 55296 || h > 57343) && (s = h);
                break;

              case 4:
                u = t[i + 1], c = t[i + 2], l = t[i + 3], 128 == (192 & u) && 128 == (192 & c) && 128 == (192 & l) && (h = (15 & o) << 18 | (63 & u) << 12 | (63 & c) << 6 | 63 & l) > 65535 && h < 1114112 && (s = h);
            }
          }

          null === s ? (s = 65533, a = 1) : s > 65535 && (s -= 65536, r.push(s >>> 10 & 1023 | 55296), s = 56320 | 1023 & s), r.push(s), i += a;
        }

        return O(r);
      }

      function O(t) {
        var e = t.length;
        if (e <= Z) return String.fromCharCode.apply(String, t);

        for (var n = "", r = 0; r < e;) {
          n += String.fromCharCode.apply(String, t.slice(r, r += Z));
        }

        return n;
      }

      function N(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);

        for (var i = e; i < n; ++i) {
          r += String.fromCharCode(127 & t[i]);
        }

        return r;
      }

      function I(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);

        for (var i = e; i < n; ++i) {
          r += String.fromCharCode(t[i]);
        }

        return r;
      }

      function P(t, e, n) {
        var r = t.length;
        (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);

        for (var i = "", o = e; o < n; ++o) {
          i += V(t[o]);
        }

        return i;
      }

      function B(t, e, n) {
        for (var r = t.slice(e, n), i = "", o = 0; o < r.length; o += 2) {
          i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        }

        return i;
      }

      function R(t, e, n) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > n) throw new RangeError("Trying to access beyond buffer length");
      }

      function k(t, e, n, r, i, s) {
        if (!o.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < s) throw new RangeError('"value" argument is out of bounds');
        if (n + r > t.length) throw new RangeError("Index out of range");
      }

      function F(t, e, n, r) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - n, 2); i < o; ++i) {
          t[n + i] = (e & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
      }

      function L(t, e, n, r) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - n, 4); i < o; ++i) {
          t[n + i] = e >>> 8 * (r ? i : 3 - i) & 255;
        }
      }

      function j(t, e, n, r, i, o) {
        if (n + r > t.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }

      function U(t, e, n, r, i) {
        return i || j(t, e, n, 4, 3.4028234663852886e38, -3.4028234663852886e38), K.write(t, e, n, r, 23, 4), n + 4;
      }

      function M(t, e, n, r, i) {
        return i || j(t, e, n, 8, 1.7976931348623157e308, -1.7976931348623157e308), K.write(t, e, n, r, 52, 8), n + 8;
      }

      function q(t) {
        if (t = Y(t).replace(tt, ""), t.length < 2) return "";

        for (; t.length % 4 != 0;) {
          t += "=";
        }

        return t;
      }

      function Y(t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
      }

      function V(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function X(t, e) {
        e = e || 1 / 0;

        for (var n, r = t.length, i = null, o = [], s = 0; s < r; ++s) {
          if ((n = t.charCodeAt(s)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (s + 1 === r) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = n;
              continue;
            }

            if (n < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = n;
              continue;
            }

            n = 65536 + (i - 55296 << 10 | n - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, n < 128) {
            if ((e -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((e -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((e -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }

        return o;
      }

      function G(t) {
        for (var e = [], n = 0; n < t.length; ++n) {
          e.push(255 & t.charCodeAt(n));
        }

        return e;
      }

      function J(t, e) {
        for (var n, r, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
          n = t.charCodeAt(s), r = n >> 8, i = n % 256, o.push(i), o.push(r);
        }

        return o;
      }

      function z(t) {
        return $.toByteArray(q(t));
      }

      function W(t, e, n, r) {
        for (var i = 0; i < r && !(i + n >= e.length || i >= t.length); ++i) {
          e[i + n] = t[i];
        }

        return i;
      }

      function H(t) {
        return t !== t;
      }

      var $ = n(73),
          K = n(74),
          Q = n(35);
      e.Buffer = o, e.SlowBuffer = y, e.INSPECT_MAX_BYTES = 50, o.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = r(), o.poolSize = 8192, o._augment = function (t) {
        return t.__proto__ = o.prototype, t;
      }, o.from = function (t, e, n) {
        return s(null, t, e, n);
      }, o.TYPED_ARRAY_SUPPORT && (o.prototype.__proto__ = Uint8Array.prototype, o.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && o[Symbol.species] === o && Object.defineProperty(o, Symbol.species, {
        value: null,
        configurable: !0
      })), o.alloc = function (t, e, n) {
        return u(null, t, e, n);
      }, o.allocUnsafe = function (t) {
        return c(null, t);
      }, o.allocUnsafeSlow = function (t) {
        return c(null, t);
      }, o.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, o.compare = function (t, e) {
        if (!o.isBuffer(t) || !o.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var n = t.length, r = e.length, i = 0, s = Math.min(n, r); i < s; ++i) {
          if (t[i] !== e[i]) {
            n = t[i], r = e[i];
            break;
          }
        }

        return n < r ? -1 : r < n ? 1 : 0;
      }, o.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, o.concat = function (t, e) {
        if (!Q(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return o.alloc(0);
        var n;
        if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) {
          e += t[n].length;
        }
        var r = o.allocUnsafe(e),
            i = 0;

        for (n = 0; n < t.length; ++n) {
          var s = t[n];
          if (!o.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
          s.copy(r, i), i += s.length;
        }

        return r;
      }, o.byteLength = g, o.prototype._isBuffer = !0, o.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          v(this, e, e + 1);
        }

        return this;
      }, o.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          v(this, e, e + 3), v(this, e + 1, e + 2);
        }

        return this;
      }, o.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          v(this, e, e + 7), v(this, e + 1, e + 6), v(this, e + 2, e + 5), v(this, e + 3, e + 4);
        }

        return this;
      }, o.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? S(this, 0, t) : m.apply(this, arguments);
      }, o.prototype.equals = function (t) {
        if (!o.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === o.compare(this, t);
      }, o.prototype.inspect = function () {
        var t = "",
            n = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">";
      }, o.prototype.compare = function (t, e, n, r, i) {
        if (!o.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), e < 0 || n > t.length || r < 0 || i > this.length) throw new RangeError("out of range index");
        if (r >= i && e >= n) return 0;
        if (r >= i) return -1;
        if (e >= n) return 1;
        if (e >>>= 0, n >>>= 0, r >>>= 0, i >>>= 0, this === t) return 0;

        for (var s = i - r, a = n - e, u = Math.min(s, a), c = this.slice(r, i), l = t.slice(e, n), h = 0; h < u; ++h) {
          if (c[h] !== l[h]) {
            s = c[h], a = l[h];
            break;
          }
        }

        return s < a ? -1 : a < s ? 1 : 0;
      }, o.prototype.includes = function (t, e, n) {
        return -1 !== this.indexOf(t, e, n);
      }, o.prototype.indexOf = function (t, e, n) {
        return w(this, t, e, n, !0);
      }, o.prototype.lastIndexOf = function (t, e, n) {
        return w(this, t, e, n, !1);
      }, o.prototype.write = function (t, e, n, r) {
        if (void 0 === e) r = "utf8", n = this.length, e = 0;else if (void 0 === n && "string" == typeof e) r = e, n = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }
        var i = this.length - e;
        if ((void 0 === n || n > i) && (n = i), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");

        for (var o = !1;;) {
          switch (r) {
            case "hex":
              return _(this, t, e, n);

            case "utf8":
            case "utf-8":
              return E(this, t, e, n);

            case "ascii":
              return T(this, t, e, n);

            case "latin1":
            case "binary":
              return A(this, t, e, n);

            case "base64":
              return x(this, t, e, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return D(this, t, e, n);

            default:
              if (o) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), o = !0;
          }
        }
      }, o.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var Z = 4096;
      o.prototype.slice = function (t, e) {
        var n = this.length;
        t = ~~t, e = void 0 === e ? n : ~~e, t < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), e < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t);
        var r;
        if (o.TYPED_ARRAY_SUPPORT) r = this.subarray(t, e), r.__proto__ = o.prototype;else {
          var i = e - t;
          r = new o(i, void 0);

          for (var s = 0; s < i; ++s) {
            r[s] = this[s + t];
          }
        }
        return r;
      }, o.prototype.readUIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || R(t, e, this.length);

        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          r += this[t + o] * i;
        }

        return r;
      }, o.prototype.readUIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || R(t, e, this.length);

        for (var r = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          r += this[t + --e] * i;
        }

        return r;
      }, o.prototype.readUInt8 = function (t, e) {
        return e || R(t, 1, this.length), this[t];
      }, o.prototype.readUInt16LE = function (t, e) {
        return e || R(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, o.prototype.readUInt16BE = function (t, e) {
        return e || R(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, o.prototype.readUInt32LE = function (t, e) {
        return e || R(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, o.prototype.readUInt32BE = function (t, e) {
        return e || R(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, o.prototype.readIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || R(t, e, this.length);

        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          r += this[t + o] * i;
        }

        return i *= 128, r >= i && (r -= Math.pow(2, 8 * e)), r;
      }, o.prototype.readIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || R(t, e, this.length);

        for (var r = e, i = 1, o = this[t + --r]; r > 0 && (i *= 256);) {
          o += this[t + --r] * i;
        }

        return i *= 128, o >= i && (o -= Math.pow(2, 8 * e)), o;
      }, o.prototype.readInt8 = function (t, e) {
        return e || R(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, o.prototype.readInt16LE = function (t, e) {
        e || R(t, 2, this.length);
        var n = this[t] | this[t + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, o.prototype.readInt16BE = function (t, e) {
        e || R(t, 2, this.length);
        var n = this[t + 1] | this[t] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, o.prototype.readInt32LE = function (t, e) {
        return e || R(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, o.prototype.readInt32BE = function (t, e) {
        return e || R(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, o.prototype.readFloatLE = function (t, e) {
        return e || R(t, 4, this.length), K.read(this, t, !0, 23, 4);
      }, o.prototype.readFloatBE = function (t, e) {
        return e || R(t, 4, this.length), K.read(this, t, !1, 23, 4);
      }, o.prototype.readDoubleLE = function (t, e) {
        return e || R(t, 8, this.length), K.read(this, t, !0, 52, 8);
      }, o.prototype.readDoubleBE = function (t, e) {
        return e || R(t, 8, this.length), K.read(this, t, !1, 52, 8);
      }, o.prototype.writeUIntLE = function (t, e, n, r) {
        if (t = +t, e |= 0, n |= 0, !r) {
          k(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        }

        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < n && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + n;
      }, o.prototype.writeUIntBE = function (t, e, n, r) {
        if (t = +t, e |= 0, n |= 0, !r) {
          k(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        }

        var i = n - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + n;
      }, o.prototype.writeUInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 1, 255, 0), o.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, o.prototype.writeUInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 2, 65535, 0), o.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : F(this, t, e, !0), e + 2;
      }, o.prototype.writeUInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 2, 65535, 0), o.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : F(this, t, e, !1), e + 2;
      }, o.prototype.writeUInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 4, 4294967295, 0), o.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
      }, o.prototype.writeUInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 4, 4294967295, 0), o.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, o.prototype.writeIntLE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          k(this, t, e, n, i - 1, -i);
        }

        var o = 0,
            s = 1,
            a = 0;

        for (this[e] = 255 & t; ++o < n && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + n;
      }, o.prototype.writeIntBE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          k(this, t, e, n, i - 1, -i);
        }

        var o = n - 1,
            s = 1,
            a = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + n;
      }, o.prototype.writeInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 1, 127, -128), o.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, o.prototype.writeInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 2, 32767, -32768), o.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : F(this, t, e, !0), e + 2;
      }, o.prototype.writeInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 2, 32767, -32768), o.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : F(this, t, e, !1), e + 2;
      }, o.prototype.writeInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 4, 2147483647, -2147483648), o.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
      }, o.prototype.writeInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || k(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), o.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, o.prototype.writeFloatLE = function (t, e, n) {
        return U(this, t, e, !0, n);
      }, o.prototype.writeFloatBE = function (t, e, n) {
        return U(this, t, e, !1, n);
      }, o.prototype.writeDoubleLE = function (t, e, n) {
        return M(this, t, e, !0, n);
      }, o.prototype.writeDoubleBE = function (t, e, n) {
        return M(this, t, e, !1, n);
      }, o.prototype.copy = function (t, e, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
        var i,
            s = r - n;
        if (this === t && n < e && e < r) for (i = s - 1; i >= 0; --i) {
          t[i + e] = this[i + n];
        } else if (s < 1e3 || !o.TYPED_ARRAY_SUPPORT) for (i = 0; i < s; ++i) {
          t[i + e] = this[i + n];
        } else Uint8Array.prototype.set.call(t, this.subarray(n, n + s), e);
        return s;
      }, o.prototype.fill = function (t, e, n, r) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (r = e, e = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !o.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < n) throw new RangeError("Out of range index");
        if (n <= e) return this;
        e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0);
        var s;
        if ("number" == typeof t) for (s = e; s < n; ++s) {
          this[s] = t;
        } else {
          var a = o.isBuffer(t) ? t : X(new o(t, r).toString()),
              u = a.length;

          for (s = 0; s < n - e; ++s) {
            this[s + e] = a[s % u];
          }
        }
        return this;
      };
      var tt = /[^+\/0-9A-Za-z-_]/g;
    }).call(e, n(1));
  }, function (t, e, n) {
    e = t.exports = n(36), e.Stream = e, e.Readable = e, e.Writable = n(27), e.Duplex = n(3), e.Transform = n(40), e.PassThrough = n(81);
  }, function (t, e, n) {
    "use strict";

    (function (e, r, i) {
      function o(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          C(e, t);
        };
      }

      function s(t) {
        return R.from(t);
      }

      function a(t) {
        return R.isBuffer(t) || t instanceof k;
      }

      function u() {}

      function c(t, e) {
        O = O || n(3), t = t || {};
        var r = e instanceof O;
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            s = t.writableHighWaterMark,
            a = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : r && (s || 0 === s) ? s : a, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var u = !1 === t.decodeStrings;
        this.decodeStrings = !u, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          v(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
      }

      function l(t) {
        if (O = O || n(3), !(L.call(l, this) || this instanceof O)) return new l(t);
        this._writableState = new c(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), B.call(this);
      }

      function h(t, e) {
        var n = new Error("write after end");
        t.emit("error", n), S(e, n);
      }

      function f(t, e, n, r) {
        var i = !0,
            o = !1;
        return null === n ? o = new TypeError("May not write null values to stream") : "string" == typeof n || void 0 === n || e.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (t.emit("error", o), S(r, o), i = !1), i;
      }

      function p(t, e, n) {
        return t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = R.from(e, n)), e;
      }

      function d(t, e, n, r, i, o) {
        if (!n) {
          var s = p(e, r, i);
          r !== s && (n = !0, i = "buffer", r = s);
        }

        var a = e.objectMode ? 1 : r.length;
        e.length += a;
        var u = e.length < e.highWaterMark;

        if (u || (e.needDrain = !0), e.writing || e.corked) {
          var c = e.lastBufferedRequest;
          e.lastBufferedRequest = {
            chunk: r,
            encoding: i,
            isBuf: n,
            callback: o,
            next: null
          }, c ? c.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
        } else y(t, e, !1, a, r, i, o);

        return u;
      }

      function y(t, e, n, r, i, o, s) {
        e.writelen = r, e.writecb = s, e.writing = !0, e.sync = !0, n ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function g(t, e, n, r, i) {
        --e.pendingcb, n ? (S(i, r), S(x, t, e), t._writableState.errorEmitted = !0, t.emit("error", r)) : (i(r), t._writableState.errorEmitted = !0, t.emit("error", r), x(t, e));
      }

      function m(t) {
        t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
      }

      function v(t, e) {
        var n = t._writableState,
            r = n.sync,
            i = n.writecb;
        if (m(n), e) g(t, n, r, e, i);else {
          var o = E(n);
          o || n.corked || n.bufferProcessing || !n.bufferedRequest || _(t, n), r ? N(w, t, n, o, i) : w(t, n, o, i);
        }
      }

      function w(t, e, n, r) {
        n || b(t, e), e.pendingcb--, r(), x(t, e);
      }

      function b(t, e) {
        0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
      }

      function _(t, e) {
        e.bufferProcessing = !0;
        var n = e.bufferedRequest;

        if (t._writev && n && n.next) {
          var r = e.bufferedRequestCount,
              i = new Array(r),
              s = e.corkedRequestsFree;
          s.entry = n;

          for (var a = 0, u = !0; n;) {
            i[a] = n, n.isBuf || (u = !1), n = n.next, a += 1;
          }

          i.allBuffers = u, y(t, e, !0, e.length, i, "", s.finish), e.pendingcb++, e.lastBufferedRequest = null, s.next ? (e.corkedRequestsFree = s.next, s.next = null) : e.corkedRequestsFree = new o(e), e.bufferedRequestCount = 0;
        } else {
          for (; n;) {
            var c = n.chunk,
                l = n.encoding,
                h = n.callback;
            if (y(t, e, !1, e.objectMode ? 1 : c.length, c, l, h), n = n.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === n && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = n, e.bufferProcessing = !1;
      }

      function E(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function T(t, e) {
        t._final(function (n) {
          e.pendingcb--, n && t.emit("error", n), e.prefinished = !0, t.emit("prefinish"), x(t, e);
        });
      }

      function A(t, e) {
        e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, S(T, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
      }

      function x(t, e) {
        var n = E(e);
        return n && (A(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), n;
      }

      function D(t, e, n) {
        e.ending = !0, x(t, e), n && (e.finished ? S(n) : t.once("finish", n)), e.ended = !0, t.writable = !1;
      }

      function C(t, e, n) {
        var r = t.entry;

        for (t.entry = null; r;) {
          var i = r.callback;
          e.pendingcb--, i(n), r = r.next;
        }

        e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
      }

      var S = n(21).nextTick;
      t.exports = l;
      var O,
          N = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? r : S;
      l.WritableState = c;
      var I = n(6);
      I.inherits = n(5);

      var P = {
        deprecate: n(80)
      },
          B = n(37),
          R = n(22).Buffer,
          k = i.Uint8Array || function () {},
          F = n(38);

      I.inherits(l, B), c.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(c.prototype, "buffer", {
            get: P.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }();
      var L;
      "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (L = Function.prototype[Symbol.hasInstance], Object.defineProperty(l, Symbol.hasInstance, {
        value: function value(t) {
          return !!L.call(this, t) || this === l && t && t._writableState instanceof c;
        }
      })) : L = function L(t) {
        return t instanceof this;
      }, l.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, l.prototype.write = function (t, e, n) {
        var r = this._writableState,
            i = !1,
            o = !r.objectMode && a(t);
        return o && !R.isBuffer(t) && (t = s(t)), "function" == typeof e && (n = e, e = null), o ? e = "buffer" : e || (e = r.defaultEncoding), "function" != typeof n && (n = u), r.ended ? h(this, n) : (o || f(this, r, t, n)) && (r.pendingcb++, i = d(this, r, o, t, e, n)), i;
      }, l.prototype.cork = function () {
        this._writableState.corked++;
      }, l.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || _(this, t));
      }, l.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, l.prototype._write = function (t, e, n) {
        n(new Error("_write() is not implemented"));
      }, l.prototype._writev = null, l.prototype.end = function (t, e, n) {
        var r = this._writableState;
        "function" == typeof t ? (n = t, t = null, e = null) : "function" == typeof e && (n = e, e = null), null !== t && void 0 !== t && this.write(t, e), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || D(this, r, n);
      }, Object.defineProperty(l.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), l.prototype.destroy = F.destroy, l.prototype._undestroy = F.undestroy, l.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(e, n(20), n(39).setImmediate, n(1));
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if (!t) return "utf8";

      for (var e;;) {
        switch (t) {
          case "utf8":
          case "utf-8":
            return "utf8";

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return "utf16le";

          case "latin1":
          case "binary":
            return "latin1";

          case "base64":
          case "ascii":
          case "hex":
            return t;

          default:
            if (e) return;
            t = ("" + t).toLowerCase(), e = !0;
        }
      }
    }

    function i(t) {
      var e = r(t);
      if ("string" != typeof e && (v.isEncoding === w || !w(t))) throw new Error("Unknown encoding: " + t);
      return e || t;
    }

    function o(t) {
      this.encoding = i(t);
      var e;

      switch (this.encoding) {
        case "utf16le":
          this.text = f, this.end = p, e = 4;
          break;

        case "utf8":
          this.fillLast = c, e = 4;
          break;

        case "base64":
          this.text = d, this.end = y, e = 3;
          break;

        default:
          return this.write = g, void (this.end = m);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = v.allocUnsafe(e);
    }

    function s(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : -1;
    }

    function a(t, e, n) {
      var r = e.length - 1;
      if (r < n) return 0;
      var i = s(e[r]);
      return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --r < n ? 0 : (i = s(e[r])) >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --r < n ? 0 : (i = s(e[r]), i >= 0 ? (i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i) : 0);
    }

    function u(t, e, n) {
      if (128 != (192 & e[0])) return t.lastNeed = 0, "�".repeat(n);

      if (t.lastNeed > 1 && e.length > 1) {
        if (128 != (192 & e[1])) return t.lastNeed = 1, "�".repeat(n + 1);
        if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�".repeat(n + 2);
      }
    }

    function c(t) {
      var e = this.lastTotal - this.lastNeed,
          n = u(this, t, e);
      return void 0 !== n ? n : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function l(t, e) {
      var n = a(this, t, e);
      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = n;
      var r = t.length - (n - this.lastNeed);
      return t.copy(this.lastChar, 0, r), t.toString("utf8", e, r);
    }

    function h(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�".repeat(this.lastTotal - this.lastNeed) : e;
    }

    function f(t, e) {
      if ((t.length - e) % 2 == 0) {
        var n = t.toString("utf16le", e);

        if (n) {
          var r = n.charCodeAt(n.length - 1);
          if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], n.slice(0, -1);
        }

        return n;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function p(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var n = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, n);
      }

      return e;
    }

    function d(t, e) {
      var n = (t.length - e) % 3;
      return 0 === n ? t.toString("base64", e) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - n));
    }

    function y(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function g(t) {
      return t.toString(this.encoding);
    }

    function m(t) {
      return t && t.length ? this.write(t) : "";
    }

    var v = n(22).Buffer,
        w = v.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, n;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        n = this.lastNeed, this.lastNeed = 0;
      } else n = 0;

      return n < t.length ? e ? e + this.text(t, n) : this.text(t, n) : e || "";
    }, o.prototype.end = h, o.prototype.text = l, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e) {
    function n() {
      for (var t = {}, e = 0; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          r.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    }

    t.exports = n;
    var r = Object.prototype.hasOwnProperty;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t.replace(/\/*$/, "");
    }

    function i(t) {
      return JSON.parse(JSON.stringify(t));
    }

    function o(t) {
      return /^(\w+)\//.exec(t)[1];
    }

    function s(t) {
      return /\/(\d+)$/.exec(t)[1];
    }

    function a(t) {
      return /^[-]\d+$/.test(t);
    }

    function u(t) {
      if (null === t || void 0 === t) return "";
      var e = [],
          n = !0,
          r = !1,
          i = void 0;

      try {
        for (var o, s = Object.keys(t)[Symbol.iterator](); !(n = (o = s.next()).done); n = !0) {
          var a = o.value,
              u = encodeURIComponent(a),
              c = encodeURIComponent(t[a]);
          e.push(u + "=" + c);
        }
      } catch (t) {
        r = !0, i = t;
      } finally {
        try {
          !n && s.return && s.return();
        } finally {
          if (r) throw i;
        }
      }

      return (e.length > 0 ? "?" : "") + e.join("&");
    }

    function c(t, e, n) {
      return r(t) + "/api/0.6" + e + u(n);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.removeTrailingSlashes = r, e.simpleObjectDeepClone = i, e.findElementType = o, e.findElementId = s, e.checkIdIsNegative = a, e.buildQueryString = u, e.buildApiUrl = c;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function i(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }

    function o(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    e.RequestException = function (t) {
      function e(t) {
        r(this, e);
        var n = i(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
        return Error.captureStackTrace && Error.captureStackTrace(n, e), n.name = "RequestException", n;
      }

      return o(e, t), e;
    }(Error);
  }, function (t, e) {
    (function () {
      t.exports = function () {
        function t(t, e, n) {
          if (this.options = t.options, this.stringify = t.stringify, null == e) throw new Error("Missing attribute name of element " + t.name);
          if (null == n) throw new Error("Missing attribute value for attribute " + e + " of element " + t.name);
          this.name = this.stringify.attName(e), this.value = this.stringify.attValue(n);
        }

        return t.prototype.clone = function () {
          return Object.create(this);
        }, t.prototype.toString = function (t) {
          return this.options.writer.set(t).attribute(this);
        }, t;
      }();
    }).call(this);
  }, function (t, e) {
    (function () {
      var e = function e(t, _e) {
        return function () {
          return t.apply(_e, arguments);
        };
      },
          n = {}.hasOwnProperty;

      t.exports = function () {
        function t(t) {
          this.assertLegalChar = e(this.assertLegalChar, this);
          var r, i, o;
          t || (t = {}), this.noDoubleEncoding = t.noDoubleEncoding, i = t.stringify || {};

          for (r in i) {
            n.call(i, r) && (o = i[r], this[r] = o);
          }
        }

        return t.prototype.eleName = function (t) {
          return t = "" + t || "", this.assertLegalChar(t);
        }, t.prototype.eleText = function (t) {
          return t = "" + t || "", this.assertLegalChar(this.elEscape(t));
        }, t.prototype.cdata = function (t) {
          return t = "" + t || "", t = t.replace("]]>", "]]]]><![CDATA[>"), this.assertLegalChar(t);
        }, t.prototype.comment = function (t) {
          if (t = "" + t || "", t.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + t);
          return this.assertLegalChar(t);
        }, t.prototype.raw = function (t) {
          return "" + t || "";
        }, t.prototype.attName = function (t) {
          return t = "" + t || "";
        }, t.prototype.attValue = function (t) {
          return t = "" + t || "", this.attEscape(t);
        }, t.prototype.insTarget = function (t) {
          return "" + t || "";
        }, t.prototype.insValue = function (t) {
          if (t = "" + t || "", t.match(/\?>/)) throw new Error("Invalid processing instruction value: " + t);
          return t;
        }, t.prototype.xmlVersion = function (t) {
          if (t = "" + t || "", !t.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + t);
          return t;
        }, t.prototype.xmlEncoding = function (t) {
          if (t = "" + t || "", !t.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + t);
          return t;
        }, t.prototype.xmlStandalone = function (t) {
          return t ? "yes" : "no";
        }, t.prototype.dtdPubID = function (t) {
          return "" + t || "";
        }, t.prototype.dtdSysID = function (t) {
          return "" + t || "";
        }, t.prototype.dtdElementValue = function (t) {
          return "" + t || "";
        }, t.prototype.dtdAttType = function (t) {
          return "" + t || "";
        }, t.prototype.dtdAttDefault = function (t) {
          return null != t ? "" + t || "" : t;
        }, t.prototype.dtdEntityValue = function (t) {
          return "" + t || "";
        }, t.prototype.dtdNData = function (t) {
          return "" + t || "";
        }, t.prototype.convertAttKey = "@", t.prototype.convertPIKey = "?", t.prototype.convertTextKey = "#text", t.prototype.convertCDataKey = "#cdata", t.prototype.convertCommentKey = "#comment", t.prototype.convertRawKey = "#raw", t.prototype.assertLegalChar = function (t) {
          var e;
          if (e = t.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/)) throw new Error("Invalid character in string: " + t + " at index " + e.index);
          return t;
        }, t.prototype.elEscape = function (t) {
          var e;
          return e = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g, t.replace(e, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
        }, t.prototype.attEscape = function (t) {
          var e;
          return e = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g, t.replace(e, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
        }, t;
      }();
    }).call(this);
  }, function (t, e) {
    (function () {
      var e = {}.hasOwnProperty;

      t.exports = function () {
        function t(t) {
          var n, r, i, o, s, a, u, c, l;
          t || (t = {}), this.pretty = t.pretty || !1, this.allowEmpty = null != (r = t.allowEmpty) && r, this.pretty ? (this.indent = null != (i = t.indent) ? i : "  ", this.newline = null != (o = t.newline) ? o : "\n", this.offset = null != (s = t.offset) ? s : 0, this.dontprettytextnodes = null != (a = t.dontprettytextnodes) ? a : 0) : (this.indent = "", this.newline = "", this.offset = 0, this.dontprettytextnodes = 0), this.spacebeforeslash = null != (u = t.spacebeforeslash) ? u : "", !0 === this.spacebeforeslash && (this.spacebeforeslash = " "), this.newlinedefault = this.newline, this.prettydefault = this.pretty, c = t.writer || {};

          for (n in c) {
            e.call(c, n) && (l = c[n], this[n] = l);
          }
        }

        return t.prototype.set = function (t) {
          var n, r, i;
          t || (t = {}), "pretty" in t && (this.pretty = t.pretty), "allowEmpty" in t && (this.allowEmpty = t.allowEmpty), this.pretty ? (this.indent = "indent" in t ? t.indent : "  ", this.newline = "newline" in t ? t.newline : "\n", this.offset = "offset" in t ? t.offset : 0, this.dontprettytextnodes = "dontprettytextnodes" in t ? t.dontprettytextnodes : 0) : (this.indent = "", this.newline = "", this.offset = 0, this.dontprettytextnodes = 0), this.spacebeforeslash = "spacebeforeslash" in t ? t.spacebeforeslash : "", !0 === this.spacebeforeslash && (this.spacebeforeslash = " "), this.newlinedefault = this.newline, this.prettydefault = this.pretty, r = t.writer || {};

          for (n in r) {
            e.call(r, n) && (i = r[n], this[n] = i);
          }

          return this;
        }, t.prototype.space = function (t) {
          var e;
          return this.pretty ? (e = (t || 0) + this.offset + 1, e > 0 ? new Array(e).join(this.indent) : "") : "";
        }, t;
      }();
    }).call(this);
  }, function (t, e) {
    var n = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == n.call(t);
    };
  }, function (t, e, n) {
    "use strict";

    (function (e, r) {
      function i(t) {
        return L.from(t);
      }

      function o(t) {
        return L.isBuffer(t) || t instanceof j;
      }

      function s(t, e, n) {
        if ("function" == typeof t.prependListener) return t.prependListener(e, n);
        t._events && t._events[e] ? R(t._events[e]) ? t._events[e].unshift(n) : t._events[e] = [n, t._events[e]] : t.on(e, n);
      }

      function a(t, e) {
        B = B || n(3), t = t || {};
        var r = e instanceof B;
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            o = t.readableHighWaterMark,
            s = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : r && (o || 0 === o) ? o : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new V(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (Y || (Y = n(28).StringDecoder), this.decoder = new Y(t.encoding), this.encoding = t.encoding);
      }

      function u(t) {
        if (B = B || n(3), !(this instanceof u)) return new u(t);
        this._readableState = new a(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), F.call(this);
      }

      function c(t, e, n, r, o) {
        var s = t._readableState;
        if (null === e) s.reading = !1, y(t, s);else {
          var a;
          o || (a = h(s, e)), a ? t.emit("error", a) : s.objectMode || e && e.length > 0 ? ("string" == typeof e || s.objectMode || Object.getPrototypeOf(e) === L.prototype || (e = i(e)), r ? s.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : l(t, s, e, !0) : s.ended ? t.emit("error", new Error("stream.push() after EOF")) : (s.reading = !1, s.decoder && !n ? (e = s.decoder.write(e), s.objectMode || 0 !== e.length ? l(t, s, e, !1) : v(t, s)) : l(t, s, e, !1))) : r || (s.reading = !1);
        }
        return f(s);
      }

      function l(t, e, n, r) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", n), t.read(0)) : (e.length += e.objectMode ? 1 : n.length, r ? e.buffer.unshift(n) : e.buffer.push(n), e.needReadable && g(t)), v(t, e);
      }

      function h(t, e) {
        var n;
        return o(e) || "string" == typeof e || void 0 === e || t.objectMode || (n = new TypeError("Invalid non-string/buffer chunk")), n;
      }

      function f(t) {
        return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
      }

      function p(t) {
        return t >= J ? t = J : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
      }

      function d(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t !== t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = p(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function y(t, e) {
        if (!e.ended) {
          if (e.decoder) {
            var n = e.decoder.end();
            n && n.length && (e.buffer.push(n), e.length += e.objectMode ? 1 : n.length);
          }

          e.ended = !0, g(t);
        }
      }

      function g(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (q("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? P(m, t) : m(t));
      }

      function m(t) {
        q("emit readable"), t.emit("readable"), A(t);
      }

      function v(t, e) {
        e.readingMore || (e.readingMore = !0, P(w, t, e));
      }

      function w(t, e) {
        for (var n = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (q("maybeReadMore read 0"), t.read(0), n !== e.length);) {
          n = e.length;
        }

        e.readingMore = !1;
      }

      function b(t) {
        return function () {
          var e = t._readableState;
          q("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && k(t, "data") && (e.flowing = !0, A(t));
        };
      }

      function _(t) {
        q("readable nexttick read 0"), t.read(0);
      }

      function E(t, e) {
        e.resumeScheduled || (e.resumeScheduled = !0, P(T, t, e));
      }

      function T(t, e) {
        e.reading || (q("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), A(t), e.flowing && !e.reading && t.read(0);
      }

      function A(t) {
        var e = t._readableState;

        for (q("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function x(t, e) {
        if (0 === e.length) return null;
        var n;
        return e.objectMode ? n = e.buffer.shift() : !t || t >= e.length ? (n = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : n = D(t, e.buffer, e.decoder), n;
      }

      function D(t, e, n) {
        var r;
        return t < e.head.data.length ? (r = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : r = t === e.head.data.length ? e.shift() : n ? C(t, e) : S(t, e), r;
      }

      function C(t, e) {
        var n = e.head,
            r = 1,
            i = n.data;

        for (t -= i.length; n = n.next;) {
          var o = n.data,
              s = t > o.length ? o.length : t;

          if (s === o.length ? i += o : i += o.slice(0, t), 0 === (t -= s)) {
            s === o.length ? (++r, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(s));
            break;
          }

          ++r;
        }

        return e.length -= r, i;
      }

      function S(t, e) {
        var n = L.allocUnsafe(t),
            r = e.head,
            i = 1;

        for (r.data.copy(n), t -= r.data.length; r = r.next;) {
          var o = r.data,
              s = t > o.length ? o.length : t;

          if (o.copy(n, n.length - t, 0, s), 0 === (t -= s)) {
            s === o.length ? (++i, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(s));
            break;
          }

          ++i;
        }

        return e.length -= i, n;
      }

      function O(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, P(N, e, t));
      }

      function N(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function I(t, e) {
        for (var n = 0, r = t.length; n < r; n++) {
          if (t[n] === e) return n;
        }

        return -1;
      }

      var P = n(21).nextTick;
      t.exports = u;
      var B,
          R = n(35);
      u.ReadableState = a;

      var k = (n(19).EventEmitter, function (t, e) {
        return t.listeners(e).length;
      }),
          F = n(37),
          L = n(22).Buffer,
          j = e.Uint8Array || function () {},
          U = n(6);

      U.inherits = n(5);
      var M = n(76),
          q = void 0;
      q = M && M.debuglog ? M.debuglog("stream") : function () {};
      var Y,
          V = n(77),
          X = n(38);
      U.inherits(u, F);
      var G = ["error", "close", "destroy", "pause", "resume"];
      Object.defineProperty(u.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), u.prototype.destroy = X.destroy, u.prototype._undestroy = X.undestroy, u.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, u.prototype.push = function (t, e) {
        var n,
            r = this._readableState;
        return r.objectMode ? n = !0 : "string" == typeof t && (e = e || r.defaultEncoding, e !== r.encoding && (t = L.from(t, e), e = ""), n = !0), c(this, t, e, !1, n);
      }, u.prototype.unshift = function (t) {
        return c(this, t, null, !0, !1);
      }, u.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, u.prototype.setEncoding = function (t) {
        return Y || (Y = n(28).StringDecoder), this._readableState.decoder = new Y(t), this._readableState.encoding = t, this;
      };
      var J = 8388608;
      u.prototype.read = function (t) {
        q("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            n = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return q("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? O(this) : g(this), null;
        if (0 === (t = d(t, e)) && e.ended) return 0 === e.length && O(this), null;
        var r = e.needReadable;
        q("need readable", r), (0 === e.length || e.length - t < e.highWaterMark) && (r = !0, q("length less than watermark", r)), e.ended || e.reading ? (r = !1, q("reading or ended", r)) : r && (q("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = d(n, e)));
        var i;
        return i = t > 0 ? x(t, e) : null, null === i ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), n !== t && e.ended && O(this)), null !== i && this.emit("data", i), i;
      }, u.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, u.prototype.pipe = function (t, e) {
        function n(t, e) {
          q("onunpipe"), t === f && e && !1 === e.hasUnpiped && (e.hasUnpiped = !0, o());
        }

        function i() {
          q("onend"), t.end();
        }

        function o() {
          q("cleanup"), t.removeListener("close", c), t.removeListener("finish", l), t.removeListener("drain", g), t.removeListener("error", u), t.removeListener("unpipe", n), f.removeListener("end", i), f.removeListener("end", h), f.removeListener("data", a), m = !0, !p.awaitDrain || t._writableState && !t._writableState.needDrain || g();
        }

        function a(e) {
          q("ondata"), v = !1, !1 !== t.write(e) || v || ((1 === p.pipesCount && p.pipes === t || p.pipesCount > 1 && -1 !== I(p.pipes, t)) && !m && (q("false write response, pause", f._readableState.awaitDrain), f._readableState.awaitDrain++, v = !0), f.pause());
        }

        function u(e) {
          q("onerror", e), h(), t.removeListener("error", u), 0 === k(t, "error") && t.emit("error", e);
        }

        function c() {
          t.removeListener("finish", l), h();
        }

        function l() {
          q("onfinish"), t.removeListener("close", c), h();
        }

        function h() {
          q("unpipe"), f.unpipe(t);
        }

        var f = this,
            p = this._readableState;

        switch (p.pipesCount) {
          case 0:
            p.pipes = t;
            break;

          case 1:
            p.pipes = [p.pipes, t];
            break;

          default:
            p.pipes.push(t);
        }

        p.pipesCount += 1, q("pipe count=%d opts=%j", p.pipesCount, e);
        var d = (!e || !1 !== e.end) && t !== r.stdout && t !== r.stderr,
            y = d ? i : h;
        p.endEmitted ? P(y) : f.once("end", y), t.on("unpipe", n);
        var g = b(f);
        t.on("drain", g);
        var m = !1,
            v = !1;
        return f.on("data", a), s(t, "error", u), t.once("close", c), t.once("finish", l), t.emit("pipe", f), p.flowing || (q("pipe resume"), f.resume()), t;
      }, u.prototype.unpipe = function (t) {
        var e = this._readableState,
            n = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, n), this);

        if (!t) {
          var r = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            r[o].emit("unpipe", this, n);
          }

          return this;
        }

        var s = I(e.pipes, t);
        return -1 === s ? this : (e.pipes.splice(s, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, n), this);
      }, u.prototype.on = function (t, e) {
        var n = F.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var r = this._readableState;
          r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && g(this) : P(_, this));
        }
        return n;
      }, u.prototype.addListener = u.prototype.on, u.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (q("resume"), t.flowing = !0, E(this, t)), this;
      }, u.prototype.pause = function () {
        return q("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (q("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, u.prototype.wrap = function (t) {
        var e = this,
            n = this._readableState,
            r = !1;
        t.on("end", function () {
          if (q("wrapped end"), n.decoder && !n.ended) {
            var t = n.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          if (q("wrapped data"), n.decoder && (i = n.decoder.write(i)), (!n.objectMode || null !== i && void 0 !== i) && (n.objectMode || i && i.length)) {
            e.push(i) || (r = !0, t.pause());
          }
        });

        for (var i in t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < G.length; o++) {
          t.on(G[o], this.emit.bind(this, G[o]));
        }

        return this._read = function (e) {
          q("wrapped _read", e), r && (r = !1, t.resume());
        }, this;
      }, u._fromList = x;
    }).call(e, n(1), n(20));
  }, function (t, e, n) {
    t.exports = n(19).EventEmitter;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      var n = this,
          r = this._readableState && this._readableState.destroyed,
          i = this._writableState && this._writableState.destroyed;
      return r || i ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || s(o, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
        !e && t ? (s(o, n, t), n._writableState && (n._writableState.errorEmitted = !0)) : e && e(t);
      }), this);
    }

    function i() {
      this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
    }

    function o(t, e) {
      t.emit("error", e);
    }

    var s = n(21).nextTick;
    t.exports = {
      destroy: r,
      undestroy: i
    };
  }, function (t, e, n) {
    (function (t) {
      function r(t, e) {
        this._id = t, this._clearFn = e;
      }

      var i = Function.prototype.apply;
      e.setTimeout = function () {
        return new r(i.call(setTimeout, window, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new r(i.call(setInterval, window, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, r.prototype.unref = r.prototype.ref = function () {}, r.prototype.close = function () {
        this._clearFn.call(window, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(79), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      var n = this._transformState;
      n.transforming = !1;
      var r = n.writecb;
      if (!r) return this.emit("error", new Error("write callback called multiple times"));
      n.writechunk = null, n.writecb = null, null != e && this.push(e), r(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function i(t) {
      if (!(this instanceof i)) return new i(t);
      a.call(this, t), this._transformState = {
        afterTransform: r.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", o);
    }

    function o() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, n) {
        s(t, e, n);
      }) : s(this, null, null);
    }

    function s(t, e, n) {
      if (e) return t.emit("error", e);
      if (null != n && t.push(n), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    t.exports = i;
    var a = n(3),
        u = n(6);
    u.inherits = n(5), u.inherits(i, a), i.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, a.prototype.push.call(this, t, e);
    }, i.prototype._transform = function (t, e, n) {
      throw new Error("_transform() is not implemented");
    }, i.prototype._write = function (t, e, n) {
      var r = this._transformState;

      if (r.writecb = n, r.writechunk = t, r.writeencoding = e, !r.transforming) {
        var i = this._readableState;
        (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, i.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, i.prototype._destroy = function (t, e) {
      var n = this;

      a.prototype._destroy.call(this, t, function (t) {
        e(t), n.emit("close");
      });
    };
  }, function (t, e) {
    (function () {
      "use strict";

      var t;
      t = new RegExp(/(?!xmlns)^.*:/), e.normalize = function (t) {
        return t.toLowerCase();
      }, e.firstCharLowerCase = function (t) {
        return t.charAt(0).toLowerCase() + t.slice(1);
      }, e.stripPrefix = function (e) {
        return e.replace(t, "");
      }, e.parseNumbers = function (t) {
        return isNaN(t) || (t = t % 1 == 0 ? parseInt(t, 10) : parseFloat(t)), t;
      }, e.parseBooleans = function (t) {
        return /^(?:true|false)$/i.test(t) && (t = "true" === t.toLowerCase()), t;
      };
    }).call(this);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function i(t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }

      return Array.from(t);
    }

    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var s = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        a = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        u = n(43),
        c = r(u),
        l = n(58),
        h = r(l),
        f = n(59),
        p = n(30),
        d = n(60),
        y = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        o(this, t), this._options = s({}, h.default, e), this._options.endpoint = (0, p.removeTrailingSlashes)(this._options.endpoint), this._auth = (0, c.default)({
          url: this._options.endpoint,
          oauth_consumer_key: this._options.oauthConsumerKey,
          oauth_secret: this._options.oauthSecret,
          oauth_token: this._options.oauthUserToken,
          oauth_token_secret: this._options.oauthUserTokenSecret
        });
      }

      return a(t, [{
        key: "fetchNotes",
        value: function value(t, e, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
              o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null;
          return (0, d.fetchNotesRequest)(this.endpoint, t, e, n, r, i, o, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "fetchNotesSearch",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "xml",
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
              i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
              o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
              s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
              a = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null;
          return (0, d.fetchNotesSearchRequest)(this.endpoint, t, e, n, r, i, o, s, a, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "fetchNote",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "xml";
          return (0, d.fetchNoteByIdRequest)(this.endpoint, t, e, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "createNote",
        value: function value(t, e, n) {
          return (0, d.createNoteRequest)(this._auth, this.endpoint, t, e, n);
        }
      }, {
        key: "commentNote",
        value: function value(t, e) {
          return (0, d.genericPostNoteRequest)(this._auth, this.endpoint, t, e, "comment");
        }
      }, {
        key: "closeNote",
        value: function value(t, e) {
          return (0, d.genericPostNoteRequest)(this._auth, this.endpoint, t, e, "close");
        }
      }, {
        key: "reopenNote",
        value: function value(t, e) {
          return (0, d.genericPostNoteRequest)(this._auth, this.endpoint, t, e, "reopen");
        }
      }, {
        key: "createChangeset",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return (0, d.createChangesetRequest)(this._auth, this.endpoint, t, e, n);
        }
      }, {
        key: "isChangesetStillOpen",
        value: function value(t) {
          return (0, d.changesetCheckRequest)(this._auth, this.endpoint, t);
        }
      }, {
        key: "fetchChangeset",
        value: function value(t) {
          return (0, d.changesetGetRequest)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "updateChangesetTags",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return (0, d.updateChangesetTagsRequest)(this._auth, this.endpoint, t, e, n, r);
        }
      }, {
        key: "closeChangeset",
        value: function value(t) {
          return (0, d.closeChangesetRequest)(this._auth, this.endpoint, t);
        }
      }, {
        key: "uploadChangesetOsc",
        value: function value(t, e) {
          return (0, d.uploadChangesetOscRequest)(this._auth, this.endpoint, t, e);
        }
      }, {
        key: "fetchChangesets",
        value: function value(t) {
          return (0, d.fetchChangesetsRequest)(this.endpoint, s({
            auth: this._options.always_authenticated ? this._auth : null
          }, t));
        }
      }, {
        key: "createNodeElement",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = arguments[3],
              i = {
            $: {
              lat: t,
              lon: e
            },
            tag: [],
            _type: "node"
          };
          return void 0 !== r && (i._id = r.toString()), i.tag = Object.keys(n).map(function (t) {
            return {
              $: {
                k: t.toString(),
                v: n[t].toString()
              }
            };
          }), i;
        }
      }, {
        key: "createWayElement",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments[2],
              r = {
            $: {},
            nd: t.map(function (t) {
              return {
                $: {
                  ref: (0, p.findElementId)(t)
                }
              };
            }),
            tag: [],
            _type: "way"
          };
          return void 0 !== n && (r._id = n.toString()), r.tag = Object.keys(e).map(function (t) {
            return {
              $: {
                k: t.toString(),
                v: e[t].toString()
              }
            };
          }), r;
        }
      }, {
        key: "createRelationElement",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments[2],
              r = {
            $: {},
            member: t.map(function (t) {
              var e = t.id,
                  n = t.role,
                  r = (0, p.findElementType)(e),
                  i = (0, p.findElementId)(e),
                  o = {
                type: r,
                ref: i
              };
              return void 0 !== n && (o.role = t.role), {
                $: o
              };
            }),
            tag: [],
            _type: "relation"
          };
          return void 0 !== n && (r._id = n.toString()), r.tag = Object.keys(e).map(function (t) {
            return {
              $: {
                k: t.toString(),
                v: e[t].toString()
              }
            };
          }), r;
        }
      }, {
        key: "fetchElement",
        value: function value(t, e) {
          return e && e.full ? (0, d.fetchElementRequestFull)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {}) : (0, d.fetchElementRequest)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "fetchMultipleElements",
        value: function value(t) {
          return (0, d.multiFetchElementsByTypeRequest)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "fetchRelationsForElement",
        value: function value(t) {
          return (0, d.fetchRelationsForElementRequest)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "fetchWaysForNode",
        value: function value(t) {
          return (0, d.fetchWaysForNodeRequest)(this.endpoint, t, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "findElementWithinOSMCollection",
        value: function value(t, e) {
          var n = (0, p.findElementType)(e),
              r = (0, p.findElementId)(e);
          if (n in t) return t[n].find(function (t) {
            return t.$.id === r;
          });
        }
      }, {
        key: "getTags",
        value: function value(t) {
          var e = {};
          return t && t.tag && t.tag.forEach(function (t) {
            e[t.$.k] = t.$.v;
          }), e;
        }
      }, {
        key: "setProperty",
        value: function value(t, e, n) {
          return this.setTag(t, e, n);
        }
      }, {
        key: "setTag",
        value: function value(t, e, n) {
          var r = (0, p.simpleObjectDeepClone)(t),
              o = r.tag ? r.tag.filter(function (t) {
            return t.$.k !== e.toString();
          }) : [];
          return r.tag = [].concat(i(o), [{
            $: {
              k: e.toString(),
              v: n.toString()
            }
          }]), r;
        }
      }, {
        key: "setProperties",
        value: function value(t, e) {
          return this.setTags(t, e);
        }
      }, {
        key: "setTags",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t),
              r = (0, p.simpleObjectDeepClone)(e),
              o = Object.keys(r),
              s = n.tag ? n.tag.filter(function (t) {
            return !o.includes(t.$.k);
          }) : [],
              a = o.map(function (t) {
            return {
              $: {
                k: t.toString(),
                v: r[t].toString()
              }
            };
          });
          return n.tag = [].concat(i(s), i(a)), n;
        }
      }, {
        key: "replaceTags",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t),
              r = (0, p.simpleObjectDeepClone)(e),
              i = Object.entries(r).map(function (t) {
            return {
              $: {
                k: t[0].toString(),
                v: t[1].toString()
              }
            };
          });
          return n.tag = i, n;
        }
      }, {
        key: "removeProperty",
        value: function value(t, e) {
          return this.removeTag(t, e);
        }
      }, {
        key: "removeTag",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t),
              r = n.tag.filter(function (t) {
            return t.$.k !== e;
          });
          return n.tag = r, n;
        }
      }, {
        key: "setCoordinates",
        value: function value(t, e, n) {
          var r = (0, p.simpleObjectDeepClone)(t);
          return r.$.lat = e.toString(), r.$.lon = n.toString(), r;
        }
      }, {
        key: "getNodeIdsForWay",
        value: function value(t) {
          return t.nd.map(function (t) {
            return "node/" + t.$.ref;
          });
        }
      }, {
        key: "setNodeIdsForWay",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t);
          return n.nd = e.map(function (t) {
            return {
              $: {
                ref: (0, p.findElementId)(t)
              }
            };
          }), n;
        }
      }, {
        key: "getRelationMembers",
        value: function value(t) {
          return t.member.map(function (t) {
            var e = t.$,
                n = e.type,
                r = e.ref,
                i = e.role,
                o = {
              id: n + "/" + r
            };
            return void 0 !== i && (o.role = i), o;
          });
        }
      }, {
        key: "setRelationMembers",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t);
          return n.member = e.map(function (t) {
            var e = t.id,
                n = t.role,
                r = (0, p.findElementType)(e),
                i = (0, p.findElementId)(e),
                o = {
              type: r,
              ref: i
            };
            return void 0 !== n && (o.role = t.role), {
              $: o
            };
          }), n;
        }
      }, {
        key: "setTimestampToNow",
        value: function value(t) {
          var e = (0, p.simpleObjectDeepClone)(t);
          return e.$.timestamp = (0, f.getCurrentIsoTimestamp)(), e;
        }
      }, {
        key: "setVersion",
        value: function value(t, e) {
          var n = (0, p.simpleObjectDeepClone)(t);
          return n.$.version = parseInt(e, 10).toString(), n;
        }
      }, {
        key: "sendElement",
        value: function value(t, e) {
          return (0, d.sendElementRequest)(this._auth, this.endpoint, t, e);
        }
      }, {
        key: "fetchMapByBbox",
        value: function value(t, e, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "json";
          return (0, d.fetchMapByBboxRequest)(this.endpoint, t, e, n, r, i, this._options.always_authenticated ? {
            auth: this._auth
          } : {});
        }
      }, {
        key: "deleteElement",
        value: function value(t, e) {
          return (0, d.deleteElementRequest)(this._auth, this.endpoint, t, e);
        }
      }, {
        key: "getUserPreferences",
        value: function value() {
          return (0, d.getUserPreferencesRequest)(this._auth, this.endpoint);
        }
      }, {
        key: "setUserPreferences",
        value: function value(t) {
          return (0, d.setUserPreferencesRequest)(this._auth, this.endpoint, t);
        }
      }, {
        key: "getUserPreferenceByKey",
        value: function value(t) {
          return (0, d.getUserPreferenceByKeyRequest)(this._auth, this.endpoint, t);
        }
      }, {
        key: "setUserPreferenceByKey",
        value: function value(t, e) {
          return (0, d.setUserPreferenceByKeyRequest)(this._auth, this.endpoint, t, e);
        }
      }, {
        key: "deleteUserPreference",
        value: function value(t) {
          return (0, d.deleteUserPreferenceRequest)(this._auth, this.endpoint, t);
        }
      }, {
        key: "endpoint",
        get: function get() {
          return this._options.endpoint;
        }
      }]), t;
    }();

    e.default = y;
  }, function (t, e, n) {
    "use strict";

    var r = n(44),
        i = n(46),
        o = n(47),
        s = n(29);

    t.exports = function (t) {
      function e(t) {
        return t.oauth_timestamp = r.timestamp(), t.oauth_nonce = r.nonce(), t;
      }

      function n(t) {
        return {
          oauth_consumer_key: t.oauth_consumer_key,
          oauth_signature_method: "HMAC-SHA1"
        };
      }

      var a = {};
      a.authenticated = function () {
        return !(!u("oauth_token") || !u("oauth_token_secret"));
      }, a.logout = function () {
        return u("oauth_token", ""), u("oauth_token_secret", ""), u("oauth_request_token_secret", ""), a;
      }, a.authenticate = function (o) {
        function s(e, n) {
          if (t.done(), e) return o(e);
          var s = r.stringQs(n.response);
          u("oauth_request_token_secret", s.oauth_token_secret);
          var a = t.url + "/oauth/authorize?" + r.qsString({
            oauth_token: s.oauth_token,
            oauth_callback: i(t.landing)
          });
          t.singlepage ? location.href = a : d.location = a;
        }

        function c(i) {
          var o = t.url + "/oauth/access_token",
              s = e(n(t)),
              a = u("oauth_request_token_secret");
          s.oauth_token = i, s.oauth_signature = r.signature(t.oauth_secret, a, r.baseString("POST", o, s)), r.xhr("POST", o, s, null, {}, l), t.loading();
        }

        function l(e, n) {
          if (t.done(), e) return o(e);
          var i = r.stringQs(n.response);
          u("oauth_token", i.oauth_token), u("oauth_token_secret", i.oauth_token_secret), o(null, a);
        }

        if (a.authenticated()) return o();
        a.logout();
        var h = e(n(t)),
            f = t.url + "/oauth/request_token";
        if (h.oauth_signature = r.signature(t.oauth_secret, "", r.baseString("POST", f, h)), !t.singlepage) var p = [["width", 600], ["height", 550], ["left", screen.width / 2 - 300], ["top", screen.height / 2 - 275]].map(function (t) {
          return t.join("=");
        }).join(","),
            d = window.open("about:blank", "oauth_window", p);
        r.xhr("POST", f, h, null, {}, s), t.loading(), window.authComplete = function (t) {
          c(r.stringQs(t.split("?")[1]).oauth_token), delete window.authComplete;
        };
      }, a.bootstrapToken = function (i, o) {
        function s(e, n) {
          if (t.done(), e) return o(e);
          var i = r.stringQs(n.response);
          u("oauth_token", i.oauth_token), u("oauth_token_secret", i.oauth_token_secret), o(null, a);
        }

        !function (i) {
          var o = t.url + "/oauth/access_token",
              a = e(n(t)),
              c = u("oauth_request_token_secret");
          a.oauth_token = i, a.oauth_signature = r.signature(t.oauth_secret, c, r.baseString("POST", o, a)), r.xhr("POST", o, a, null, {}, s), t.loading();
        }(i);
      }, a.xhr = function (i, o) {
        function c() {
          var o = e(n(t)),
              a = u("oauth_token_secret"),
              c = !1 !== i.prefix ? t.url + i.path : i.path,
              h = c.replace(/#.*$/, "").split("?", 2),
              f = h[0],
              p = 2 === h.length ? h[1] : "";
          return i.options && i.options.header && "application/x-www-form-urlencoded" !== i.options.header["Content-Type"] || !i.content || (o = s(o, r.stringQs(i.content))), o.oauth_token = u("oauth_token"), o.oauth_signature = r.signature(t.oauth_secret, a, r.baseString(i.method, f, s(o, r.stringQs(p)))), r.xhr(i.method, c, o, i.content, i.options, l);
        }

        function l(t, e) {
          return t ? o(t) : e.responseXML ? o(t, e.responseXML) : o(t, e.response);
        }

        return a.authenticated() ? c() : t.auto ? a.authenticate(c) : void o("not authenticated", null);
      }, a.preauth = function (t) {
        if (t) return t.oauth_token && u("oauth_token", t.oauth_token), t.oauth_token_secret && u("oauth_token_secret", t.oauth_token_secret), a;
      }, a.options = function (e) {
        return arguments.length ? (t = e, t.url = t.url || "https://www.openstreetmap.org", t.landing = t.landing || "land.html", t.singlepage = t.singlepage || !1, t.loading = t.loading || function () {}, t.done = t.done || function () {}, a.preauth(t)) : t;
      };
      var u;
      if (o.enabled) u = function u(e, n) {
        return 1 === arguments.length ? o.get(t.url + e) : 2 === arguments.length ? o.set(t.url + e, n) : void 0;
      };else {
        var c = {};

        u = function u(e, n) {
          return 1 === arguments.length ? c[t.url + e] : 2 === arguments.length ? c[t.url + e] = n : void 0;
        };
      }
      return a.options(t), a;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(45),
        i = n(29),
        o = new r.SHA1(),
        s = {};
    s.qsString = function (t) {
      return Object.keys(t).sort().map(function (e) {
        return s.percentEncode(e) + "=" + s.percentEncode(t[e]);
      }).join("&");
    }, s.stringQs = function (t) {
      return t.split("&").filter(function (t) {
        return "" !== t;
      }).reduce(function (t, e) {
        var n = e.split("=");
        return t[decodeURIComponent(n[0])] = null === n[1] ? "" : decodeURIComponent(n[1]), t;
      }, {});
    }, s.rawxhr = function (t, e, n, r, i) {
      var o = new XMLHttpRequest(),
          s = /^20\d$/;
      o.onreadystatechange = function () {
        if (4 === o.readyState && 0 !== o.status) {
          if (!s.test(o.status)) return i(o, null);
          i(null, o);
        }
      }, o.onerror = function (t) {
        return i(t, null);
      }, o.open(t, e, !0);

      for (var a in r) {
        o.setRequestHeader(a, r[a]);
      }

      return o.send(n), o;
    }, s.xhr = function (t, e, n, r, i, o) {
      var a = i && i.header || {
        "Content-Type": "application/x-www-form-urlencoded"
      };
      return a.Authorization = "OAuth " + s.authHeader(n), s.rawxhr(t, e, r, a, o);
    }, s.nonce = function () {
      for (var t = ""; t.length < 6;) {
        t += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz"[Math.floor(61 * Math.random())];
      }

      return t;
    }, s.authHeader = function (t) {
      return Object.keys(t).sort().map(function (e) {
        return encodeURIComponent(e) + '="' + encodeURIComponent(t[e]) + '"';
      }).join(", ");
    }, s.timestamp = function () {
      return ~~(+new Date() / 1e3);
    }, s.percentEncode = function (t) {
      return encodeURIComponent(t).replace(/\!/g, "%21").replace(/\'/g, "%27").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29");
    }, s.baseString = function (t, e, n) {
      return n.oauth_signature && delete n.oauth_signature, [t, s.percentEncode(e), s.percentEncode(s.qsString(n))].join("&");
    }, s.signature = function (t, e, n) {
      return o.b64_hmac(s.percentEncode(t) + "&" + s.percentEncode(e), n);
    }, s.headerGenerator = function (t) {
      t = t || {};
      var e = t.consumer_key || "",
          n = t.consumer_secret || "",
          r = t.signature_method || "HMAC-SHA1",
          o = t.version || "1.0",
          a = t.token || "",
          u = t.token_secret || "";
      return function (t, c, l) {
        t = t.toUpperCase(), "string" == typeof l && l.length > 0 && (l = s.stringQs(l));
        var h = c.split("?", 2),
            f = h[0],
            p = 2 === h.length ? s.stringQs(h[1]) : {},
            d = {
          oauth_consumer_key: e,
          oauth_signature_method: r,
          oauth_version: o,
          oauth_timestamp: s.timestamp(),
          oauth_nonce: s.nonce()
        };
        a && (d.oauth_token = a);
        var y = i({}, d, p, l),
            g = s.baseString(t, f, y);
        return d.oauth_signature = s.signature(n, u, g), "OAuth " + s.authHeader(d);
      };
    }, t.exports = s;
  }, function (t, e, n) {
    (function (r) {
      var i;
      !function () {
        function o(t) {
          var e,
              n,
              r,
              i = "",
              o = -1;
          if (t && t.length) for (r = t.length; (o += 1) < r;) {
            e = t.charCodeAt(o), n = o + 1 < r ? t.charCodeAt(o + 1) : 0, 55296 <= e && e <= 56319 && 56320 <= n && n <= 57343 && (e = 65536 + ((1023 & e) << 10) + (1023 & n), o += 1), e <= 127 ? i += String.fromCharCode(e) : e <= 2047 ? i += String.fromCharCode(192 | e >>> 6 & 31, 128 | 63 & e) : e <= 65535 ? i += String.fromCharCode(224 | e >>> 12 & 15, 128 | e >>> 6 & 63, 128 | 63 & e) : e <= 2097151 && (i += String.fromCharCode(240 | e >>> 18 & 7, 128 | e >>> 12 & 63, 128 | e >>> 6 & 63, 128 | 63 & e));
          }
          return i;
        }

        function s(t) {
          var e,
              n,
              r,
              i,
              o,
              s,
              a = [];
          if (e = n = r = i = o = 0, t && t.length) for (s = t.length, t += ""; e < s;) {
            r = t.charCodeAt(e), n += 1, r < 128 ? (a[n] = String.fromCharCode(r), e += 1) : r > 191 && r < 224 ? (i = t.charCodeAt(e + 1), a[n] = String.fromCharCode((31 & r) << 6 | 63 & i), e += 2) : (i = t.charCodeAt(e + 1), o = t.charCodeAt(e + 2), a[n] = String.fromCharCode((15 & r) << 12 | (63 & i) << 6 | 63 & o), e += 3);
          }
          return a.join("");
        }

        function a(t, e) {
          var n = (65535 & t) + (65535 & e);
          return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        function u(t, e) {
          return t << e | t >>> 32 - e;
        }

        function c(t, e) {
          for (var n, r = e ? "0123456789ABCDEF" : "0123456789abcdef", i = "", o = 0, s = t.length; o < s; o += 1) {
            n = t.charCodeAt(o), i += r.charAt(n >>> 4 & 15) + r.charAt(15 & n);
          }

          return i;
        }

        function l(t) {
          var e,
              n = 32 * t.length,
              r = "";

          for (e = 0; e < n; e += 8) {
            r += String.fromCharCode(t[e >> 5] >>> 24 - e % 32 & 255);
          }

          return r;
        }

        function h(t) {
          var e,
              n = 32 * t.length,
              r = "";

          for (e = 0; e < n; e += 8) {
            r += String.fromCharCode(t[e >> 5] >>> e % 32 & 255);
          }

          return r;
        }

        function f(t) {
          var e,
              n = 8 * t.length,
              r = Array(t.length >> 2),
              i = r.length;

          for (e = 0; e < i; e += 1) {
            r[e] = 0;
          }

          for (e = 0; e < n; e += 8) {
            r[e >> 5] |= (255 & t.charCodeAt(e / 8)) << e % 32;
          }

          return r;
        }

        function p(t) {
          var e,
              n = 8 * t.length,
              r = Array(t.length >> 2),
              i = r.length;

          for (e = 0; e < i; e += 1) {
            r[e] = 0;
          }

          for (e = 0; e < n; e += 8) {
            r[e >> 5] |= (255 & t.charCodeAt(e / 8)) << 24 - e % 32;
          }

          return r;
        }

        function d(t, e) {
          var n,
              r,
              i,
              o,
              s,
              a,
              u,
              c,
              l = e.length,
              h = Array();

          for (a = Array(Math.ceil(t.length / 2)), o = a.length, n = 0; n < o; n += 1) {
            a[n] = t.charCodeAt(2 * n) << 8 | t.charCodeAt(2 * n + 1);
          }

          for (; a.length > 0;) {
            for (s = Array(), i = 0, n = 0; n < a.length; n += 1) {
              i = (i << 16) + a[n], r = Math.floor(i / l), i -= r * l, (s.length > 0 || r > 0) && (s[s.length] = r);
            }

            h[h.length] = i, a = s;
          }

          for (u = "", n = h.length - 1; n >= 0; n--) {
            u += e.charAt(h[n]);
          }

          for (c = Math.ceil(8 * t.length / (Math.log(e.length) / Math.log(2))), n = u.length; n < c; n += 1) {
            u = e[0] + u;
          }

          return u;
        }

        function y(t, e) {
          var n,
              r,
              i,
              o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
              s = "",
              a = t.length;

          for (e = e || "=", n = 0; n < a; n += 3) {
            for (i = t.charCodeAt(n) << 16 | (n + 1 < a ? t.charCodeAt(n + 1) << 8 : 0) | (n + 2 < a ? t.charCodeAt(n + 2) : 0), r = 0; r < 4; r += 1) {
              8 * n + 6 * r > 8 * t.length ? s += e : s += o.charAt(i >>> 6 * (3 - r) & 63);
            }
          }

          return s;
        }

        var g;
        g = {
          VERSION: "1.0.6",
          Base64: function Base64() {
            var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                e = "=",
                n = !0;
            this.encode = function (r) {
              var i,
                  s,
                  a,
                  u = "",
                  c = r.length;

              for (e = e || "=", r = n ? o(r) : r, i = 0; i < c; i += 3) {
                for (a = r.charCodeAt(i) << 16 | (i + 1 < c ? r.charCodeAt(i + 1) << 8 : 0) | (i + 2 < c ? r.charCodeAt(i + 2) : 0), s = 0; s < 4; s += 1) {
                  u += 8 * i + 6 * s > 8 * c ? e : t.charAt(a >>> 6 * (3 - s) & 63);
                }
              }

              return u;
            }, this.decode = function (r) {
              var i,
                  o,
                  a,
                  u,
                  c,
                  l,
                  h,
                  f,
                  p,
                  d,
                  y = "",
                  g = [];
              if (!r) return r;
              i = d = 0, r = r.replace(new RegExp("\\" + e, "gi"), "");

              do {
                c = t.indexOf(r.charAt(i += 1)), l = t.indexOf(r.charAt(i += 1)), h = t.indexOf(r.charAt(i += 1)), f = t.indexOf(r.charAt(i += 1)), p = c << 18 | l << 12 | h << 6 | f, o = p >> 16 & 255, a = p >> 8 & 255, u = 255 & p, d += 1, g[d] = 64 === h ? String.fromCharCode(o) : 64 === f ? String.fromCharCode(o, a) : String.fromCharCode(o, a, u);
              } while (i < r.length);

              return y = g.join(""), y = n ? s(y) : y;
            }, this.setPad = function (t) {
              return e = t || e, this;
            }, this.setTab = function (e) {
              return t = e || t, this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (n = t), this;
            };
          },
          CRC32: function CRC32(t) {
            var e,
                n,
                r,
                i = 0,
                s = 0,
                a = 0;

            for (t = o(t), e = ["00000000 77073096 EE0E612C 990951BA 076DC419 706AF48F E963A535 9E6495A3 0EDB8832 ", "79DCB8A4 E0D5E91E 97D2D988 09B64C2B 7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 ", "84BE41DE 1ADAD47D 6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F ", "63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1 4B04D447 D20D85FD ", "A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3 45DF5C75 DCD60DCF ABD13D59 26D930AC ", "51DE003A C8D75180 BFD06116 21B4F4B5 56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 ", "B10BE924 2F6F7C87 58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589 ", "06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB 086D3D2D 91646C97 ", "E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED 1B01A57B 8208F4C1 F50FC457 65B0D9C6 ", "12B7E950 8BBEB8EA FCB9887C 62DD1DDF 15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 ", "D4BB30E2 4ADFA541 3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73 ", "33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525 206F85B3 B966D409 ", "CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17 2EB40D81 B7BD5C3B C0BA6CAD EDB88320 ", "9ABFB3B6 03B6E20C 74B1D29A EAD54739 9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E ", "7A6A5AA8 E40ECF0B 9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D ", "806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F 8EBEEFF9 17B7BE43 ", "60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1 A6BC5767 3FB506DD 48B2364B D80D2BDA ", "AF0A1B4C 36034AF6 41047A60 DF60EFC3 A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 ", "5268E236 CC0C7795 BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7 ", "B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9 EB0E363F 72076785 ", "05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 ", "F1D4E242 68DDB3F8 1FDA836E 81BE16CD F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA ", "11010B5C 8F659EFF F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661 ", "D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53 DEBB9EC5 47B2CF7F ", "30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605 CDD70693 54DE5729 23D967BF B3667A2E ", "C4614AB8 5D681B02 2A6F2B94 B40BBE37 C30C8EA1 5A05DF1B 2D02EF8D"].join(""), i ^= -1, n = 0, r = t.length; n < r; n += 1) {
              a = 255 & (i ^ t.charCodeAt(n)), s = "0x" + e.substr(9 * a, 8), i = i >>> 8 ^ s;
            }

            return (-1 ^ i) >>> 0;
          },
          MD5: function MD5(t) {
            function e(t) {
              return t = w ? o(t) : t, h(r(f(t), 8 * t.length));
            }

            function n(t, e) {
              var n, i, s, a, u;

              for (t = w ? o(t) : t, e = w ? o(e) : e, n = f(t), n.length > 16 && (n = r(n, 8 * t.length)), i = Array(16), s = Array(16), u = 0; u < 16; u += 1) {
                i[u] = 909522486 ^ n[u], s[u] = 1549556828 ^ n[u];
              }

              return a = r(i.concat(f(e)), 512 + 8 * e.length), h(r(s.concat(a), 640));
            }

            function r(t, e) {
              var n,
                  r,
                  i,
                  o,
                  u,
                  c = 1732584193,
                  h = -271733879,
                  f = -1732584194,
                  d = 271733878;

              for (t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e, n = 0; n < t.length; n += 16) {
                r = c, i = h, o = f, u = d, c = s(c, h, f, d, t[n + 0], 7, -680876936), d = s(d, c, h, f, t[n + 1], 12, -389564586), f = s(f, d, c, h, t[n + 2], 17, 606105819), h = s(h, f, d, c, t[n + 3], 22, -1044525330), c = s(c, h, f, d, t[n + 4], 7, -176418897), d = s(d, c, h, f, t[n + 5], 12, 1200080426), f = s(f, d, c, h, t[n + 6], 17, -1473231341), h = s(h, f, d, c, t[n + 7], 22, -45705983), c = s(c, h, f, d, t[n + 8], 7, 1770035416), d = s(d, c, h, f, t[n + 9], 12, -1958414417), f = s(f, d, c, h, t[n + 10], 17, -42063), h = s(h, f, d, c, t[n + 11], 22, -1990404162), c = s(c, h, f, d, t[n + 12], 7, 1804603682), d = s(d, c, h, f, t[n + 13], 12, -40341101), f = s(f, d, c, h, t[n + 14], 17, -1502002290), h = s(h, f, d, c, t[n + 15], 22, 1236535329), c = l(c, h, f, d, t[n + 1], 5, -165796510), d = l(d, c, h, f, t[n + 6], 9, -1069501632), f = l(f, d, c, h, t[n + 11], 14, 643717713), h = l(h, f, d, c, t[n + 0], 20, -373897302), c = l(c, h, f, d, t[n + 5], 5, -701558691), d = l(d, c, h, f, t[n + 10], 9, 38016083), f = l(f, d, c, h, t[n + 15], 14, -660478335), h = l(h, f, d, c, t[n + 4], 20, -405537848), c = l(c, h, f, d, t[n + 9], 5, 568446438), d = l(d, c, h, f, t[n + 14], 9, -1019803690), f = l(f, d, c, h, t[n + 3], 14, -187363961), h = l(h, f, d, c, t[n + 8], 20, 1163531501), c = l(c, h, f, d, t[n + 13], 5, -1444681467), d = l(d, c, h, f, t[n + 2], 9, -51403784), f = l(f, d, c, h, t[n + 7], 14, 1735328473), h = l(h, f, d, c, t[n + 12], 20, -1926607734), c = p(c, h, f, d, t[n + 5], 4, -378558), d = p(d, c, h, f, t[n + 8], 11, -2022574463), f = p(f, d, c, h, t[n + 11], 16, 1839030562), h = p(h, f, d, c, t[n + 14], 23, -35309556), c = p(c, h, f, d, t[n + 1], 4, -1530992060), d = p(d, c, h, f, t[n + 4], 11, 1272893353), f = p(f, d, c, h, t[n + 7], 16, -155497632), h = p(h, f, d, c, t[n + 10], 23, -1094730640), c = p(c, h, f, d, t[n + 13], 4, 681279174), d = p(d, c, h, f, t[n + 0], 11, -358537222), f = p(f, d, c, h, t[n + 3], 16, -722521979), h = p(h, f, d, c, t[n + 6], 23, 76029189), c = p(c, h, f, d, t[n + 9], 4, -640364487), d = p(d, c, h, f, t[n + 12], 11, -421815835), f = p(f, d, c, h, t[n + 15], 16, 530742520), h = p(h, f, d, c, t[n + 2], 23, -995338651), c = g(c, h, f, d, t[n + 0], 6, -198630844), d = g(d, c, h, f, t[n + 7], 10, 1126891415), f = g(f, d, c, h, t[n + 14], 15, -1416354905), h = g(h, f, d, c, t[n + 5], 21, -57434055), c = g(c, h, f, d, t[n + 12], 6, 1700485571), d = g(d, c, h, f, t[n + 3], 10, -1894986606), f = g(f, d, c, h, t[n + 10], 15, -1051523), h = g(h, f, d, c, t[n + 1], 21, -2054922799), c = g(c, h, f, d, t[n + 8], 6, 1873313359), d = g(d, c, h, f, t[n + 15], 10, -30611744), f = g(f, d, c, h, t[n + 6], 15, -1560198380), h = g(h, f, d, c, t[n + 13], 21, 1309151649), c = g(c, h, f, d, t[n + 4], 6, -145523070), d = g(d, c, h, f, t[n + 11], 10, -1120210379), f = g(f, d, c, h, t[n + 2], 15, 718787259), h = g(h, f, d, c, t[n + 9], 21, -343485551), c = a(c, r), h = a(h, i), f = a(f, o), d = a(d, u);
              }

              return Array(c, h, f, d);
            }

            function i(t, e, n, r, i, o) {
              return a(u(a(a(e, t), a(r, o)), i), n);
            }

            function s(t, e, n, r, o, s, a) {
              return i(e & n | ~e & r, t, e, o, s, a);
            }

            function l(t, e, n, r, o, s, a) {
              return i(e & r | n & ~r, t, e, o, s, a);
            }

            function p(t, e, n, r, o, s, a) {
              return i(e ^ n ^ r, t, e, o, s, a);
            }

            function g(t, e, n, r, o, s, a) {
              return i(n ^ (e | ~r), t, e, o, s, a);
            }

            var m = !(!t || "boolean" != typeof t.uppercase) && t.uppercase,
                v = t && "string" == typeof t.pad ? t.pad : "=",
                w = !t || "boolean" != typeof t.utf8 || t.utf8;
            this.hex = function (t) {
              return c(e(t), m);
            }, this.b64 = function (t) {
              return y(e(t), v);
            }, this.any = function (t, n) {
              return d(e(t), n);
            }, this.raw = function (t) {
              return e(t);
            }, this.hex_hmac = function (t, e) {
              return c(n(t, e), m);
            }, this.b64_hmac = function (t, e) {
              return y(n(t, e), v);
            }, this.any_hmac = function (t, e, r) {
              return d(n(t, e), r);
            }, this.vm_test = function () {
              return "900150983cd24fb0d6963f7d28e17f72" === hex("abc").toLowerCase();
            }, this.setUpperCase = function (t) {
              return "boolean" == typeof t && (m = t), this;
            }, this.setPad = function (t) {
              return v = t || v, this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (w = t), this;
            };
          },
          SHA1: function SHA1(t) {
            function e(t) {
              return t = g ? o(t) : t, l(r(p(t), 8 * t.length));
            }

            function n(t, e) {
              var n, i, s, a, u;

              for (t = g ? o(t) : t, e = g ? o(e) : e, n = p(t), n.length > 16 && (n = r(n, 8 * t.length)), i = Array(16), s = Array(16), a = 0; a < 16; a += 1) {
                i[a] = 909522486 ^ n[a], s[a] = 1549556828 ^ n[a];
              }

              return u = r(i.concat(p(e)), 512 + 8 * e.length), l(r(s.concat(u), 672));
            }

            function r(t, e) {
              var n,
                  r,
                  o,
                  c,
                  l,
                  h,
                  f,
                  p,
                  d = Array(80),
                  y = 1732584193,
                  g = -271733879,
                  m = -1732584194,
                  v = 271733878,
                  w = -1009589776;

              for (t[e >> 5] |= 128 << 24 - e % 32, t[15 + (e + 64 >> 9 << 4)] = e, n = 0; n < t.length; n += 16) {
                for (c = y, l = g, h = m, f = v, p = w, r = 0; r < 80; r += 1) {
                  d[r] = r < 16 ? t[n + r] : u(d[r - 3] ^ d[r - 8] ^ d[r - 14] ^ d[r - 16], 1), o = a(a(u(y, 5), i(r, g, m, v)), a(a(w, d[r]), s(r))), w = v, v = m, m = u(g, 30), g = y, y = o;
                }

                y = a(y, c), g = a(g, l), m = a(m, h), v = a(v, f), w = a(w, p);
              }

              return Array(y, g, m, v, w);
            }

            function i(t, e, n, r) {
              return t < 20 ? e & n | ~e & r : t < 40 ? e ^ n ^ r : t < 60 ? e & n | e & r | n & r : e ^ n ^ r;
            }

            function s(t) {
              return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
            }

            var h = !(!t || "boolean" != typeof t.uppercase) && t.uppercase,
                f = t && "string" == typeof t.pad ? t.pad : "=",
                g = !t || "boolean" != typeof t.utf8 || t.utf8;
            this.hex = function (t) {
              return c(e(t), h);
            }, this.b64 = function (t) {
              return y(e(t), f);
            }, this.any = function (t, n) {
              return d(e(t), n);
            }, this.raw = function (t) {
              return e(t);
            }, this.hex_hmac = function (t, e) {
              return c(n(t, e));
            }, this.b64_hmac = function (t, e) {
              return y(n(t, e), f);
            }, this.any_hmac = function (t, e, r) {
              return d(n(t, e), r);
            }, this.vm_test = function () {
              return "900150983cd24fb0d6963f7d28e17f72" === hex("abc").toLowerCase();
            }, this.setUpperCase = function (t) {
              return "boolean" == typeof t && (h = t), this;
            }, this.setPad = function (t) {
              return f = t || f, this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (g = t), this;
            };
          },
          SHA256: function SHA256(t) {
            function e(t, e) {
              return t = e ? o(t) : t, l(v(p(t), 8 * t.length));
            }

            function n(t, e) {
              t = E ? o(t) : t, e = E ? o(e) : e;
              var n,
                  r = 0,
                  i = p(t),
                  s = Array(16),
                  a = Array(16);

              for (i.length > 16 && (i = v(i, 8 * t.length)); r < 16; r += 1) {
                s[r] = 909522486 ^ i[r], a[r] = 1549556828 ^ i[r];
              }

              return n = v(s.concat(p(e)), 512 + 8 * e.length), l(v(a.concat(n), 768));
            }

            function r(t, e) {
              return t >>> e | t << 32 - e;
            }

            function i(t, e) {
              return t >>> e;
            }

            function s(t, e, n) {
              return t & e ^ ~t & n;
            }

            function u(t, e, n) {
              return t & e ^ t & n ^ e & n;
            }

            function h(t) {
              return r(t, 2) ^ r(t, 13) ^ r(t, 22);
            }

            function f(t) {
              return r(t, 6) ^ r(t, 11) ^ r(t, 25);
            }

            function g(t) {
              return r(t, 7) ^ r(t, 18) ^ i(t, 3);
            }

            function m(t) {
              return r(t, 17) ^ r(t, 19) ^ i(t, 10);
            }

            function v(t, e) {
              var n,
                  r,
                  i,
                  o,
                  c,
                  l,
                  p,
                  d,
                  y,
                  v,
                  b,
                  _,
                  E = [1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225],
                  T = new Array(64);

              for (t[e >> 5] |= 128 << 24 - e % 32, t[15 + (e + 64 >> 9 << 4)] = e, y = 0; y < t.length; y += 16) {
                for (n = E[0], r = E[1], i = E[2], o = E[3], c = E[4], l = E[5], p = E[6], d = E[7], v = 0; v < 64; v += 1) {
                  T[v] = v < 16 ? t[v + y] : a(a(a(m(T[v - 2]), T[v - 7]), g(T[v - 15])), T[v - 16]), b = a(a(a(a(d, f(c)), s(c, l, p)), w[v]), T[v]), _ = a(h(n), u(n, r, i)), d = p, p = l, l = c, c = a(o, b), o = i, i = r, r = n, n = a(b, _);
                }

                E[0] = a(n, E[0]), E[1] = a(r, E[1]), E[2] = a(i, E[2]), E[3] = a(o, E[3]), E[4] = a(c, E[4]), E[5] = a(l, E[5]), E[6] = a(p, E[6]), E[7] = a(d, E[7]);
              }

              return E;
            }

            var w,
                b = !(!t || "boolean" != typeof t.uppercase) && t.uppercase,
                _ = t && "string" == typeof t.pad ? t.pad : "=",
                E = !t || "boolean" != typeof t.utf8 || t.utf8;

            this.hex = function (t) {
              return c(e(t, E));
            }, this.b64 = function (t) {
              return y(e(t, E), _);
            }, this.any = function (t, n) {
              return d(e(t, E), n);
            }, this.raw = function (t) {
              return e(t, E);
            }, this.hex_hmac = function (t, e) {
              return c(n(t, e));
            }, this.b64_hmac = function (t, e) {
              return y(n(t, e), _);
            }, this.any_hmac = function (t, e, r) {
              return d(n(t, e), r);
            }, this.vm_test = function () {
              return "900150983cd24fb0d6963f7d28e17f72" === hex("abc").toLowerCase();
            }, this.setUpperCase = function (t) {
              return "boolean" == typeof t && (b = t), this;
            }, this.setPad = function (t) {
              return _ = t || _, this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (E = t), this;
            }, w = [1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998];
          },
          SHA512: function SHA512(t) {
            function e(t) {
              return t = _ ? o(t) : t, l(r(p(t), 8 * t.length));
            }

            function n(t, e) {
              t = _ ? o(t) : t, e = _ ? o(e) : e;
              var n,
                  i = 0,
                  s = p(t),
                  a = Array(32),
                  u = Array(32);

              for (s.length > 32 && (s = r(s, 8 * t.length)); i < 32; i += 1) {
                a[i] = 909522486 ^ s[i], u[i] = 1549556828 ^ s[i];
              }

              return n = r(a.concat(p(e)), 1024 + 8 * e.length), l(r(u.concat(n), 1536));
            }

            function r(t, e) {
              var n,
                  r,
                  o,
                  c = new Array(80),
                  l = new Array(16),
                  p = [new i(1779033703, -205731576), new i(-1150833019, -2067093701), new i(1013904242, -23791573), new i(-1521486534, 1595750129), new i(1359893119, -1377402159), new i(-1694144372, 725511199), new i(528734635, -79577749), new i(1541459225, 327033209)],
                  d = new i(0, 0),
                  y = new i(0, 0),
                  w = new i(0, 0),
                  b = new i(0, 0),
                  _ = new i(0, 0),
                  E = new i(0, 0),
                  T = new i(0, 0),
                  A = new i(0, 0),
                  x = new i(0, 0),
                  D = new i(0, 0),
                  C = new i(0, 0),
                  S = new i(0, 0),
                  O = new i(0, 0),
                  N = new i(0, 0),
                  I = new i(0, 0),
                  P = new i(0, 0),
                  B = new i(0, 0);

              for (void 0 === v && (v = [new i(1116352408, -685199838), new i(1899447441, 602891725), new i(-1245643825, -330482897), new i(-373957723, -2121671748), new i(961987163, -213338824), new i(1508970993, -1241133031), new i(-1841331548, -1357295717), new i(-1424204075, -630357736), new i(-670586216, -1560083902), new i(310598401, 1164996542), new i(607225278, 1323610764), new i(1426881987, -704662302), new i(1925078388, -226784913), new i(-2132889090, 991336113), new i(-1680079193, 633803317), new i(-1046744716, -815192428), new i(-459576895, -1628353838), new i(-272742522, 944711139), new i(264347078, -1953704523), new i(604807628, 2007800933), new i(770255983, 1495990901), new i(1249150122, 1856431235), new i(1555081692, -1119749164), new i(1996064986, -2096016459), new i(-1740746414, -295247957), new i(-1473132947, 766784016), new i(-1341970488, -1728372417), new i(-1084653625, -1091629340), new i(-958395405, 1034457026), new i(-710438585, -1828018395), new i(113926993, -536640913), new i(338241895, 168717936), new i(666307205, 1188179964), new i(773529912, 1546045734), new i(1294757372, 1522805485), new i(1396182291, -1651133473), new i(1695183700, -1951439906), new i(1986661051, 1014477480), new i(-2117940946, 1206759142), new i(-1838011259, 344077627), new i(-1564481375, 1290863460), new i(-1474664885, -1136513023), new i(-1035236496, -789014639), new i(-949202525, 106217008), new i(-778901479, -688958952), new i(-694614492, 1432725776), new i(-200395387, 1467031594), new i(275423344, 851169720), new i(430227734, -1194143544), new i(506948616, 1363258195), new i(659060556, -544281703), new i(883997877, -509917016), new i(958139571, -976659869), new i(1322822218, -482243893), new i(1537002063, 2003034995), new i(1747873779, -692930397), new i(1955562222, 1575990012), new i(2024104815, 1125592928), new i(-2067236844, -1578062990), new i(-1933114872, 442776044), new i(-1866530822, 593698344), new i(-1538233109, -561857047), new i(-1090935817, -1295615723), new i(-965641998, -479046869), new i(-903397682, -366583396), new i(-779700025, 566280711), new i(-354779690, -840897762), new i(-176337025, -294727304), new i(116418474, 1914138554), new i(174292421, -1563912026), new i(289380356, -1090974290), new i(460393269, 320620315), new i(685471733, 587496836), new i(852142971, 1086792851), new i(1017036298, 365543100), new i(1126000580, -1676669620), new i(1288033470, -885112138), new i(1501505948, -60457430), new i(1607167915, 987167468), new i(1816402316, 1246189591)]), r = 0; r < 80; r += 1) {
                c[r] = new i(0, 0);
              }

              for (t[e >> 5] |= 128 << 24 - (31 & e), t[31 + (e + 128 >> 10 << 5)] = e, o = t.length, r = 0; r < o; r += 32) {
                for (s(w, p[0]), s(b, p[1]), s(_, p[2]), s(E, p[3]), s(T, p[4]), s(A, p[5]), s(x, p[6]), s(D, p[7]), n = 0; n < 16; n += 1) {
                  c[n].h = t[r + 2 * n], c[n].l = t[r + 2 * n + 1];
                }

                for (n = 16; n < 80; n += 1) {
                  a(I, c[n - 2], 19), u(P, c[n - 2], 29), h(B, c[n - 2], 6), S.l = I.l ^ P.l ^ B.l, S.h = I.h ^ P.h ^ B.h, a(I, c[n - 15], 1), a(P, c[n - 15], 8), h(B, c[n - 15], 7), C.l = I.l ^ P.l ^ B.l, C.h = I.h ^ P.h ^ B.h, g(c[n], S, c[n - 7], C, c[n - 16]);
                }

                for (n = 0; n < 80; n += 1) {
                  O.l = T.l & A.l ^ ~T.l & x.l, O.h = T.h & A.h ^ ~T.h & x.h, a(I, T, 14), a(P, T, 18), u(B, T, 9), S.l = I.l ^ P.l ^ B.l, S.h = I.h ^ P.h ^ B.h, a(I, w, 28), u(P, w, 2), u(B, w, 7), C.l = I.l ^ P.l ^ B.l, C.h = I.h ^ P.h ^ B.h, N.l = w.l & b.l ^ w.l & _.l ^ b.l & _.l, N.h = w.h & b.h ^ w.h & _.h ^ b.h & _.h, m(d, D, S, O, v[n], c[n]), f(y, C, N), s(D, x), s(x, A), s(A, T), f(T, E, d), s(E, _), s(_, b), s(b, w), f(w, d, y);
                }

                f(p[0], p[0], w), f(p[1], p[1], b), f(p[2], p[2], _), f(p[3], p[3], E), f(p[4], p[4], T), f(p[5], p[5], A), f(p[6], p[6], x), f(p[7], p[7], D);
              }

              for (r = 0; r < 8; r += 1) {
                l[2 * r] = p[r].h, l[2 * r + 1] = p[r].l;
              }

              return l;
            }

            function i(t, e) {
              this.h = t, this.l = e;
            }

            function s(t, e) {
              t.h = e.h, t.l = e.l;
            }

            function a(t, e, n) {
              t.l = e.l >>> n | e.h << 32 - n, t.h = e.h >>> n | e.l << 32 - n;
            }

            function u(t, e, n) {
              t.l = e.h >>> n | e.l << 32 - n, t.h = e.l >>> n | e.h << 32 - n;
            }

            function h(t, e, n) {
              t.l = e.l >>> n | e.h << 32 - n, t.h = e.h >>> n;
            }

            function f(t, e, n) {
              var r = (65535 & e.l) + (65535 & n.l),
                  i = (e.l >>> 16) + (n.l >>> 16) + (r >>> 16),
                  o = (65535 & e.h) + (65535 & n.h) + (i >>> 16),
                  s = (e.h >>> 16) + (n.h >>> 16) + (o >>> 16);
              t.l = 65535 & r | i << 16, t.h = 65535 & o | s << 16;
            }

            function g(t, e, n, r, i) {
              var o = (65535 & e.l) + (65535 & n.l) + (65535 & r.l) + (65535 & i.l),
                  s = (e.l >>> 16) + (n.l >>> 16) + (r.l >>> 16) + (i.l >>> 16) + (o >>> 16),
                  a = (65535 & e.h) + (65535 & n.h) + (65535 & r.h) + (65535 & i.h) + (s >>> 16),
                  u = (e.h >>> 16) + (n.h >>> 16) + (r.h >>> 16) + (i.h >>> 16) + (a >>> 16);
              t.l = 65535 & o | s << 16, t.h = 65535 & a | u << 16;
            }

            function m(t, e, n, r, i, o) {
              var s = (65535 & e.l) + (65535 & n.l) + (65535 & r.l) + (65535 & i.l) + (65535 & o.l),
                  a = (e.l >>> 16) + (n.l >>> 16) + (r.l >>> 16) + (i.l >>> 16) + (o.l >>> 16) + (s >>> 16),
                  u = (65535 & e.h) + (65535 & n.h) + (65535 & r.h) + (65535 & i.h) + (65535 & o.h) + (a >>> 16),
                  c = (e.h >>> 16) + (n.h >>> 16) + (r.h >>> 16) + (i.h >>> 16) + (o.h >>> 16) + (u >>> 16);
              t.l = 65535 & s | a << 16, t.h = 65535 & u | c << 16;
            }

            var v,
                w = !(!t || "boolean" != typeof t.uppercase) && t.uppercase,
                b = t && "string" == typeof t.pad ? t.pad : "=",
                _ = !t || "boolean" != typeof t.utf8 || t.utf8;

            this.hex = function (t) {
              return c(e(t));
            }, this.b64 = function (t) {
              return y(e(t), b);
            }, this.any = function (t, n) {
              return d(e(t), n);
            }, this.raw = function (t) {
              return e(t);
            }, this.hex_hmac = function (t, e) {
              return c(n(t, e));
            }, this.b64_hmac = function (t, e) {
              return y(n(t, e), b);
            }, this.any_hmac = function (t, e, r) {
              return d(n(t, e), r);
            }, this.vm_test = function () {
              return "900150983cd24fb0d6963f7d28e17f72" === hex("abc").toLowerCase();
            }, this.setUpperCase = function (t) {
              return "boolean" == typeof t && (w = t), this;
            }, this.setPad = function (t) {
              return b = t || b, this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (_ = t), this;
            };
          },
          RMD160: function RMD160(t) {
            function e(t) {
              return t = m ? o(t) : t, r(i(f(t), 8 * t.length));
            }

            function n(t, e) {
              t = m ? o(t) : t, e = m ? o(e) : e;
              var n,
                  s,
                  a = f(t),
                  u = Array(16),
                  c = Array(16);

              for (a.length > 16 && (a = i(a, 8 * t.length)), n = 0; n < 16; n += 1) {
                u[n] = 909522486 ^ a[n], c[n] = 1549556828 ^ a[n];
              }

              return s = i(u.concat(f(e)), 512 + 8 * e.length), r(i(c.concat(s), 672));
            }

            function r(t) {
              var e,
                  n = "",
                  r = 32 * t.length;

              for (e = 0; e < r; e += 8) {
                n += String.fromCharCode(t[e >> 5] >>> e % 32 & 255);
              }

              return n;
            }

            function i(t, e) {
              var n,
                  r,
                  i,
                  o,
                  c,
                  f,
                  p,
                  d,
                  y,
                  g,
                  m,
                  E,
                  T,
                  A,
                  x = 1732584193,
                  D = 4023233417,
                  C = 2562383102,
                  S = 271733878,
                  O = 3285377520;

              for (t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e, o = t.length, i = 0; i < o; i += 16) {
                for (c = g = x, f = m = D, p = E = C, d = T = S, y = A = O, r = 0; r <= 79; r += 1) {
                  n = a(c, s(r, f, p, d)), n = a(n, t[i + v[r]]), n = a(n, l(r)), n = a(u(n, b[r]), y), c = y, y = d, d = u(p, 10), p = f, f = n, n = a(g, s(79 - r, m, E, T)), n = a(n, t[i + w[r]]), n = a(n, h(r)), n = a(u(n, _[r]), A), g = A, A = T, T = u(E, 10), E = m, m = n;
                }

                n = a(D, a(p, T)), D = a(C, a(d, A)), C = a(S, a(y, g)), S = a(O, a(c, m)), O = a(x, a(f, E)), x = n;
              }

              return [x, D, C, S, O];
            }

            function s(t, e, n, r) {
              return 0 <= t && t <= 15 ? e ^ n ^ r : 16 <= t && t <= 31 ? e & n | ~e & r : 32 <= t && t <= 47 ? (e | ~n) ^ r : 48 <= t && t <= 63 ? e & r | n & ~r : 64 <= t && t <= 79 ? e ^ (n | ~r) : "rmd160_f: j out of range";
            }

            function l(t) {
              return 0 <= t && t <= 15 ? 0 : 16 <= t && t <= 31 ? 1518500249 : 32 <= t && t <= 47 ? 1859775393 : 48 <= t && t <= 63 ? 2400959708 : 64 <= t && t <= 79 ? 2840853838 : "rmd160_K1: j out of range";
            }

            function h(t) {
              return 0 <= t && t <= 15 ? 1352829926 : 16 <= t && t <= 31 ? 1548603684 : 32 <= t && t <= 47 ? 1836072691 : 48 <= t && t <= 63 ? 2053994217 : 64 <= t && t <= 79 ? 0 : "rmd160_K2: j out of range";
            }

            var p = !(!t || "boolean" != typeof t.uppercase) && t.uppercase,
                g = t && "string" == typeof t.pad ? t.pa : "=",
                m = !t || "boolean" != typeof t.utf8 || t.utf8,
                v = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
                w = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
                b = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
                _ = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
            this.hex = function (t) {
              return c(e(t));
            }, this.b64 = function (t) {
              return y(e(t), g);
            }, this.any = function (t, n) {
              return d(e(t), n);
            }, this.raw = function (t) {
              return e(t);
            }, this.hex_hmac = function (t, e) {
              return c(n(t, e));
            }, this.b64_hmac = function (t, e) {
              return y(n(t, e), g);
            }, this.any_hmac = function (t, e, r) {
              return d(n(t, e), r);
            }, this.vm_test = function () {
              return "900150983cd24fb0d6963f7d28e17f72" === hex("abc").toLowerCase();
            }, this.setUpperCase = function (t) {
              return "boolean" == typeof t && (p = t), this;
            }, this.setPad = function (t) {
              return void 0 !== t && (g = t), this;
            }, this.setUTF8 = function (t) {
              return "boolean" == typeof t && (m = t), this;
            };
          }
        }, function (o, s) {
          e, e && "object" == typeof r && r && r.global, void 0 !== (i = function () {
            return g;
          }.call(e, n, e, t)) && (t.exports = i);
        }();
      }();
    }).call(e, n(1));
  }, function (t, e, n) {
    var r, i;
    !function (o, s) {
      r = s, void 0 !== (i = "function" == typeof r ? r.call(e, n, e, t) : r) && (t.exports = i);
    }(0, function () {
      function t() {
        var t = arguments.length;
        if (0 === t) throw new Error("resolveUrl requires at least one argument; got none.");
        var e = document.createElement("base");
        if (e.href = arguments[0], 1 === t) return e.href;
        var n = document.getElementsByTagName("head")[0];
        n.insertBefore(e, n.firstChild);

        for (var r, i = document.createElement("a"), o = 1; o < t; o++) {
          i.href = arguments[o], r = i.href, e.href = r;
        }

        return n.removeChild(e), r;
      }

      return t;
    });
  }, function (t, e, n) {
    var r = n(48),
        i = n(49),
        o = [n(56)];
    t.exports = r.createStore(i, o);
  }, function (t, e, n) {
    function r() {
      var t = "undefined" == typeof console ? null : console;

      if (t) {
        (t.warn ? t.warn : t.log).apply(t, arguments);
      }
    }

    function i(t, e, n) {
      n || (n = ""), t && !h(t) && (t = [t]), e && !h(e) && (e = [e]);
      var i = n ? "__storejs_" + n + "_" : "",
          o = n ? new RegExp("^" + i) : null;
      if (!/^[a-zA-Z0-9_\-]*$/.test(n)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
      var y = {
        _namespacePrefix: i,
        _namespaceRegexp: o,
        _testStorage: function _testStorage(t) {
          try {
            var e = "__storejs__test__";
            t.write(e, e);
            var n = t.read(e) === e;
            return t.remove(e), n;
          } catch (t) {
            return !1;
          }
        },
        _assignPluginFnProp: function _assignPluginFnProp(t, e) {
          var n = this[e];

          this[e] = function () {
            function e() {
              if (n) return u(arguments, function (t, e) {
                r[e] = t;
              }), n.apply(i, r);
            }

            var r = s(arguments, 0),
                i = this,
                o = [e].concat(r);
            return t.apply(i, o);
          };
        },
        _serialize: function _serialize(t) {
          return JSON.stringify(t);
        },
        _deserialize: function _deserialize(t, e) {
          if (!t) return e;
          var n = "";

          try {
            n = JSON.parse(t);
          } catch (e) {
            n = t;
          }

          return void 0 !== n ? n : e;
        },
        _addStorage: function _addStorage(t) {
          this.enabled || this._testStorage(t) && (this.storage = t, this.enabled = !0);
        },
        _addPlugin: function _addPlugin(t) {
          var e = this;
          if (h(t)) return void u(t, function (t) {
            e._addPlugin(t);
          });

          if (!a(this.plugins, function (e) {
            return t === e;
          })) {
            if (this.plugins.push(t), !f(t)) throw new Error("Plugins must be function values that return objects");
            var n = t.call(this);
            if (!p(n)) throw new Error("Plugins must return an object of function properties");
            u(n, function (n, r) {
              if (!f(n)) throw new Error("Bad plugin property: " + r + " from plugin " + t.name + ". Plugins should only return functions.");

              e._assignPluginFnProp(n, r);
            });
          }
        },
        addStorage: function addStorage(t) {
          r("store.addStorage(storage) is deprecated. Use createStore([storages])"), this._addStorage(t);
        }
      },
          g = l(y, d, {
        plugins: []
      });
      return g.raw = {}, u(g, function (t, e) {
        f(t) && (g.raw[e] = c(g, t));
      }), u(t, function (t) {
        g._addStorage(t);
      }), u(e, function (t) {
        g._addPlugin(t);
      }), g;
    }

    var o = n(4),
        s = o.slice,
        a = o.pluck,
        u = o.each,
        c = o.bind,
        l = o.create,
        h = o.isList,
        f = o.isFunction,
        p = o.isObject;
    t.exports = {
      createStore: i
    };
    var d = {
      version: "2.0.12",
      enabled: !1,
      get: function get(t, e) {
        var n = this.storage.read(this._namespacePrefix + t);
        return this._deserialize(n, e);
      },
      set: function set(t, e) {
        return void 0 === e ? this.remove(t) : (this.storage.write(this._namespacePrefix + t, this._serialize(e)), e);
      },
      remove: function remove(t) {
        this.storage.remove(this._namespacePrefix + t);
      },
      each: function each(t) {
        var e = this;
        this.storage.each(function (n, r) {
          t.call(e, e._deserialize(n), (r || "").replace(e._namespaceRegexp, ""));
        });
      },
      clearAll: function clearAll() {
        this.storage.clearAll();
      },
      hasNamespace: function hasNamespace(t) {
        return this._namespacePrefix == "__storejs_" + t + "_";
      },
      createStore: function createStore() {
        return i.apply(this, arguments);
      },
      addPlugin: function addPlugin(t) {
        this._addPlugin(t);
      },
      namespace: function namespace(t) {
        return i(this.storage, this.plugins, t);
      }
    };
  }, function (t, e, n) {
    t.exports = [n(50), n(51), n(52), n(53), n(54), n(55)];
  }, function (t, e, n) {
    function r() {
      return l.localStorage;
    }

    function i(t) {
      return r().getItem(t);
    }

    function o(t, e) {
      return r().setItem(t, e);
    }

    function s(t) {
      for (var e = r().length - 1; e >= 0; e--) {
        var n = r().key(e);
        t(i(n), n);
      }
    }

    function a(t) {
      return r().removeItem(t);
    }

    function u() {
      return r().clear();
    }

    var c = n(4),
        l = c.Global;
    t.exports = {
      name: "localStorage",
      read: i,
      write: o,
      each: s,
      remove: a,
      clearAll: u
    };
  }, function (t, e, n) {
    function r(t) {
      return l[t];
    }

    function i(t, e) {
      l[t] = e;
    }

    function o(t) {
      for (var e = l.length - 1; e >= 0; e--) {
        var n = l.key(e);
        t(l[n], n);
      }
    }

    function s(t) {
      return l.removeItem(t);
    }

    function a() {
      o(function (t, e) {
        delete l[t];
      });
    }

    var u = n(4),
        c = u.Global;
    t.exports = {
      name: "oldFF-globalStorage",
      read: r,
      write: i,
      each: o,
      remove: s,
      clearAll: a
    };
    var l = c.globalStorage;
  }, function (t, e, n) {
    function r(t, e) {
      if (!d) {
        var n = u(t);
        p(function (t) {
          t.setAttribute(n, e), t.save(h);
        });
      }
    }

    function i(t) {
      if (!d) {
        var e = u(t),
            n = null;
        return p(function (t) {
          n = t.getAttribute(e);
        }), n;
      }
    }

    function o(t) {
      p(function (e) {
        for (var n = e.XMLDocument.documentElement.attributes, r = n.length - 1; r >= 0; r--) {
          var i = n[r];
          t(e.getAttribute(i.name), i.name);
        }
      });
    }

    function s(t) {
      var e = u(t);
      p(function (t) {
        t.removeAttribute(e), t.save(h);
      });
    }

    function a() {
      p(function (t) {
        var e = t.XMLDocument.documentElement.attributes;
        t.load(h);

        for (var n = e.length - 1; n >= 0; n--) {
          t.removeAttribute(e[n].name);
        }

        t.save(h);
      });
    }

    function u(t) {
      return t.replace(/^\d/, "___$&").replace(y, "___");
    }

    var c = n(4),
        l = c.Global;
    t.exports = {
      name: "oldIE-userDataStorage",
      write: r,
      read: i,
      each: o,
      remove: s,
      clearAll: a
    };

    var h = "storejs",
        f = l.document,
        p = function () {
      if (!f || !f.documentElement || !f.documentElement.addBehavior) return null;
      var t, e, n;

      try {
        e = new ActiveXObject("htmlfile"), e.open(), e.write('<script>document.w=window<\/script><iframe src="/favicon.ico"></iframe>'), e.close(), t = e.w.frames[0].document, n = t.createElement("div");
      } catch (e) {
        n = f.createElement("div"), t = f.body;
      }

      return function (e) {
        var r = [].slice.call(arguments, 0);
        r.unshift(n), t.appendChild(n), n.addBehavior("#default#userData"), n.load(h), e.apply(this, r), t.removeChild(n);
      };
    }(),
        d = (l.navigator ? l.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./),
        y = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
  }, function (t, e, n) {
    function r(t) {
      if (!t || !u(t)) return null;
      var e = "(?:^|.*;\\s*)" + escape(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
      return unescape(f.cookie.replace(new RegExp(e), "$1"));
    }

    function i(t) {
      for (var e = f.cookie.split(/; ?/g), n = e.length - 1; n >= 0; n--) {
        if (h(e[n])) {
          var r = e[n].split("="),
              i = unescape(r[0]),
              o = unescape(r[1]);
          t(o, i);
        }
      }
    }

    function o(t, e) {
      t && (f.cookie = escape(t) + "=" + escape(e) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/");
    }

    function s(t) {
      t && u(t) && (f.cookie = escape(t) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
    }

    function a() {
      i(function (t, e) {
        s(e);
      });
    }

    function u(t) {
      return new RegExp("(?:^|;\\s*)" + escape(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(f.cookie);
    }

    var c = n(4),
        l = c.Global,
        h = c.trim;
    t.exports = {
      name: "cookieStorage",
      read: r,
      write: o,
      each: i,
      remove: s,
      clearAll: a
    };
    var f = l.document;
  }, function (t, e, n) {
    function r() {
      return l.sessionStorage;
    }

    function i(t) {
      return r().getItem(t);
    }

    function o(t, e) {
      return r().setItem(t, e);
    }

    function s(t) {
      for (var e = r().length - 1; e >= 0; e--) {
        var n = r().key(e);
        t(i(n), n);
      }
    }

    function a(t) {
      return r().removeItem(t);
    }

    function u() {
      return r().clear();
    }

    var c = n(4),
        l = c.Global;
    t.exports = {
      name: "sessionStorage",
      read: i,
      write: o,
      each: s,
      remove: a,
      clearAll: u
    };
  }, function (t, e) {
    function n(t) {
      return a[t];
    }

    function r(t, e) {
      a[t] = e;
    }

    function i(t) {
      for (var e in a) {
        a.hasOwnProperty(e) && t(a[e], e);
      }
    }

    function o(t) {
      delete a[t];
    }

    function s(t) {
      a = {};
    }

    t.exports = {
      name: "memoryStorage",
      read: n,
      write: r,
      each: i,
      remove: o,
      clearAll: s
    };
    var a = {};
  }, function (t, e, n) {
    function r() {
      return n(57), {};
    }

    t.exports = r;
  }, function (module, exports) {
    "object" != typeof JSON && (JSON = {}), function () {
      "use strict";

      function f(t) {
        return t < 10 ? "0" + t : t;
      }

      function this_value() {
        return this.valueOf();
      }

      function quote(t) {
        return rx_escapable.lastIndex = 0, rx_escapable.test(t) ? '"' + t.replace(rx_escapable, function (t) {
          var e = meta[t];
          return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + t + '"';
      }

      function str(t, e) {
        var n,
            r,
            i,
            o,
            s,
            a = gap,
            u = e[t];

        switch (u && "object" == typeof u && "function" == typeof u.toJSON && (u = u.toJSON(t)), "function" == typeof rep && (u = rep.call(e, t, u)), typeof u) {
          case "string":
            return quote(u);

          case "number":
            return isFinite(u) ? String(u) : "null";

          case "boolean":
          case "null":
            return String(u);

          case "object":
            if (!u) return "null";

            if (gap += indent, s = [], "[object Array]" === Object.prototype.toString.apply(u)) {
              for (o = u.length, n = 0; n < o; n += 1) {
                s[n] = str(n, u) || "null";
              }

              return i = 0 === s.length ? "[]" : gap ? "[\n" + gap + s.join(",\n" + gap) + "\n" + a + "]" : "[" + s.join(",") + "]", gap = a, i;
            }

            if (rep && "object" == typeof rep) for (o = rep.length, n = 0; n < o; n += 1) {
              "string" == typeof rep[n] && (r = rep[n], (i = str(r, u)) && s.push(quote(r) + (gap ? ": " : ":") + i));
            } else for (r in u) {
              Object.prototype.hasOwnProperty.call(u, r) && (i = str(r, u)) && s.push(quote(r) + (gap ? ": " : ":") + i);
            }
            return i = 0 === s.length ? "{}" : gap ? "{\n" + gap + s.join(",\n" + gap) + "\n" + a + "}" : "{" + s.join(",") + "}", gap = a, i;
        }
      }

      var rx_one = /^[\],:{}\s]*$/,
          rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
          rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
          rx_four = /(?:^|:|,)(?:\s*\[)+/g,
          rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
          rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
      "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
      }, Boolean.prototype.toJSON = this_value, Number.prototype.toJSON = this_value, String.prototype.toJSON = this_value);
      var gap, indent, meta, rep;
      "function" != typeof JSON.stringify && (meta = {
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      }, JSON.stringify = function (t, e, n) {
        var r;
        if (gap = "", indent = "", "number" == typeof n) for (r = 0; r < n; r += 1) {
          indent += " ";
        } else "string" == typeof n && (indent = n);
        if (rep = e, e && "function" != typeof e && ("object" != typeof e || "number" != typeof e.length)) throw new Error("JSON.stringify");
        return str("", {
          "": t
        });
      }), "function" != typeof JSON.parse && (JSON.parse = function (text, reviver) {
        function walk(t, e) {
          var n,
              r,
              i = t[e];
          if (i && "object" == typeof i) for (n in i) {
            Object.prototype.hasOwnProperty.call(i, n) && (r = walk(i, n), void 0 !== r ? i[n] = r : delete i[n]);
          }
          return reviver.call(t, e, i);
        }

        var j;
        if (text = String(text), rx_dangerous.lastIndex = 0, rx_dangerous.test(text) && (text = text.replace(rx_dangerous, function (t) {
          return "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
        })), rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({
          "": j
        }, "") : j;
        throw new SyntaxError("JSON.parse");
      });
    }();
  }, function (t, e) {
    t.exports = {
      endpoint: "https://www.openstreetmap.org",
      oauthConsumerKey: "",
      oauthSecret: "",
      oauthUserToken: "",
      oauthUserTokenSecret: "",
      always_authenticated: !1
    };
  }, function (t, e, n) {
    "use strict";

    function r() {
      return new Date().toISOString();
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getCurrentIsoTimestamp = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = (0, O.findElementType)(e),
          i = (0, O.findElementId)(e);
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/" + e), n).then(function (t) {
        return (0, N.convertElementXmlToJson)(t, r, i);
      });
    }

    function i(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/" + e + "/full"), n).then(function (t) {
        return (0, N.xmlToJson)(t).then(function (t) {
          return Promise.resolve((0, N.cleanMapJson)(t));
        }).catch(function (t) {
          throw new I.RequestException(t);
        });
      });
    }

    function o(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = (0, O.findElementType)(e[0]),
          i = e.map(function (t) {
        return (0, O.findElementId)(t);
      });
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/" + r + "s?" + r + "s=" + i.join(",")), n).then(function (t) {
        return (0, N.xmlToJson)(t).then(function (t) {
          return Promise.resolve((0, N.cleanMapJson)(t));
        }).catch(function (t) {
          throw new I.RequestException(t);
        });
      });
    }

    function s(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/" + e + "/ways"), n).then(function (t) {
        return (0, N.convertElementsListXmlToJson)(t, "way");
      });
    }

    function a(t, e, n, r) {
      var i = (0, O.simpleObjectDeepClone)(n),
          o = i._id,
          s = i._type;
      delete i._id, delete i._type, i.$.changeset = r;
      var a = {
        osm: {
          $: {}
        }
      };
      a.osm[s] = [i];
      var u = (0, N.jsonToXml)(a),
          c = o && !(0, O.checkIdIsNegative)(o) ? "/" + s + "/" + o : "/" + s + "/create";
      return new Promise(function (n, r) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, c),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: u
        }, function (t, e) {
          return t && r(new I.RequestException("Element sending request failed")), n(parseInt(e, 10));
        });
      });
    }

    function u(t, e, n, r, i) {
      var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
          s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
          a = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : {},
          u = {
        bbox: e.toString() + "," + n.toString() + "," + r.toString() + "," + i.toString()
      };
      return o && (u.limit = o), null !== s && void 0 !== s && (u.closed = s), (0, S.fetch)((0, O.buildApiUrl)(t, "/notes", u), a).then(function (t) {
        return (0, N.convertNotesXmlToJson)(t);
      });
    }

    function c(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "xml",
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
          o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
          s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
          a = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null,
          u = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null,
          c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : {},
          l = {
        q: e
      },
          h = "/notes/search." + n;
      "raw" === n && (h = "/notes/search");
      var f = {
        limit: r,
        closed: i,
        display_name: o,
        user: s,
        from: a,
        to: u
      };
      return Object.entries(f).forEach(function (t) {
        t[1] && (l[t[0]] = t[1]);
      }), (0, S.fetch)((0, O.buildApiUrl)(t, h, l), c).then(function (t) {
        return "xml" === n ? (0, N.convertNotesXmlToJson)(t) : t;
      });
    }

    function l(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "xml",
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          i = "/notes/" + e.toString() + "." + n;
      return "raw" === n && (i = "/notes/" + e.toString()), (0, S.fetch)((0, O.buildApiUrl)(t, i), r).then(function (t) {
        return "xml" === n ? (0, N.convertNotesXmlToJson)(t) : t;
      }).then(function (t) {
        return "xml" === n ? t.find(function () {
          return !0;
        }) : t;
      });
    }

    function h(t, e, n, r, i) {
      return new Promise(function (o, s) {
        t.xhr({
          method: "POST",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/notes/" + n + "/" + i, {
            text: r
          }),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          }
        }, function (t, e) {
          return t ? s(new I.RequestException(JSON.stringify({
            message: "Note " + i + " change failed",
            status: t.status,
            statusText: t.statusText
          }))) : o((0, N.convertNotesXmlToJson)(new XMLSerializer().serializeToString(e)));
        });
      }).then(function (t) {
        return t.find(function () {
          return !0;
        });
      });
    }

    function f(t, e, n, r, i) {
      var o = {
        lat: n,
        lon: r,
        text: i
      };
      return new Promise(function (n, r) {
        t.xhr({
          method: "POST",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/notes", o),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          }
        }, function (t, e) {
          return t ? r(new I.RequestException(JSON.stringify({
            message: "Note creation failed",
            status: t.status,
            statusText: t.statusText
          }))) : n((0, N.convertNotesXmlToJson)(new XMLSerializer().serializeToString(e)));
        });
      }).then(function (t) {
        return t.find(function () {
          return !0;
        });
      });
    }

    function p(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
          i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {},
          o = (0, N.buildChangesetXml)(n, r, i);
      return new Promise(function (n, r) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/changeset/create"),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: o
        }, function (t, e) {
          return t ? r(new I.RequestException("Changeset creation request failed")) : n(parseInt(e, 10));
        });
      });
    }

    function d(t, e, n) {
      return new Promise(function (r, i) {
        t.xhr({
          method: "GET",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/changeset/" + n.toString()),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          }
        }, function (t, e) {
          if (t) return i(new I.RequestException("Changeset check request failed"));
          var o = "false",
              s = e.getElementsByTagName("changeset")[0];
          return s && (o = s.getAttribute("open")), "false" === o ? i(t) : r(n);
        });
      });
    }

    function y(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/changeset/" + e.toString()), n).then(function (t) {
        return (0, N.xmlToJson)(t);
      });
    }

    function g(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
          i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "",
          o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {},
          s = (0, N.buildChangesetFromObjectXml)(o, r, i);
      return new Promise(function (r, i) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/changeset/" + n.toString()),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: s
        }, function (t, e) {
          return t ? i(new I.RequestException(JSON.stringify({
            message: "Changeset update request failed",
            status: t.status,
            statusText: t.statusText
          }))) : r((0, N.xmlToJson)(new XMLSerializer().serializeToString(e)));
        });
      });
    }

    function m(t, e, n) {
      return new Promise(function (r, i) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/changeset/" + n.toString() + "/close"),
          options: {
            header: {
              "Content-Type": "text/plain"
            }
          }
        }, function (t, e) {
          return t ? i(new I.RequestException(JSON.stringify({
            message: "Changeset close request failed",
            status: t.status,
            statusText: t.statusText
          }))) : r(e);
        });
      });
    }

    function v(t, e, n, r) {
      return new Promise(function (n, i) {
        t.xhr({
          method: "POST",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/changeset/create"),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: r
        }, function (t, e) {
          return t ? i(new I.RequestException("Changeset OSC file content upload request failed")) : n((0, N.xmlToJson)(new XMLSerializer().serializeToString(e)));
        });
      });
    }

    function w(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = ["left", "bottom", "right", "top", "display_name", "user", "time", "open", "closed", "changesets"],
          r = {};
      return n.forEach(function (t) {
        t in e && e[t] && (r[t] = e[t].toString());
      }), r.left && r.bottom && r.right && r.top && (r.bbox = r.left.toString() + "," + r.bottom.toString() + "," + r.right.toString() + "," + r.top.toString(), delete r.left, delete r.bottom, delete r.right, delete r.top), (0, S.fetch)((0, O.buildApiUrl)(t, "/changesets", r), {
        auth: e.auth
      }).then(function (t) {
        return (0, N.xmlToJson)(t);
      });
    }

    function b(t, e, n, r, i) {
      var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "json",
          s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {},
          a = Array.from(arguments);
      if (a.length < 5 && a.some(function (t) {
        return void 0 === t;
      })) throw new Error("You didn't provide all arguments to the function");
      var u = {
        bbox: e.toString() + "," + n.toString() + "," + r.toString() + "," + i.toString()
      };
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/map", u), s).then(function (t) {
        return "json" !== o ? Promise.all([(0, N.xmlToJson)(t).then(function (t) {
          return Promise.resolve((0, N.cleanMapJson)(t));
        }).catch(function (t) {
          throw new I.RequestException(t);
        }), t]) : (0, N.xmlToJson)(t).then(function (t) {
          return Promise.resolve((0, N.cleanMapJson)(t));
        }).catch(function (t) {
          throw new I.RequestException(t);
        });
      });
    }

    function _(t, e, n, r) {
      var i = (0, O.simpleObjectDeepClone)(n),
          o = i._id,
          s = i._type;
      delete i._id, delete i._type, i.$.changeset = r;
      var a = {
        osm: {
          $: {}
        }
      };
      a.osm[s] = [i];
      var u = (0, N.jsonToXml)(a),
          c = "/" + s + "/" + o;
      return new Promise(function (n, r) {
        t.xhr({
          method: "DELETE",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, c),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: u
        }, function (t, e) {
          return t ? r(new I.RequestException(t)) : n(parseInt(e, 10));
        });
      });
    }

    function E(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return (0, S.fetch)((0, O.buildApiUrl)(t, "/" + e + "/relations"), n).then(function (t) {
        return (0, N.convertElementsListXmlToJson)(t, "relation");
      });
    }

    function T(t, e) {
      return new Promise(function (n, r) {
        t.xhr({
          method: "GET",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/user/preferences"),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          }
        }, function (t, e) {
          return t ? r(new I.RequestException(JSON.stringify({
            message: "Issue to get user preferences",
            status: t.status,
            statusText: t.statusText
          }))) : n((0, N.xmlToJson)(new XMLSerializer().serializeToString(e)));
        });
      });
    }

    function A(t, e, n) {
      var r = (0, N.buildPreferencesFromObjectXml)(n);
      return new Promise(function (n, i) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/user/preferences"),
          options: {
            header: {
              "Content-Type": "text/xml"
            }
          },
          content: r
        }, function (t, e) {
          return t ? i(new I.RequestException(JSON.stringify({
            message: "User preferences update request failed",
            status: t.status,
            statusText: t.statusText
          }))) : n(e);
        });
      });
    }

    function x(t, e, n) {
      return new Promise(function (r, i) {
        t.xhr({
          method: "GET",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/user/preferences/" + n)
        }, function (t, e) {
          return t ? i(new I.RequestException(JSON.stringify({
            message: "Issue to get this user preference",
            status: t.status,
            statusText: t.statusText
          }))) : r(e);
        });
      });
    }

    function D(t, e, n, r) {
      return new Promise(function (i, o) {
        t.xhr({
          method: "PUT",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/user/preferences/" + n),
          options: {
            header: {
              "Content-Type": "text/plain"
            }
          },
          content: r
        }, function (t, e) {
          return t ? o(new I.RequestException(JSON.stringify({
            message: "User preference update request failed for " + n,
            status: t.status,
            statusText: t.statusText
          }))) : i(e);
        });
      });
    }

    function C(t, e, n) {
      return new Promise(function (r, i) {
        t.xhr({
          method: "DELETE",
          prefix: !1,
          path: (0, O.buildApiUrl)(e, "/user/preferences/" + n)
        }, function (t, e) {
          return t ? i(new I.RequestException(JSON.stringify({
            message: "User preference deletion request failed for " + n,
            status: t.status,
            statusText: t.statusText
          }))) : r(e);
        });
      });
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.fetchElementRequest = r, e.fetchElementRequestFull = i, e.multiFetchElementsByTypeRequest = o, e.fetchWaysForNodeRequest = s, e.sendElementRequest = a, e.fetchNotesRequest = u, e.fetchNotesSearchRequest = c, e.fetchNoteByIdRequest = l, e.genericPostNoteRequest = h, e.createNoteRequest = f, e.createChangesetRequest = p, e.changesetCheckRequest = d, e.changesetGetRequest = y, e.updateChangesetTagsRequest = g, e.closeChangesetRequest = m, e.uploadChangesetOscRequest = v, e.fetchChangesetsRequest = w, e.fetchMapByBboxRequest = b, e.deleteElementRequest = _, e.fetchRelationsForElementRequest = E, e.getUserPreferencesRequest = T, e.setUserPreferencesRequest = A, e.getUserPreferenceByKeyRequest = x, e.setUserPreferenceByKeyRequest = D, e.deleteUserPreferenceRequest = C;
    var S = n(61),
        O = n(30),
        N = n(64),
        I = n(31);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function i(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return e.auth ? new Promise(function (n, r) {
        e.auth.xhr({
          method: "GET",
          prefix: !1,
          path: t
        }, function (t, e) {
          if (t) return r(new c.RequestException(JSON.stringify({
            message: "Request failed",
            status: t.status,
            statusText: t.statusText
          })));

          if (e instanceof XMLDocument) {
            var i = window && window.XMLSerializer ? new XMLSerializer() : u.default;
            return n(i.serializeToString(e));
          }

          return n(e);
        });
      }) : (0, s.default)(t).then(function (t) {
        return 200 !== t.status ? t.text().then(function (e) {
          return Promise.reject({
            message: e,
            status: t.status,
            statusText: t.statusText
          });
        }) : t;
      }).catch(function (t) {
        throw new c.RequestException(t);
      }).then(function (t) {
        return t.text();
      });
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.fetch = i;
    var o = n(62),
        s = r(o),
        a = n(63),
        u = r(a),
        c = n(31);
  }, function (t, e) {
    var n = function (t) {
      function e() {
        this.fetch = !1;
      }

      return e.prototype = t, new e();
    }("undefined" != typeof self ? self : this);

    (function (t) {
      !function (t) {
        function e(t) {
          if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
          return t.toLowerCase();
        }

        function n(t) {
          return "string" != typeof t && (t = String(t)), t;
        }

        function r(t) {
          var e = {
            next: function next() {
              var e = t.shift();
              return {
                done: void 0 === e,
                value: e
              };
            }
          };
          return m.iterable && (e[Symbol.iterator] = function () {
            return e;
          }), e;
        }

        function i(t) {
          this.map = {}, t instanceof i ? t.forEach(function (t, e) {
            this.append(e, t);
          }, this) : Array.isArray(t) ? t.forEach(function (t) {
            this.append(t[0], t[1]);
          }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
            this.append(e, t[e]);
          }, this);
        }

        function o(t) {
          if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
          t.bodyUsed = !0;
        }

        function s(t) {
          return new Promise(function (e, n) {
            t.onload = function () {
              e(t.result);
            }, t.onerror = function () {
              n(t.error);
            };
          });
        }

        function a(t) {
          var e = new FileReader(),
              n = s(e);
          return e.readAsArrayBuffer(t), n;
        }

        function u(t) {
          var e = new FileReader(),
              n = s(e);
          return e.readAsText(t), n;
        }

        function c(t) {
          for (var e = new Uint8Array(t), n = new Array(e.length), r = 0; r < e.length; r++) {
            n[r] = String.fromCharCode(e[r]);
          }

          return n.join("");
        }

        function l(t) {
          if (t.slice) return t.slice(0);
          var e = new Uint8Array(t.byteLength);
          return e.set(new Uint8Array(t)), e.buffer;
        }

        function h() {
          return this.bodyUsed = !1, this._initBody = function (t) {
            if (this._bodyInit = t, t) {
              if ("string" == typeof t) this._bodyText = t;else if (m.blob && Blob.prototype.isPrototypeOf(t)) this._bodyBlob = t;else if (m.formData && FormData.prototype.isPrototypeOf(t)) this._bodyFormData = t;else if (m.searchParams && URLSearchParams.prototype.isPrototypeOf(t)) this._bodyText = t.toString();else if (m.arrayBuffer && m.blob && w(t)) this._bodyArrayBuffer = l(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
                if (!m.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(t) && !b(t)) throw new Error("unsupported BodyInit type");
                this._bodyArrayBuffer = l(t);
              }
            } else this._bodyText = "";
            this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : m.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, m.blob && (this.blob = function () {
            var t = o(this);
            if (t) return t;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? o(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(a);
          }), this.text = function () {
            var t = o(this);
            if (t) return t;
            if (this._bodyBlob) return u(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(c(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, m.formData && (this.formData = function () {
            return this.text().then(d);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }

        function f(t) {
          var e = t.toUpperCase();
          return _.indexOf(e) > -1 ? e : t;
        }

        function p(t, e) {
          e = e || {};
          var n = e.body;

          if (t instanceof p) {
            if (t.bodyUsed) throw new TypeError("Already read");
            this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new i(t.headers)), this.method = t.method, this.mode = t.mode, n || null == t._bodyInit || (n = t._bodyInit, t.bodyUsed = !0);
          } else this.url = String(t);

          if (this.credentials = e.credentials || this.credentials || "omit", !e.headers && this.headers || (this.headers = new i(e.headers)), this.method = f(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");

          this._initBody(n);
        }

        function d(t) {
          var e = new FormData();
          return t.trim().split("&").forEach(function (t) {
            if (t) {
              var n = t.split("="),
                  r = n.shift().replace(/\+/g, " "),
                  i = n.join("=").replace(/\+/g, " ");
              e.append(decodeURIComponent(r), decodeURIComponent(i));
            }
          }), e;
        }

        function y(t) {
          var e = new i();
          return t.split(/\r?\n/).forEach(function (t) {
            var n = t.split(":"),
                r = n.shift().trim();

            if (r) {
              var i = n.join(":").trim();
              e.append(r, i);
            }
          }), e;
        }

        function g(t, e) {
          e || (e = {}), this.type = "default", this.status = "status" in e ? e.status : 200, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new i(e.headers), this.url = e.url || "", this._initBody(t);
        }

        if (!t.fetch) {
          var m = {
            searchParams: "URLSearchParams" in t,
            iterable: "Symbol" in t && "iterator" in Symbol,
            blob: "FileReader" in t && "Blob" in t && function () {
              try {
                return new Blob(), !0;
              } catch (t) {
                return !1;
              }
            }(),
            formData: "FormData" in t,
            arrayBuffer: "ArrayBuffer" in t
          };
          if (m.arrayBuffer) var v = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
              w = function w(t) {
            return t && DataView.prototype.isPrototypeOf(t);
          },
              b = ArrayBuffer.isView || function (t) {
            return t && v.indexOf(Object.prototype.toString.call(t)) > -1;
          };
          i.prototype.append = function (t, r) {
            t = e(t), r = n(r);
            var i = this.map[t];
            this.map[t] = i ? i + "," + r : r;
          }, i.prototype.delete = function (t) {
            delete this.map[e(t)];
          }, i.prototype.get = function (t) {
            return t = e(t), this.has(t) ? this.map[t] : null;
          }, i.prototype.has = function (t) {
            return this.map.hasOwnProperty(e(t));
          }, i.prototype.set = function (t, r) {
            this.map[e(t)] = n(r);
          }, i.prototype.forEach = function (t, e) {
            for (var n in this.map) {
              this.map.hasOwnProperty(n) && t.call(e, this.map[n], n, this);
            }
          }, i.prototype.keys = function () {
            var t = [];
            return this.forEach(function (e, n) {
              t.push(n);
            }), r(t);
          }, i.prototype.values = function () {
            var t = [];
            return this.forEach(function (e) {
              t.push(e);
            }), r(t);
          }, i.prototype.entries = function () {
            var t = [];
            return this.forEach(function (e, n) {
              t.push([n, e]);
            }), r(t);
          }, m.iterable && (i.prototype[Symbol.iterator] = i.prototype.entries);
          var _ = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
          p.prototype.clone = function () {
            return new p(this, {
              body: this._bodyInit
            });
          }, h.call(p.prototype), h.call(g.prototype), g.prototype.clone = function () {
            return new g(this._bodyInit, {
              status: this.status,
              statusText: this.statusText,
              headers: new i(this.headers),
              url: this.url
            });
          }, g.error = function () {
            var t = new g(null, {
              status: 0,
              statusText: ""
            });
            return t.type = "error", t;
          };
          var E = [301, 302, 303, 307, 308];
          g.redirect = function (t, e) {
            if (-1 === E.indexOf(e)) throw new RangeError("Invalid status code");
            return new g(null, {
              status: e,
              headers: {
                location: t
              }
            });
          }, t.Headers = i, t.Request = p, t.Response = g, t.fetch = function (t, e) {
            return new Promise(function (n, r) {
              var i = new p(t, e),
                  o = new XMLHttpRequest();
              o.onload = function () {
                var t = {
                  status: o.status,
                  statusText: o.statusText,
                  headers: y(o.getAllResponseHeaders() || "")
                };
                t.url = "responseURL" in o ? o.responseURL : t.headers.get("X-Request-URL");
                var e = "response" in o ? o.response : o.responseText;
                n(new g(e, t));
              }, o.onerror = function () {
                r(new TypeError("Network request failed"));
              }, o.ontimeout = function () {
                r(new TypeError("Network request failed"));
              }, o.open(i.method, i.url, !0), "include" === i.credentials && (o.withCredentials = !0), "responseType" in o && m.blob && (o.responseType = "blob"), i.headers.forEach(function (t, e) {
                o.setRequestHeader(e, t);
              }), o.send(void 0 === i._bodyInit ? null : i._bodyInit);
            });
          }, t.fetch.polyfill = !0;
        }
      }(void 0 !== t ? t : this);
    }).call(n, void 0);
    var r = n.fetch;
    r.Response = n.Response, r.Request = n.Request, r.Headers = n.Headers;
    "object" == typeof t && t.exports && (t.exports = r);
  }, function (t, e, n) {
    var r, i, o;
    !function (n, s) {
      i = [], r = s, void 0 !== (o = "function" == typeof r ? r.apply(e, i) : r) && (t.exports = o);
    }(0, function () {
      var t = function t(_t) {
        return _t.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, "");
      },
          e = function e(t) {
        return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
      },
          n = function n(t) {
        return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      },
          r = function r(t) {
        var n = t.value;
        return " " + t.name + '="' + e(n) + '"';
      },
          i = function i(t) {
        var e = t.tagName;
        return "http://www.w3.org/1999/xhtml" === t.namespaceURI && (e = e.toLowerCase()), e;
      },
          o = function o(t, e) {
        return Array.prototype.map.call(t.attributes || t.attrs, function (t) {
          return t.name;
        }).indexOf("xmlns") >= 0 || !e && t.namespaceURI === t.parentNode.namespaceURI ? "" : ' xmlns="' + t.namespaceURI + '"';
      },
          s = function s(t) {
        return Array.prototype.map.call(t.childNodes, function (t) {
          return h(t);
        }).join("");
      },
          a = function a(t, e) {
        var n = "<" + i(t);
        return n += o(t, e), Array.prototype.forEach.call(t.attributes || t.attrs, function (t) {
          n += r(t);
        }), t.childNodes.length > 0 ? (n += ">", n += s(t), n += "</" + i(t) + ">") : n += "/>", n;
      },
          u = function u(t) {
        var e = t.nodeValue || t.value || "";
        return n(e);
      },
          c = function c(t) {
        return "\x3c!--" + t.data.replace(/-/g, "&#45;") + "--\x3e";
      },
          l = function l(t) {
        return "<![CDATA[" + t.nodeValue + "]]>";
      },
          h = function h(t, e) {
        var n = e && e.rootNode;
        return "#document" === t.nodeName || "#document-fragment" === t.nodeName ? s(t) : t.tagName ? a(t, n) : "#text" === t.nodeName ? u(t) : "#comment" === t.nodeName ? c(t) : "#cdata-section" === t.nodeName ? l(t) : void 0;
      };

      return {
        serializeToString: function serializeToString(e) {
          return t(h(e, {
            rootNode: !0
          }));
        }
      };
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }

      return Array.from(t);
    }

    function i() {
      return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }

    function o() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = Object.entries(n).map(function (t) {
        return '<tag k="' + t[0] + '" v="' + i(String(t[1])) + '"/>';
      });
      return '\n    <osm>\n      <changeset>\n        <tag k="created_by" v="' + i(t) + '"/>\n        <tag k="created_by:library" v="OSM Request ' + w + '"/>\n        <tag k="comment" v="' + i(e) + '"/>\n        ' + r.join("\n        ") + "\n      </changeset>\n    </osm>\n  ";
    }

    function s() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
          r = Object.entries(t).map(function (t) {
        return '<tag k="' + t[0] + '" v="' + i(String(t[1])) + '"/>';
      });
      return '\n    <osm>\n      <changeset>\n        <tag k="created_by" v="' + i(e) + '"/>\n        <tag k="created_by:library" v="OSM Request ' + w + '"/>\n        <tag k="comment" v="' + i(n) + '"/>\n        ' + r.join("\n        ") + "\n      </changeset>\n    </osm>\n  ";
    }

    function a(t) {
      return "\n    <osm>\n      <preferences>\n        " + Object.entries(t).map(function (t) {
        return '<preference k="' + t[0] + '" v="' + i(String(t[1])) + '"/>';
      }).join("\n        ") + "\n      </preferences>\n    </osm>\n  ";
    }

    function u(t, e, n) {
      return p(t).then(function (t) {
        var r = t.osm[e][0];
        return r._id = n, r._type = e, r;
      });
    }

    function c(t) {
      var e = t.osm.bounds,
          n = function n(t) {
        return function (e) {
          return y({}, e, {
            _id: e.$.id,
            _type: t
          });
        };
      },
          r = [];

      t.osm.way && (r = t.osm.way.map(n("way")));
      var i = [];
      t.osm.node && (i = t.osm.node.map(n("node")));
      var o = [];
      t.osm.relation && (o = t.osm.relation.map(n("relation")));
      var s = {};
      return Object.entries({
        node: i,
        way: r,
        relation: o
      }).map(function (e) {
        e[0] in t.osm && (s[e[0]] = e[1]);
      }), e && (s.bounds = e), s;
    }

    function l(t, e) {
      return p(t).then(function (t) {
        return t.osm[e] ? t.osm[e].map(function (t) {
          return t._id = t.$.id, t._type = e, t;
        }) : [];
      });
    }

    function h(t) {
      return p(t).then(function (t) {
        return t.osm.note ? t.osm.note : [];
      }).then(function (t) {
        return t.map(function (t) {
          var e = f(t);
          return e.comments = [].concat(r(e.comments.comment.map(function (t) {
            return f(t);
          }))), e;
        });
      });
    }

    function f(t) {
      var e = y({}, t.$);
      return Object.keys(t).forEach(function (n) {
        "$" !== n && t[n] && 0 !== t[n].length && (e[n] = t[n][0]);
      }), e;
    }

    function p(t) {
      return new Promise(function (e, n) {
        (0, g.parseString)(t, function (t, r) {
          t && n(t), e(r);
        });
      });
    }

    function d(t) {
      return new g.Builder({
        xmldec: {
          version: "1.0",
          encoding: "UTF-8",
          standalone: null
        }
      }).buildObject(t);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var y = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    };

    e.encodeXML = i, e.buildChangesetXml = o, e.buildChangesetFromObjectXml = s, e.buildPreferencesFromObjectXml = a, e.convertElementXmlToJson = u, e.cleanMapJson = c, e.convertElementsListXmlToJson = l, e.convertNotesXmlToJson = h, e.flattenAttributes = f, e.xmlToJson = p, e.jsonToXml = d;

    var g = n(65),
        m = n(87),
        v = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(m),
        w = v.default.version;
  }, function (t, e, n) {
    (function () {
      "use strict";

      var t,
          r,
          i,
          o,
          s = function s(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          a.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          a = {}.hasOwnProperty;

      r = n(23), t = n(66), i = n(71), o = n(41), e.defaults = r.defaults, e.processors = o, e.ValidationError = function (t) {
        function e(t) {
          this.message = t;
        }

        return s(e, t), e;
      }(Error), e.Builder = t.Builder, e.Parser = i.Parser, e.parseString = i.parseString;
    }).call(this);
  }, function (t, e, n) {
    (function () {
      "use strict";

      var t,
          r,
          i,
          o,
          s,
          a = {}.hasOwnProperty;
      t = n(67), r = n(23).defaults, o = function o(t) {
        return "string" == typeof t && (t.indexOf("&") >= 0 || t.indexOf(">") >= 0 || t.indexOf("<") >= 0);
      }, s = function s(t) {
        return "<![CDATA[" + i(t) + "]]>";
      }, i = function i(t) {
        return t.replace("]]>", "]]]]><![CDATA[>");
      }, e.Builder = function () {
        function e(t) {
          var e, n, i;
          this.options = {}, n = r[.2];

          for (e in n) {
            a.call(n, e) && (i = n[e], this.options[e] = i);
          }

          for (e in t) {
            a.call(t, e) && (i = t[e], this.options[e] = i);
          }
        }

        return e.prototype.buildObject = function (e) {
          var n, i, u, c, l;
          return n = this.options.attrkey, i = this.options.charkey, 1 === Object.keys(e).length && this.options.rootName === r[.2].rootName ? (l = Object.keys(e)[0], e = e[l]) : l = this.options.rootName, u = function (t) {
            return function (e, r) {
              var c, l, h, f, p, d;
              if ("object" != typeof r) t.options.cdata && o(r) ? e.raw(s(r)) : e.txt(r);else if (Array.isArray(r)) {
                for (f in r) {
                  if (a.call(r, f)) {
                    l = r[f];

                    for (p in l) {
                      h = l[p], e = u(e.ele(p), h).up();
                    }
                  }
                }
              } else for (p in r) {
                if (a.call(r, p)) if (l = r[p], p === n) {
                  if ("object" == typeof l) for (c in l) {
                    d = l[c], e = e.att(c, d);
                  }
                } else if (p === i) e = t.options.cdata && o(l) ? e.raw(s(l)) : e.txt(l);else if (Array.isArray(l)) for (f in l) {
                  a.call(l, f) && (h = l[f], e = "string" == typeof h ? t.options.cdata && o(h) ? e.ele(p).raw(s(h)).up() : e.ele(p, h).up() : u(e.ele(p), h).up());
                } else "object" == typeof l ? e = u(e.ele(p), l).up() : "string" == typeof l && t.options.cdata && o(l) ? e = e.ele(p).raw(s(l)).up() : (null == l && (l = ""), e = e.ele(p, l.toString()).up());
              }
              return e;
            };
          }(this), c = t.create(l, this.options.xmldec, this.options.doctype, {
            headless: this.options.headless,
            allowSurrogateChars: this.options.allowSurrogateChars
          }), u(c, e).end(this.options.renderOpts);
        }, e;
      }();
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e, r, i, o, s, a, u;
      u = n(2), s = u.assign, a = u.isFunction, e = n(68), r = n(69), o = n(24), i = n(70), t.exports.create = function (t, n, r, i) {
        var o, a;
        if (null == t) throw new Error("Root element needs a name");
        return i = s({}, n, r, i), o = new e(i), a = o.element(t), i.headless || (o.declaration(i), null == i.pubID && null == i.sysID || o.doctype(i)), a;
      }, t.exports.begin = function (t, n, i) {
        var o;
        return a(t) && (o = [t, n], n = o[0], i = o[1], t = {}), n ? new r(t, n, i) : new e(t);
      }, t.exports.stringWriter = function (t) {
        return new o(t);
      }, t.exports.streamWriter = function (t, e) {
        return new i(t, e);
      };
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s = function s(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          a.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          a = {}.hasOwnProperty;

      o = n(2).isPlainObject, e = n(0), i = n(33), r = n(24), t.exports = function (t) {
        function e(t) {
          e.__super__.constructor.call(this, null), t || (t = {}), t.writer || (t.writer = new r()), this.options = t, this.stringify = new i(t), this.isDocument = !0;
        }

        return s(e, t), e.prototype.end = function (t) {
          var e;
          return t ? o(t) && (e = t, t = this.options.writer.set(e)) : t = this.options.writer, t.document(this);
        }, e.prototype.toString = function (t) {
          return this.options.writer.set(t).document(this);
        }, e;
      }(e);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          h,
          f,
          p,
          d,
          y,
          g,
          m,
          v,
          w,
          b,
          _ = {}.hasOwnProperty;
      b = n(2), v = b.isObject, m = b.isFunction, w = b.isPlainObject, h = n(7), r = n(8), i = n(9), p = n(16), g = n(17), f = n(18), c = n(10), l = n(11), o = n(12), a = n(13), s = n(14), u = n(15), e = n(32), y = n(33), d = n(24), t.exports = function () {
        function t(t, e, n) {
          var r;
          t || (t = {}), t.writer ? w(t.writer) && (r = t.writer, t.writer = new d(r)) : t.writer = new d(t), this.options = t, this.writer = t.writer, this.stringify = new y(t), this.onDataCallback = e || function () {}, this.onEndCallback = n || function () {}, this.currentNode = null, this.currentLevel = -1, this.openTags = {}, this.documentStarted = !1, this.documentCompleted = !1, this.root = null;
        }

        return t.prototype.node = function (t, e, n) {
          var r;
          if (null == t) throw new Error("Missing node name");
          if (this.root && -1 === this.currentLevel) throw new Error("Document can only have one root node");
          return this.openCurrent(), t = t.valueOf(), null == e && (e = {}), e = e.valueOf(), v(e) || (r = [e, n], n = r[0], e = r[1]), this.currentNode = new h(this, t, e), this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, null != n && this.text(n), this;
        }, t.prototype.element = function (t, e, n) {
          return this.currentNode && this.currentNode instanceof l ? this.dtdElement.apply(this, arguments) : this.node(t, e, n);
        }, t.prototype.attribute = function (t, n) {
          var r, i;
          if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode");
          if (null != t && (t = t.valueOf()), v(t)) for (r in t) {
            _.call(t, r) && (i = t[r], this.attribute(r, i));
          } else m(n) && (n = n.apply()), this.options.skipNullAttributes && null == n || (this.currentNode.attributes[t] = new e(this, t, n));
          return this;
        }, t.prototype.text = function (t) {
          var e;
          return this.openCurrent(), e = new g(this, t), this.onData(this.writer.text(e, this.currentLevel + 1)), this;
        }, t.prototype.cdata = function (t) {
          var e;
          return this.openCurrent(), e = new r(this, t), this.onData(this.writer.cdata(e, this.currentLevel + 1)), this;
        }, t.prototype.comment = function (t) {
          var e;
          return this.openCurrent(), e = new i(this, t), this.onData(this.writer.comment(e, this.currentLevel + 1)), this;
        }, t.prototype.raw = function (t) {
          var e;
          return this.openCurrent(), e = new p(this, t), this.onData(this.writer.raw(e, this.currentLevel + 1)), this;
        }, t.prototype.instruction = function (t, e) {
          var n, r, i, o, s;
          if (this.openCurrent(), null != t && (t = t.valueOf()), null != e && (e = e.valueOf()), Array.isArray(t)) for (n = 0, o = t.length; n < o; n++) {
            r = t[n], this.instruction(r);
          } else if (v(t)) for (r in t) {
            _.call(t, r) && (i = t[r], this.instruction(r, i));
          } else m(e) && (e = e.apply()), s = new f(this, t, e), this.onData(this.writer.processingInstruction(s, this.currentLevel + 1));
          return this;
        }, t.prototype.declaration = function (t, e, n) {
          var r;
          if (this.openCurrent(), this.documentStarted) throw new Error("declaration() must be the first node");
          return r = new c(this, t, e, n), this.onData(this.writer.declaration(r, this.currentLevel + 1)), this;
        }, t.prototype.doctype = function (t, e, n) {
          if (this.openCurrent(), null == t) throw new Error("Missing root node name");
          if (this.root) throw new Error("dtd() must come before the root node");
          return this.currentNode = new l(this, e, n), this.currentNode.rootNodeName = t, this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, this;
        }, t.prototype.dtdElement = function (t, e) {
          var n;
          return this.openCurrent(), n = new s(this, t, e), this.onData(this.writer.dtdElement(n, this.currentLevel + 1)), this;
        }, t.prototype.attList = function (t, e, n, r, i) {
          var s;
          return this.openCurrent(), s = new o(this, t, e, n, r, i), this.onData(this.writer.dtdAttList(s, this.currentLevel + 1)), this;
        }, t.prototype.entity = function (t, e) {
          var n;
          return this.openCurrent(), n = new a(this, !1, t, e), this.onData(this.writer.dtdEntity(n, this.currentLevel + 1)), this;
        }, t.prototype.pEntity = function (t, e) {
          var n;
          return this.openCurrent(), n = new a(this, !0, t, e), this.onData(this.writer.dtdEntity(n, this.currentLevel + 1)), this;
        }, t.prototype.notation = function (t, e) {
          var n;
          return this.openCurrent(), n = new u(this, t, e), this.onData(this.writer.dtdNotation(n, this.currentLevel + 1)), this;
        }, t.prototype.up = function () {
          if (this.currentLevel < 0) throw new Error("The document node has no parent");
          return this.currentNode ? (this.currentNode.children ? this.closeNode(this.currentNode) : this.openNode(this.currentNode), this.currentNode = null) : this.closeNode(this.openTags[this.currentLevel]), delete this.openTags[this.currentLevel], this.currentLevel--, this;
        }, t.prototype.end = function () {
          for (; this.currentLevel >= 0;) {
            this.up();
          }

          return this.onEnd();
        }, t.prototype.openCurrent = function () {
          if (this.currentNode) return this.currentNode.children = !0, this.openNode(this.currentNode);
        }, t.prototype.openNode = function (t) {
          if (!t.isOpen) return !this.root && 0 === this.currentLevel && t instanceof h && (this.root = t), this.onData(this.writer.openNode(t, this.currentLevel)), t.isOpen = !0;
        }, t.prototype.closeNode = function (t) {
          if (!t.isClosed) return this.onData(this.writer.closeNode(t, this.currentLevel)), t.isClosed = !0;
        }, t.prototype.onData = function (t) {
          return this.documentStarted = !0, this.onDataCallback(t);
        }, t.prototype.onEnd = function () {
          return this.documentCompleted = !0, this.onEndCallback();
        }, t.prototype.ele = function () {
          return this.element.apply(this, arguments);
        }, t.prototype.nod = function (t, e, n) {
          return this.node(t, e, n);
        }, t.prototype.txt = function (t) {
          return this.text(t);
        }, t.prototype.dat = function (t) {
          return this.cdata(t);
        }, t.prototype.com = function (t) {
          return this.comment(t);
        }, t.prototype.ins = function (t, e) {
          return this.instruction(t, e);
        }, t.prototype.dec = function (t, e, n) {
          return this.declaration(t, e, n);
        }, t.prototype.dtd = function (t, e, n) {
          return this.doctype(t, e, n);
        }, t.prototype.e = function (t, e, n) {
          return this.element(t, e, n);
        }, t.prototype.n = function (t, e, n) {
          return this.node(t, e, n);
        }, t.prototype.t = function (t) {
          return this.text(t);
        }, t.prototype.d = function (t) {
          return this.cdata(t);
        }, t.prototype.c = function (t) {
          return this.comment(t);
        }, t.prototype.r = function (t) {
          return this.raw(t);
        }, t.prototype.i = function (t, e) {
          return this.instruction(t, e);
        }, t.prototype.att = function () {
          return this.currentNode && this.currentNode instanceof l ? this.attList.apply(this, arguments) : this.attribute.apply(this, arguments);
        }, t.prototype.a = function () {
          return this.currentNode && this.currentNode instanceof l ? this.attList.apply(this, arguments) : this.attribute.apply(this, arguments);
        }, t.prototype.ent = function (t, e) {
          return this.entity(t, e);
        }, t.prototype.pent = function (t, e) {
          return this.pEntity(t, e);
        }, t.prototype.not = function (t, e) {
          return this.notation(t, e);
        }, t;
      }();
    }).call(this);
  }, function (t, e, n) {
    (function () {
      var e,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          h,
          f,
          p,
          d,
          y = function y(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          g.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          g = {}.hasOwnProperty;

      u = n(10), c = n(11), e = n(8), r = n(9), l = n(7), f = n(16), p = n(17), h = n(18), i = n(12), o = n(14), s = n(13), a = n(15), d = n(34), t.exports = function (t) {
        function n(t, e) {
          n.__super__.constructor.call(this, e), this.stream = t;
        }

        return y(n, t), n.prototype.document = function (t) {
          var e, n, i, o, s, a, l, f;

          for (a = t.children, n = 0, o = a.length; n < o; n++) {
            e = a[n], e.isLastRootNode = !1;
          }

          for (t.children[t.children.length - 1].isLastRootNode = !0, l = t.children, f = [], i = 0, s = l.length; i < s; i++) {
            switch (e = l[i], !1) {
              case !(e instanceof u):
                f.push(this.declaration(e));
                break;

              case !(e instanceof c):
                f.push(this.docType(e));
                break;

              case !(e instanceof r):
                f.push(this.comment(e));
                break;

              case !(e instanceof h):
                f.push(this.processingInstruction(e));
                break;

              default:
                f.push(this.element(e));
            }
          }

          return f;
        }, n.prototype.attribute = function (t) {
          return this.stream.write(" " + t.name + '="' + t.value + '"');
        }, n.prototype.cdata = function (t, e) {
          return this.stream.write(this.space(e) + "<![CDATA[" + t.text + "]]>" + this.endline(t));
        }, n.prototype.comment = function (t, e) {
          return this.stream.write(this.space(e) + "\x3c!-- " + t.text + " --\x3e" + this.endline(t));
        }, n.prototype.declaration = function (t, e) {
          return this.stream.write(this.space(e)), this.stream.write('<?xml version="' + t.version + '"'), null != t.encoding && this.stream.write(' encoding="' + t.encoding + '"'), null != t.standalone && this.stream.write(' standalone="' + t.standalone + '"'), this.stream.write(this.spacebeforeslash + "?>"), this.stream.write(this.endline(t));
        }, n.prototype.docType = function (t, n) {
          var u, c, l, f;

          if (n || (n = 0), this.stream.write(this.space(n)), this.stream.write("<!DOCTYPE " + t.root().name), t.pubID && t.sysID ? this.stream.write(' PUBLIC "' + t.pubID + '" "' + t.sysID + '"') : t.sysID && this.stream.write(' SYSTEM "' + t.sysID + '"'), t.children.length > 0) {
            for (this.stream.write(" ["), this.stream.write(this.endline(t)), f = t.children, c = 0, l = f.length; c < l; c++) {
              switch (u = f[c], !1) {
                case !(u instanceof i):
                  this.dtdAttList(u, n + 1);
                  break;

                case !(u instanceof o):
                  this.dtdElement(u, n + 1);
                  break;

                case !(u instanceof s):
                  this.dtdEntity(u, n + 1);
                  break;

                case !(u instanceof a):
                  this.dtdNotation(u, n + 1);
                  break;

                case !(u instanceof e):
                  this.cdata(u, n + 1);
                  break;

                case !(u instanceof r):
                  this.comment(u, n + 1);
                  break;

                case !(u instanceof h):
                  this.processingInstruction(u, n + 1);
                  break;

                default:
                  throw new Error("Unknown DTD node type: " + u.constructor.name);
              }
            }

            this.stream.write("]");
          }

          return this.stream.write(this.spacebeforeslash + ">"), this.stream.write(this.endline(t));
        }, n.prototype.element = function (t, n) {
          var i, o, s, a, u, c, d, y;
          n || (n = 0), y = this.space(n), this.stream.write(y + "<" + t.name), c = t.attributes;

          for (u in c) {
            g.call(c, u) && (i = c[u], this.attribute(i));
          }

          if (0 === t.children.length || t.children.every(function (t) {
            return "" === t.value;
          })) this.allowEmpty ? this.stream.write("></" + t.name + ">") : this.stream.write(this.spacebeforeslash + "/>");else if (this.pretty && 1 === t.children.length && null != t.children[0].value) this.stream.write(">"), this.stream.write(t.children[0].value), this.stream.write("</" + t.name + ">");else {
            for (this.stream.write(">" + this.newline), d = t.children, s = 0, a = d.length; s < a; s++) {
              switch (o = d[s], !1) {
                case !(o instanceof e):
                  this.cdata(o, n + 1);
                  break;

                case !(o instanceof r):
                  this.comment(o, n + 1);
                  break;

                case !(o instanceof l):
                  this.element(o, n + 1);
                  break;

                case !(o instanceof f):
                  this.raw(o, n + 1);
                  break;

                case !(o instanceof p):
                  this.text(o, n + 1);
                  break;

                case !(o instanceof h):
                  this.processingInstruction(o, n + 1);
                  break;

                default:
                  throw new Error("Unknown XML node type: " + o.constructor.name);
              }
            }

            this.stream.write(y + "</" + t.name + ">");
          }
          return this.stream.write(this.endline(t));
        }, n.prototype.processingInstruction = function (t, e) {
          return this.stream.write(this.space(e) + "<?" + t.target), t.value && this.stream.write(" " + t.value), this.stream.write(this.spacebeforeslash + "?>" + this.endline(t));
        }, n.prototype.raw = function (t, e) {
          return this.stream.write(this.space(e) + t.value + this.endline(t));
        }, n.prototype.text = function (t, e) {
          return this.stream.write(this.space(e) + t.value + this.endline(t));
        }, n.prototype.dtdAttList = function (t, e) {
          return this.stream.write(this.space(e) + "<!ATTLIST " + t.elementName + " " + t.attributeName + " " + t.attributeType), "#DEFAULT" !== t.defaultValueType && this.stream.write(" " + t.defaultValueType), t.defaultValue && this.stream.write(' "' + t.defaultValue + '"'), this.stream.write(this.spacebeforeslash + ">" + this.endline(t));
        }, n.prototype.dtdElement = function (t, e) {
          return this.stream.write(this.space(e) + "<!ELEMENT " + t.name + " " + t.value), this.stream.write(this.spacebeforeslash + ">" + this.endline(t));
        }, n.prototype.dtdEntity = function (t, e) {
          return this.stream.write(this.space(e) + "<!ENTITY"), t.pe && this.stream.write(" %"), this.stream.write(" " + t.name), t.value ? this.stream.write(' "' + t.value + '"') : (t.pubID && t.sysID ? this.stream.write(' PUBLIC "' + t.pubID + '" "' + t.sysID + '"') : t.sysID && this.stream.write(' SYSTEM "' + t.sysID + '"'), t.nData && this.stream.write(" NDATA " + t.nData)), this.stream.write(this.spacebeforeslash + ">" + this.endline(t));
        }, n.prototype.dtdNotation = function (t, e) {
          return this.stream.write(this.space(e) + "<!NOTATION " + t.name), t.pubID && t.sysID ? this.stream.write(' PUBLIC "' + t.pubID + '" "' + t.sysID + '"') : t.pubID ? this.stream.write(' PUBLIC "' + t.pubID + '"') : t.sysID && this.stream.write(' SYSTEM "' + t.sysID + '"'), this.stream.write(this.spacebeforeslash + ">" + this.endline(t));
        }, n.prototype.endline = function (t) {
          return t.isLastRootNode ? "" : this.newline;
        }, n;
      }(d);
    }).call(this);
  }, function (t, e, n) {
    (function () {
      "use strict";

      var t,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l = function l(t, e) {
        return function () {
          return t.apply(e, arguments);
        };
      },
          h = function h(t, e) {
        function n() {
          this.constructor = t;
        }

        for (var r in e) {
          f.call(e, r) && (t[r] = e[r]);
        }

        return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
      },
          f = {}.hasOwnProperty;

      u = n(72), i = n(19), t = n(86), a = n(41), c = n(39).setImmediate, r = n(23).defaults, o = function o(t) {
        return "object" == typeof t && null != t && 0 === Object.keys(t).length;
      }, s = function s(t, e, n) {
        var r, i, o;

        for (r = 0, i = t.length; r < i; r++) {
          o = t[r], e = o(e, n);
        }

        return e;
      }, e.Parser = function (n) {
        function i(t) {
          this.parseString = l(this.parseString, this), this.reset = l(this.reset, this), this.assignOrPush = l(this.assignOrPush, this), this.processAsync = l(this.processAsync, this);
          var n, i, o;
          if (!(this instanceof e.Parser)) return new e.Parser(t);
          this.options = {}, i = r[.2];

          for (n in i) {
            f.call(i, n) && (o = i[n], this.options[n] = o);
          }

          for (n in t) {
            f.call(t, n) && (o = t[n], this.options[n] = o);
          }

          this.options.xmlns && (this.options.xmlnskey = this.options.attrkey + "ns"), this.options.normalizeTags && (this.options.tagNameProcessors || (this.options.tagNameProcessors = []), this.options.tagNameProcessors.unshift(a.normalize)), this.reset();
        }

        return h(i, n), i.prototype.processAsync = function () {
          var t, e;

          try {
            return this.remaining.length <= this.options.chunkSize ? (t = this.remaining, this.remaining = "", this.saxParser = this.saxParser.write(t), this.saxParser.close()) : (t = this.remaining.substr(0, this.options.chunkSize), this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length), this.saxParser = this.saxParser.write(t), c(this.processAsync));
          } catch (t) {
            if (e = t, !this.saxParser.errThrown) return this.saxParser.errThrown = !0, this.emit(e);
          }
        }, i.prototype.assignOrPush = function (t, e, n) {
          return e in t ? (t[e] instanceof Array || (t[e] = [t[e]]), t[e].push(n)) : this.options.explicitArray ? t[e] = [n] : t[e] = n;
        }, i.prototype.reset = function () {
          var t, e, n, r;
          return this.removeAllListeners(), this.saxParser = u.parser(this.options.strict, {
            trim: !1,
            normalize: !1,
            xmlns: this.options.xmlns
          }), this.saxParser.errThrown = !1, this.saxParser.onerror = function (t) {
            return function (e) {
              if (t.saxParser.resume(), !t.saxParser.errThrown) return t.saxParser.errThrown = !0, t.emit("error", e);
            };
          }(this), this.saxParser.onend = function (t) {
            return function () {
              if (!t.saxParser.ended) return t.saxParser.ended = !0, t.emit("end", t.resultObject);
            };
          }(this), this.saxParser.ended = !1, this.EXPLICIT_CHARKEY = this.options.explicitCharkey, this.resultObject = null, r = [], t = this.options.attrkey, e = this.options.charkey, this.saxParser.onopentag = function (n) {
            return function (i) {
              var o, a, u, c, l;

              if (u = {}, u[e] = "", !n.options.ignoreAttrs) {
                l = i.attributes;

                for (o in l) {
                  f.call(l, o) && (t in u || n.options.mergeAttrs || (u[t] = {}), a = n.options.attrValueProcessors ? s(n.options.attrValueProcessors, i.attributes[o], o) : i.attributes[o], c = n.options.attrNameProcessors ? s(n.options.attrNameProcessors, o) : o, n.options.mergeAttrs ? n.assignOrPush(u, c, a) : u[t][c] = a);
                }
              }

              return u["#name"] = n.options.tagNameProcessors ? s(n.options.tagNameProcessors, i.name) : i.name, n.options.xmlns && (u[n.options.xmlnskey] = {
                uri: i.uri,
                local: i.local
              }), r.push(u);
            };
          }(this), this.saxParser.onclosetag = function (t) {
            return function () {
              var n, i, a, u, c, l, h, p, d, y;
              if (l = r.pop(), c = l["#name"], t.options.explicitChildren && t.options.preserveChildrenOrder || delete l["#name"], !0 === l.cdata && (n = l.cdata, delete l.cdata), d = r[r.length - 1], l[e].match(/^\s*$/) && !n ? (i = l[e], delete l[e]) : (t.options.trim && (l[e] = l[e].trim()), t.options.normalize && (l[e] = l[e].replace(/\s{2,}/g, " ").trim()), l[e] = t.options.valueProcessors ? s(t.options.valueProcessors, l[e], c) : l[e], 1 === Object.keys(l).length && e in l && !t.EXPLICIT_CHARKEY && (l = l[e])), o(l) && (l = "" !== t.options.emptyTag ? t.options.emptyTag : i), null != t.options.validator && (y = "/" + function () {
                var t, e, n;

                for (n = [], t = 0, e = r.length; t < e; t++) {
                  u = r[t], n.push(u["#name"]);
                }

                return n;
              }().concat(c).join("/"), function () {
                var e;

                try {
                  l = t.options.validator(y, d && d[c], l);
                } catch (n) {
                  return e = n, t.emit("error", e);
                }
              }()), t.options.explicitChildren && !t.options.mergeAttrs && "object" == typeof l) if (t.options.preserveChildrenOrder) {
                if (d) {
                  d[t.options.childkey] = d[t.options.childkey] || [], h = {};

                  for (a in l) {
                    f.call(l, a) && (h[a] = l[a]);
                  }

                  d[t.options.childkey].push(h), delete l["#name"], 1 === Object.keys(l).length && e in l && !t.EXPLICIT_CHARKEY && (l = l[e]);
                }
              } else u = {}, t.options.attrkey in l && (u[t.options.attrkey] = l[t.options.attrkey], delete l[t.options.attrkey]), !t.options.charsAsChildren && t.options.charkey in l && (u[t.options.charkey] = l[t.options.charkey], delete l[t.options.charkey]), Object.getOwnPropertyNames(l).length > 0 && (u[t.options.childkey] = l), l = u;
              return r.length > 0 ? t.assignOrPush(d, c, l) : (t.options.explicitRoot && (p = l, l = {}, l[c] = p), t.resultObject = l, t.saxParser.ended = !0, t.emit("end", t.resultObject));
            };
          }(this), n = function (t) {
            return function (n) {
              var i, o;
              if (o = r[r.length - 1]) return o[e] += n, t.options.explicitChildren && t.options.preserveChildrenOrder && t.options.charsAsChildren && (t.options.includeWhiteChars || "" !== n.replace(/\\n/g, "").trim()) && (o[t.options.childkey] = o[t.options.childkey] || [], i = {
                "#name": "__text__"
              }, i[e] = n, t.options.normalize && (i[e] = i[e].replace(/\s{2,}/g, " ").trim()), o[t.options.childkey].push(i)), o;
            };
          }(this), this.saxParser.ontext = n, this.saxParser.oncdata = function (t) {
            return function (t) {
              var e;
              if (e = n(t)) return e.cdata = !0;
            };
          }();
        }, i.prototype.parseString = function (e, n) {
          var r;
          null != n && "function" == typeof n && (this.on("end", function (t) {
            return this.reset(), n(null, t);
          }), this.on("error", function (t) {
            return this.reset(), n(t);
          }));

          try {
            return e = e.toString(), "" === e.trim() ? (this.emit("end", null), !0) : (e = t.stripBOM(e), this.options.async ? (this.remaining = e, c(this.processAsync), this.saxParser) : this.saxParser.write(e).close());
          } catch (t) {
            if (r = t, !this.saxParser.errThrown && !this.saxParser.ended) return this.emit("error", r), this.saxParser.errThrown = !0;
            if (this.saxParser.ended) throw r;
          }
        }, i;
      }(i.EventEmitter), e.parseString = function (t, n, r) {
        var i, o, s;
        return null != r ? ("function" == typeof r && (i = r), "object" == typeof n && (o = n)) : ("function" == typeof n && (i = n), o = {}), s = new e.Parser(o), s.parseString(t, i);
      };
    }).call(this);
  }, function (t, e, n) {
    (function (t) {
      !function (e) {
        function r(t, n) {
          if (!(this instanceof r)) return new r(t, n);
          var i = this;
          o(i), i.q = i.c = "", i.bufferCheckPosition = e.MAX_BUFFER_LENGTH, i.opt = n || {}, i.opt.lowercase = i.opt.lowercase || i.opt.lowercasetags, i.looseCase = i.opt.lowercase ? "toLowerCase" : "toUpperCase", i.tags = [], i.closed = i.closedRoot = i.sawRoot = !1, i.tag = i.error = null, i.strict = !!t, i.noscript = !(!t && !i.opt.noscript), i.state = Y.BEGIN, i.strictEntities = i.opt.strictEntities, i.ENTITIES = i.strictEntities ? Object.create(e.XML_ENTITIES) : Object.create(e.ENTITIES), i.attribList = [], i.opt.xmlns && (i.ns = Object.create(L)), i.trackPosition = !1 !== i.opt.position, i.trackPosition && (i.position = i.line = i.column = 0), d(i, "onready");
        }

        function i(t) {
          for (var n = Math.max(e.MAX_BUFFER_LENGTH, 10), r = 0, i = 0, o = N.length; i < o; i++) {
            var s = t[N[i]].length;
            if (s > n) switch (N[i]) {
              case "textNode":
                g(t);
                break;

              case "cdata":
                y(t, "oncdata", t.cdata), t.cdata = "";
                break;

              case "script":
                y(t, "onscript", t.script), t.script = "";
                break;

              default:
                v(t, "Max buffer length exceeded: " + N[i]);
            }
            r = Math.max(r, s);
          }

          var a = e.MAX_BUFFER_LENGTH - r;
          t.bufferCheckPosition = a + t.position;
        }

        function o(t) {
          for (var e = 0, n = N.length; e < n; e++) {
            t[N[e]] = "";
          }
        }

        function s(t) {
          g(t), "" !== t.cdata && (y(t, "oncdata", t.cdata), t.cdata = ""), "" !== t.script && (y(t, "onscript", t.script), t.script = "");
        }

        function a(t, e) {
          return new u(t, e);
        }

        function u(t, e) {
          if (!(this instanceof u)) return new u(t, e);
          I.apply(this), this._parser = new r(t, e), this.writable = !0, this.readable = !0;
          var n = this;
          this._parser.onend = function () {
            n.emit("end");
          }, this._parser.onerror = function (t) {
            n.emit("error", t), n._parser.error = null;
          }, this._decoder = null, P.forEach(function (t) {
            Object.defineProperty(n, "on" + t, {
              get: function get() {
                return n._parser["on" + t];
              },
              set: function set(e) {
                if (!e) return n.removeAllListeners(t), n._parser["on" + t] = e, e;
                n.on(t, e);
              },
              enumerable: !0,
              configurable: !1
            });
          });
        }

        function c(t) {
          return " " === t || "\n" === t || "\r" === t || "\t" === t;
        }

        function l(t) {
          return '"' === t || "'" === t;
        }

        function h(t) {
          return ">" === t || c(t);
        }

        function f(t, e) {
          return t.test(e);
        }

        function p(t, e) {
          return !f(t, e);
        }

        function d(t, e, n) {
          t[e] && t[e](n);
        }

        function y(t, e, n) {
          t.textNode && g(t), d(t, e, n);
        }

        function g(t) {
          t.textNode = m(t.opt, t.textNode), t.textNode && d(t, "ontext", t.textNode), t.textNode = "";
        }

        function m(t, e) {
          return t.trim && (e = e.trim()), t.normalize && (e = e.replace(/\s+/g, " ")), e;
        }

        function v(t, e) {
          return g(t), t.trackPosition && (e += "\nLine: " + t.line + "\nColumn: " + t.column + "\nChar: " + t.c), e = new Error(e), t.error = e, d(t, "onerror", e), t;
        }

        function w(t) {
          return t.sawRoot && !t.closedRoot && b(t, "Unclosed root tag"), t.state !== Y.BEGIN && t.state !== Y.BEGIN_WHITESPACE && t.state !== Y.TEXT && v(t, "Unexpected end"), g(t), t.c = "", t.closed = !0, d(t, "onend"), r.call(t, t.strict, t.opt), t;
        }

        function b(t, e) {
          if ("object" != typeof t || !(t instanceof r)) throw new Error("bad call to strictFail");
          t.strict && v(t, e);
        }

        function _(t) {
          t.strict || (t.tagName = t.tagName[t.looseCase]());
          var e = t.tags[t.tags.length - 1] || t,
              n = t.tag = {
            name: t.tagName,
            attributes: {}
          };
          t.opt.xmlns && (n.ns = e.ns), t.attribList.length = 0, y(t, "onopentagstart", n);
        }

        function E(t, e) {
          var n = t.indexOf(":"),
              r = n < 0 ? ["", t] : t.split(":"),
              i = r[0],
              o = r[1];
          return e && "xmlns" === t && (i = "xmlns", o = ""), {
            prefix: i,
            local: o
          };
        }

        function T(t) {
          if (t.strict || (t.attribName = t.attribName[t.looseCase]()), -1 !== t.attribList.indexOf(t.attribName) || t.tag.attributes.hasOwnProperty(t.attribName)) return void (t.attribName = t.attribValue = "");

          if (t.opt.xmlns) {
            var e = E(t.attribName, !0),
                n = e.prefix,
                r = e.local;
            if ("xmlns" === n) if ("xml" === r && t.attribValue !== k) b(t, "xml: prefix must be bound to " + k + "\nActual: " + t.attribValue);else if ("xmlns" === r && t.attribValue !== F) b(t, "xmlns: prefix must be bound to " + F + "\nActual: " + t.attribValue);else {
              var i = t.tag,
                  o = t.tags[t.tags.length - 1] || t;
              i.ns === o.ns && (i.ns = Object.create(o.ns)), i.ns[r] = t.attribValue;
            }
            t.attribList.push([t.attribName, t.attribValue]);
          } else t.tag.attributes[t.attribName] = t.attribValue, y(t, "onattribute", {
            name: t.attribName,
            value: t.attribValue
          });

          t.attribName = t.attribValue = "";
        }

        function A(t, e) {
          if (t.opt.xmlns) {
            var n = t.tag,
                r = E(t.tagName);
            n.prefix = r.prefix, n.local = r.local, n.uri = n.ns[r.prefix] || "", n.prefix && !n.uri && (b(t, "Unbound namespace prefix: " + JSON.stringify(t.tagName)), n.uri = r.prefix);
            var i = t.tags[t.tags.length - 1] || t;
            n.ns && i.ns !== n.ns && Object.keys(n.ns).forEach(function (e) {
              y(t, "onopennamespace", {
                prefix: e,
                uri: n.ns[e]
              });
            });

            for (var o = 0, s = t.attribList.length; o < s; o++) {
              var a = t.attribList[o],
                  u = a[0],
                  c = a[1],
                  l = E(u, !0),
                  h = l.prefix,
                  f = l.local,
                  p = "" === h ? "" : n.ns[h] || "",
                  d = {
                name: u,
                value: c,
                prefix: h,
                local: f,
                uri: p
              };
              h && "xmlns" !== h && !p && (b(t, "Unbound namespace prefix: " + JSON.stringify(h)), d.uri = h), t.tag.attributes[u] = d, y(t, "onattribute", d);
            }

            t.attribList.length = 0;
          }

          t.tag.isSelfClosing = !!e, t.sawRoot = !0, t.tags.push(t.tag), y(t, "onopentag", t.tag), e || (t.noscript || "script" !== t.tagName.toLowerCase() ? t.state = Y.TEXT : t.state = Y.SCRIPT, t.tag = null, t.tagName = ""), t.attribName = t.attribValue = "", t.attribList.length = 0;
        }

        function x(t) {
          if (!t.tagName) return b(t, "Weird empty close tag."), t.textNode += "</>", void (t.state = Y.TEXT);

          if (t.script) {
            if ("script" !== t.tagName) return t.script += "</" + t.tagName + ">", t.tagName = "", void (t.state = Y.SCRIPT);
            y(t, "onscript", t.script), t.script = "";
          }

          var e = t.tags.length,
              n = t.tagName;
          t.strict || (n = n[t.looseCase]());

          for (var r = n; e--;) {
            if (t.tags[e].name === r) break;
            b(t, "Unexpected close tag");
          }

          if (e < 0) return b(t, "Unmatched closing tag: " + t.tagName), t.textNode += "</" + t.tagName + ">", void (t.state = Y.TEXT);
          t.tagName = n;

          for (var i = t.tags.length; i-- > e;) {
            var o = t.tag = t.tags.pop();
            t.tagName = t.tag.name, y(t, "onclosetag", t.tagName);
            var s = {};

            for (var a in o.ns) {
              s[a] = o.ns[a];
            }

            var u = t.tags[t.tags.length - 1] || t;
            t.opt.xmlns && o.ns !== u.ns && Object.keys(o.ns).forEach(function (e) {
              var n = o.ns[e];
              y(t, "onclosenamespace", {
                prefix: e,
                uri: n
              });
            });
          }

          0 === e && (t.closedRoot = !0), t.tagName = t.attribValue = t.attribName = "", t.attribList.length = 0, t.state = Y.TEXT;
        }

        function D(t) {
          var e,
              n = t.entity,
              r = n.toLowerCase(),
              i = "";
          return t.ENTITIES[n] ? t.ENTITIES[n] : t.ENTITIES[r] ? t.ENTITIES[r] : (n = r, "#" === n.charAt(0) && ("x" === n.charAt(1) ? (n = n.slice(2), e = parseInt(n, 16), i = e.toString(16)) : (n = n.slice(1), e = parseInt(n, 10), i = e.toString(10))), n = n.replace(/^0+/, ""), isNaN(e) || i.toLowerCase() !== n ? (b(t, "Invalid character entity"), "&" + t.entity + ";") : String.fromCodePoint(e));
        }

        function C(t, e) {
          "<" === e ? (t.state = Y.OPEN_WAKA, t.startTagPosition = t.position) : c(e) || (b(t, "Non-whitespace before first tag."), t.textNode = e, t.state = Y.TEXT);
        }

        function S(t, e) {
          var n = "";
          return e < t.length && (n = t.charAt(e)), n;
        }

        function O(t) {
          var e = this;
          if (this.error) throw this.error;
          if (e.closed) return v(e, "Cannot write after close. Assign an onready handler.");
          if (null === t) return w(e);
          "object" == typeof t && (t = t.toString());

          for (var n = 0, r = "";;) {
            if (r = S(t, n++), e.c = r, !r) break;

            switch (e.trackPosition && (e.position++, "\n" === r ? (e.line++, e.column = 0) : e.column++), e.state) {
              case Y.BEGIN:
                if (e.state = Y.BEGIN_WHITESPACE, "\uFEFF" === r) continue;
                C(e, r);
                continue;

              case Y.BEGIN_WHITESPACE:
                C(e, r);
                continue;

              case Y.TEXT:
                if (e.sawRoot && !e.closedRoot) {
                  for (var o = n - 1; r && "<" !== r && "&" !== r;) {
                    (r = S(t, n++)) && e.trackPosition && (e.position++, "\n" === r ? (e.line++, e.column = 0) : e.column++);
                  }

                  e.textNode += t.substring(o, n - 1);
                }

                "<" !== r || e.sawRoot && e.closedRoot && !e.strict ? (c(r) || e.sawRoot && !e.closedRoot || b(e, "Text data outside of root node."), "&" === r ? e.state = Y.TEXT_ENTITY : e.textNode += r) : (e.state = Y.OPEN_WAKA, e.startTagPosition = e.position);
                continue;

              case Y.SCRIPT:
                "<" === r ? e.state = Y.SCRIPT_ENDING : e.script += r;
                continue;

              case Y.SCRIPT_ENDING:
                "/" === r ? e.state = Y.CLOSE_TAG : (e.script += "<" + r, e.state = Y.SCRIPT);
                continue;

              case Y.OPEN_WAKA:
                if ("!" === r) e.state = Y.SGML_DECL, e.sgmlDecl = "";else if (c(r)) ;else if (f(j, r)) e.state = Y.OPEN_TAG, e.tagName = r;else if ("/" === r) e.state = Y.CLOSE_TAG, e.tagName = "";else if ("?" === r) e.state = Y.PROC_INST, e.procInstName = e.procInstBody = "";else {
                  if (b(e, "Unencoded <"), e.startTagPosition + 1 < e.position) {
                    var s = e.position - e.startTagPosition;
                    r = new Array(s).join(" ") + r;
                  }

                  e.textNode += "<" + r, e.state = Y.TEXT;
                }
                continue;

              case Y.SGML_DECL:
                (e.sgmlDecl + r).toUpperCase() === B ? (y(e, "onopencdata"), e.state = Y.CDATA, e.sgmlDecl = "", e.cdata = "") : e.sgmlDecl + r === "--" ? (e.state = Y.COMMENT, e.comment = "", e.sgmlDecl = "") : (e.sgmlDecl + r).toUpperCase() === R ? (e.state = Y.DOCTYPE, (e.doctype || e.sawRoot) && b(e, "Inappropriately located doctype declaration"), e.doctype = "", e.sgmlDecl = "") : ">" === r ? (y(e, "onsgmldeclaration", e.sgmlDecl), e.sgmlDecl = "", e.state = Y.TEXT) : l(r) ? (e.state = Y.SGML_DECL_QUOTED, e.sgmlDecl += r) : e.sgmlDecl += r;
                continue;

              case Y.SGML_DECL_QUOTED:
                r === e.q && (e.state = Y.SGML_DECL, e.q = ""), e.sgmlDecl += r;
                continue;

              case Y.DOCTYPE:
                ">" === r ? (e.state = Y.TEXT, y(e, "ondoctype", e.doctype), e.doctype = !0) : (e.doctype += r, "[" === r ? e.state = Y.DOCTYPE_DTD : l(r) && (e.state = Y.DOCTYPE_QUOTED, e.q = r));
                continue;

              case Y.DOCTYPE_QUOTED:
                e.doctype += r, r === e.q && (e.q = "", e.state = Y.DOCTYPE);
                continue;

              case Y.DOCTYPE_DTD:
                e.doctype += r, "]" === r ? e.state = Y.DOCTYPE : l(r) && (e.state = Y.DOCTYPE_DTD_QUOTED, e.q = r);
                continue;

              case Y.DOCTYPE_DTD_QUOTED:
                e.doctype += r, r === e.q && (e.state = Y.DOCTYPE_DTD, e.q = "");
                continue;

              case Y.COMMENT:
                "-" === r ? e.state = Y.COMMENT_ENDING : e.comment += r;
                continue;

              case Y.COMMENT_ENDING:
                "-" === r ? (e.state = Y.COMMENT_ENDED, e.comment = m(e.opt, e.comment), e.comment && y(e, "oncomment", e.comment), e.comment = "") : (e.comment += "-" + r, e.state = Y.COMMENT);
                continue;

              case Y.COMMENT_ENDED:
                ">" !== r ? (b(e, "Malformed comment"), e.comment += "--" + r, e.state = Y.COMMENT) : e.state = Y.TEXT;
                continue;

              case Y.CDATA:
                "]" === r ? e.state = Y.CDATA_ENDING : e.cdata += r;
                continue;

              case Y.CDATA_ENDING:
                "]" === r ? e.state = Y.CDATA_ENDING_2 : (e.cdata += "]" + r, e.state = Y.CDATA);
                continue;

              case Y.CDATA_ENDING_2:
                ">" === r ? (e.cdata && y(e, "oncdata", e.cdata), y(e, "onclosecdata"), e.cdata = "", e.state = Y.TEXT) : "]" === r ? e.cdata += "]" : (e.cdata += "]]" + r, e.state = Y.CDATA);
                continue;

              case Y.PROC_INST:
                "?" === r ? e.state = Y.PROC_INST_ENDING : c(r) ? e.state = Y.PROC_INST_BODY : e.procInstName += r;
                continue;

              case Y.PROC_INST_BODY:
                if (!e.procInstBody && c(r)) continue;
                "?" === r ? e.state = Y.PROC_INST_ENDING : e.procInstBody += r;
                continue;

              case Y.PROC_INST_ENDING:
                ">" === r ? (y(e, "onprocessinginstruction", {
                  name: e.procInstName,
                  body: e.procInstBody
                }), e.procInstName = e.procInstBody = "", e.state = Y.TEXT) : (e.procInstBody += "?" + r, e.state = Y.PROC_INST_BODY);
                continue;

              case Y.OPEN_TAG:
                f(U, r) ? e.tagName += r : (_(e), ">" === r ? A(e) : "/" === r ? e.state = Y.OPEN_TAG_SLASH : (c(r) || b(e, "Invalid character in tag name"), e.state = Y.ATTRIB));
                continue;

              case Y.OPEN_TAG_SLASH:
                ">" === r ? (A(e, !0), x(e)) : (b(e, "Forward-slash in opening tag not followed by >"), e.state = Y.ATTRIB);
                continue;

              case Y.ATTRIB:
                if (c(r)) continue;
                ">" === r ? A(e) : "/" === r ? e.state = Y.OPEN_TAG_SLASH : f(j, r) ? (e.attribName = r, e.attribValue = "", e.state = Y.ATTRIB_NAME) : b(e, "Invalid attribute name");
                continue;

              case Y.ATTRIB_NAME:
                "=" === r ? e.state = Y.ATTRIB_VALUE : ">" === r ? (b(e, "Attribute without value"), e.attribValue = e.attribName, T(e), A(e)) : c(r) ? e.state = Y.ATTRIB_NAME_SAW_WHITE : f(U, r) ? e.attribName += r : b(e, "Invalid attribute name");
                continue;

              case Y.ATTRIB_NAME_SAW_WHITE:
                if ("=" === r) e.state = Y.ATTRIB_VALUE;else {
                  if (c(r)) continue;
                  b(e, "Attribute without value"), e.tag.attributes[e.attribName] = "", e.attribValue = "", y(e, "onattribute", {
                    name: e.attribName,
                    value: ""
                  }), e.attribName = "", ">" === r ? A(e) : f(j, r) ? (e.attribName = r, e.state = Y.ATTRIB_NAME) : (b(e, "Invalid attribute name"), e.state = Y.ATTRIB);
                }
                continue;

              case Y.ATTRIB_VALUE:
                if (c(r)) continue;
                l(r) ? (e.q = r, e.state = Y.ATTRIB_VALUE_QUOTED) : (b(e, "Unquoted attribute value"), e.state = Y.ATTRIB_VALUE_UNQUOTED, e.attribValue = r);
                continue;

              case Y.ATTRIB_VALUE_QUOTED:
                if (r !== e.q) {
                  "&" === r ? e.state = Y.ATTRIB_VALUE_ENTITY_Q : e.attribValue += r;
                  continue;
                }

                T(e), e.q = "", e.state = Y.ATTRIB_VALUE_CLOSED;
                continue;

              case Y.ATTRIB_VALUE_CLOSED:
                c(r) ? e.state = Y.ATTRIB : ">" === r ? A(e) : "/" === r ? e.state = Y.OPEN_TAG_SLASH : f(j, r) ? (b(e, "No whitespace between attributes"), e.attribName = r, e.attribValue = "", e.state = Y.ATTRIB_NAME) : b(e, "Invalid attribute name");
                continue;

              case Y.ATTRIB_VALUE_UNQUOTED:
                if (!h(r)) {
                  "&" === r ? e.state = Y.ATTRIB_VALUE_ENTITY_U : e.attribValue += r;
                  continue;
                }

                T(e), ">" === r ? A(e) : e.state = Y.ATTRIB;
                continue;

              case Y.CLOSE_TAG:
                if (e.tagName) ">" === r ? x(e) : f(U, r) ? e.tagName += r : e.script ? (e.script += "</" + e.tagName, e.tagName = "", e.state = Y.SCRIPT) : (c(r) || b(e, "Invalid tagname in closing tag"), e.state = Y.CLOSE_TAG_SAW_WHITE);else {
                  if (c(r)) continue;
                  p(j, r) ? e.script ? (e.script += "</" + r, e.state = Y.SCRIPT) : b(e, "Invalid tagname in closing tag.") : e.tagName = r;
                }
                continue;

              case Y.CLOSE_TAG_SAW_WHITE:
                if (c(r)) continue;
                ">" === r ? x(e) : b(e, "Invalid characters in closing tag");
                continue;

              case Y.TEXT_ENTITY:
              case Y.ATTRIB_VALUE_ENTITY_Q:
              case Y.ATTRIB_VALUE_ENTITY_U:
                var a, u;

                switch (e.state) {
                  case Y.TEXT_ENTITY:
                    a = Y.TEXT, u = "textNode";
                    break;

                  case Y.ATTRIB_VALUE_ENTITY_Q:
                    a = Y.ATTRIB_VALUE_QUOTED, u = "attribValue";
                    break;

                  case Y.ATTRIB_VALUE_ENTITY_U:
                    a = Y.ATTRIB_VALUE_UNQUOTED, u = "attribValue";
                }

                ";" === r ? (e[u] += D(e), e.entity = "", e.state = a) : f(e.entity.length ? q : M, r) ? e.entity += r : (b(e, "Invalid character in entity name"), e[u] += "&" + e.entity + r, e.entity = "", e.state = a);
                continue;

              default:
                throw new Error(e, "Unknown state: " + e.state);
            }
          }

          return e.position >= e.bufferCheckPosition && i(e), e;
        }

        e.parser = function (t, e) {
          return new r(t, e);
        }, e.SAXParser = r, e.SAXStream = u, e.createStream = a, e.MAX_BUFFER_LENGTH = 65536;
        var N = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];
        e.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function (t) {
          function e() {}

          return e.prototype = t, new e();
        }), Object.keys || (Object.keys = function (t) {
          var e = [];

          for (var n in t) {
            t.hasOwnProperty(n) && e.push(n);
          }

          return e;
        }), r.prototype = {
          end: function end() {
            w(this);
          },
          write: O,
          resume: function resume() {
            return this.error = null, this;
          },
          close: function close() {
            return this.write(null);
          },
          flush: function flush() {
            s(this);
          }
        };
        var I;

        try {
          I = n(75).Stream;
        } catch (t) {
          I = function I() {};
        }

        var P = e.EVENTS.filter(function (t) {
          return "error" !== t && "end" !== t;
        });
        u.prototype = Object.create(I.prototype, {
          constructor: {
            value: u
          }
        }), u.prototype.write = function (e) {
          if ("function" == typeof t && "function" == typeof t.isBuffer && t.isBuffer(e)) {
            if (!this._decoder) {
              var r = n(28).StringDecoder;
              this._decoder = new r("utf8");
            }

            e = this._decoder.write(e);
          }

          return this._parser.write(e.toString()), this.emit("data", e), !0;
        }, u.prototype.end = function (t) {
          return t && t.length && this.write(t), this._parser.end(), !0;
        }, u.prototype.on = function (t, e) {
          var n = this;
          return n._parser["on" + t] || -1 === P.indexOf(t) || (n._parser["on" + t] = function () {
            var e = 1 === arguments.length ? [arguments[0]] : Array.apply(null, arguments);
            e.splice(0, 0, t), n.emit.apply(n, e);
          }), I.prototype.on.call(n, t, e);
        };
        var B = "[CDATA[",
            R = "DOCTYPE",
            k = "http://www.w3.org/XML/1998/namespace",
            F = "http://www.w3.org/2000/xmlns/",
            L = {
          xml: k,
          xmlns: F
        },
            j = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
            U = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/,
            M = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
            q = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/,
            Y = 0;
        e.STATE = {
          BEGIN: Y++,
          BEGIN_WHITESPACE: Y++,
          TEXT: Y++,
          TEXT_ENTITY: Y++,
          OPEN_WAKA: Y++,
          SGML_DECL: Y++,
          SGML_DECL_QUOTED: Y++,
          DOCTYPE: Y++,
          DOCTYPE_QUOTED: Y++,
          DOCTYPE_DTD: Y++,
          DOCTYPE_DTD_QUOTED: Y++,
          COMMENT_STARTING: Y++,
          COMMENT: Y++,
          COMMENT_ENDING: Y++,
          COMMENT_ENDED: Y++,
          CDATA: Y++,
          CDATA_ENDING: Y++,
          CDATA_ENDING_2: Y++,
          PROC_INST: Y++,
          PROC_INST_BODY: Y++,
          PROC_INST_ENDING: Y++,
          OPEN_TAG: Y++,
          OPEN_TAG_SLASH: Y++,
          ATTRIB: Y++,
          ATTRIB_NAME: Y++,
          ATTRIB_NAME_SAW_WHITE: Y++,
          ATTRIB_VALUE: Y++,
          ATTRIB_VALUE_QUOTED: Y++,
          ATTRIB_VALUE_CLOSED: Y++,
          ATTRIB_VALUE_UNQUOTED: Y++,
          ATTRIB_VALUE_ENTITY_Q: Y++,
          ATTRIB_VALUE_ENTITY_U: Y++,
          CLOSE_TAG: Y++,
          CLOSE_TAG_SAW_WHITE: Y++,
          SCRIPT: Y++,
          SCRIPT_ENDING: Y++
        }, e.XML_ENTITIES = {
          amp: "&",
          gt: ">",
          lt: "<",
          quot: '"',
          apos: "'"
        }, e.ENTITIES = {
          amp: "&",
          gt: ">",
          lt: "<",
          quot: '"',
          apos: "'",
          AElig: 198,
          Aacute: 193,
          Acirc: 194,
          Agrave: 192,
          Aring: 197,
          Atilde: 195,
          Auml: 196,
          Ccedil: 199,
          ETH: 208,
          Eacute: 201,
          Ecirc: 202,
          Egrave: 200,
          Euml: 203,
          Iacute: 205,
          Icirc: 206,
          Igrave: 204,
          Iuml: 207,
          Ntilde: 209,
          Oacute: 211,
          Ocirc: 212,
          Ograve: 210,
          Oslash: 216,
          Otilde: 213,
          Ouml: 214,
          THORN: 222,
          Uacute: 218,
          Ucirc: 219,
          Ugrave: 217,
          Uuml: 220,
          Yacute: 221,
          aacute: 225,
          acirc: 226,
          aelig: 230,
          agrave: 224,
          aring: 229,
          atilde: 227,
          auml: 228,
          ccedil: 231,
          eacute: 233,
          ecirc: 234,
          egrave: 232,
          eth: 240,
          euml: 235,
          iacute: 237,
          icirc: 238,
          igrave: 236,
          iuml: 239,
          ntilde: 241,
          oacute: 243,
          ocirc: 244,
          ograve: 242,
          oslash: 248,
          otilde: 245,
          ouml: 246,
          szlig: 223,
          thorn: 254,
          uacute: 250,
          ucirc: 251,
          ugrave: 249,
          uuml: 252,
          yacute: 253,
          yuml: 255,
          copy: 169,
          reg: 174,
          nbsp: 160,
          iexcl: 161,
          cent: 162,
          pound: 163,
          curren: 164,
          yen: 165,
          brvbar: 166,
          sect: 167,
          uml: 168,
          ordf: 170,
          laquo: 171,
          not: 172,
          shy: 173,
          macr: 175,
          deg: 176,
          plusmn: 177,
          sup1: 185,
          sup2: 178,
          sup3: 179,
          acute: 180,
          micro: 181,
          para: 182,
          middot: 183,
          cedil: 184,
          ordm: 186,
          raquo: 187,
          frac14: 188,
          frac12: 189,
          frac34: 190,
          iquest: 191,
          times: 215,
          divide: 247,
          OElig: 338,
          oelig: 339,
          Scaron: 352,
          scaron: 353,
          Yuml: 376,
          fnof: 402,
          circ: 710,
          tilde: 732,
          Alpha: 913,
          Beta: 914,
          Gamma: 915,
          Delta: 916,
          Epsilon: 917,
          Zeta: 918,
          Eta: 919,
          Theta: 920,
          Iota: 921,
          Kappa: 922,
          Lambda: 923,
          Mu: 924,
          Nu: 925,
          Xi: 926,
          Omicron: 927,
          Pi: 928,
          Rho: 929,
          Sigma: 931,
          Tau: 932,
          Upsilon: 933,
          Phi: 934,
          Chi: 935,
          Psi: 936,
          Omega: 937,
          alpha: 945,
          beta: 946,
          gamma: 947,
          delta: 948,
          epsilon: 949,
          zeta: 950,
          eta: 951,
          theta: 952,
          iota: 953,
          kappa: 954,
          lambda: 955,
          mu: 956,
          nu: 957,
          xi: 958,
          omicron: 959,
          pi: 960,
          rho: 961,
          sigmaf: 962,
          sigma: 963,
          tau: 964,
          upsilon: 965,
          phi: 966,
          chi: 967,
          psi: 968,
          omega: 969,
          thetasym: 977,
          upsih: 978,
          piv: 982,
          ensp: 8194,
          emsp: 8195,
          thinsp: 8201,
          zwnj: 8204,
          zwj: 8205,
          lrm: 8206,
          rlm: 8207,
          ndash: 8211,
          mdash: 8212,
          lsquo: 8216,
          rsquo: 8217,
          sbquo: 8218,
          ldquo: 8220,
          rdquo: 8221,
          bdquo: 8222,
          dagger: 8224,
          Dagger: 8225,
          bull: 8226,
          hellip: 8230,
          permil: 8240,
          prime: 8242,
          Prime: 8243,
          lsaquo: 8249,
          rsaquo: 8250,
          oline: 8254,
          frasl: 8260,
          euro: 8364,
          image: 8465,
          weierp: 8472,
          real: 8476,
          trade: 8482,
          alefsym: 8501,
          larr: 8592,
          uarr: 8593,
          rarr: 8594,
          darr: 8595,
          harr: 8596,
          crarr: 8629,
          lArr: 8656,
          uArr: 8657,
          rArr: 8658,
          dArr: 8659,
          hArr: 8660,
          forall: 8704,
          part: 8706,
          exist: 8707,
          empty: 8709,
          nabla: 8711,
          isin: 8712,
          notin: 8713,
          ni: 8715,
          prod: 8719,
          sum: 8721,
          minus: 8722,
          lowast: 8727,
          radic: 8730,
          prop: 8733,
          infin: 8734,
          ang: 8736,
          and: 8743,
          or: 8744,
          cap: 8745,
          cup: 8746,
          int: 8747,
          there4: 8756,
          sim: 8764,
          cong: 8773,
          asymp: 8776,
          ne: 8800,
          equiv: 8801,
          le: 8804,
          ge: 8805,
          sub: 8834,
          sup: 8835,
          nsub: 8836,
          sube: 8838,
          supe: 8839,
          oplus: 8853,
          otimes: 8855,
          perp: 8869,
          sdot: 8901,
          lceil: 8968,
          rceil: 8969,
          lfloor: 8970,
          rfloor: 8971,
          lang: 9001,
          rang: 9002,
          loz: 9674,
          spades: 9824,
          clubs: 9827,
          hearts: 9829,
          diams: 9830
        }, Object.keys(e.ENTITIES).forEach(function (t) {
          var n = e.ENTITIES[t],
              r = "number" == typeof n ? String.fromCharCode(n) : n;
          e.ENTITIES[t] = r;
        });

        for (var V in e.STATE) {
          e.STATE[e.STATE[V]] = V;
        }

        Y = e.STATE, String.fromCodePoint || function () {
          var t = String.fromCharCode,
              e = Math.floor,
              n = function n() {
            var n,
                r,
                i = [],
                o = -1,
                s = arguments.length;
            if (!s) return "";

            for (var a = ""; ++o < s;) {
              var u = Number(arguments[o]);
              if (!isFinite(u) || u < 0 || u > 1114111 || e(u) !== u) throw RangeError("Invalid code point: " + u);
              u <= 65535 ? i.push(u) : (u -= 65536, n = 55296 + (u >> 10), r = u % 1024 + 56320, i.push(n, r)), (o + 1 === s || i.length > 16384) && (a += t.apply(null, i), i.length = 0);
            }

            return a;
          };

          Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
            value: n,
            configurable: !0,
            writable: !0
          }) : String.fromCodePoint = n;
        }();
      }(e);
    }).call(e, n(25).Buffer);
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      return "=" === t[e - 2] ? 2 : "=" === t[e - 1] ? 1 : 0;
    }

    function i(t) {
      return 3 * t.length / 4 - r(t);
    }

    function o(t) {
      var e,
          n,
          i,
          o,
          s,
          a = t.length;
      o = r(t), s = new h(3 * a / 4 - o), n = o > 0 ? a - 4 : a;
      var u = 0;

      for (e = 0; e < n; e += 4) {
        i = l[t.charCodeAt(e)] << 18 | l[t.charCodeAt(e + 1)] << 12 | l[t.charCodeAt(e + 2)] << 6 | l[t.charCodeAt(e + 3)], s[u++] = i >> 16 & 255, s[u++] = i >> 8 & 255, s[u++] = 255 & i;
      }

      return 2 === o ? (i = l[t.charCodeAt(e)] << 2 | l[t.charCodeAt(e + 1)] >> 4, s[u++] = 255 & i) : 1 === o && (i = l[t.charCodeAt(e)] << 10 | l[t.charCodeAt(e + 1)] << 4 | l[t.charCodeAt(e + 2)] >> 2, s[u++] = i >> 8 & 255, s[u++] = 255 & i), s;
    }

    function s(t) {
      return c[t >> 18 & 63] + c[t >> 12 & 63] + c[t >> 6 & 63] + c[63 & t];
    }

    function a(t, e, n) {
      for (var r, i = [], o = e; o < n; o += 3) {
        r = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (255 & t[o + 2]), i.push(s(r));
      }

      return i.join("");
    }

    function u(t) {
      for (var e, n = t.length, r = n % 3, i = "", o = [], s = 0, u = n - r; s < u; s += 16383) {
        o.push(a(t, s, s + 16383 > u ? u : s + 16383));
      }

      return 1 === r ? (e = t[n - 1], i += c[e >> 2], i += c[e << 4 & 63], i += "==") : 2 === r && (e = (t[n - 2] << 8) + t[n - 1], i += c[e >> 10], i += c[e >> 4 & 63], i += c[e << 2 & 63], i += "="), o.push(i), o.join("");
    }

    e.byteLength = i, e.toByteArray = o, e.fromByteArray = u;

    for (var c = [], l = [], h = "undefined" != typeof Uint8Array ? Uint8Array : Array, f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0, d = f.length; p < d; ++p) {
      c[p] = f[p], l[f.charCodeAt(p)] = p;
    }

    l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, n, r, i) {
      var o,
          s,
          a = 8 * i - r - 1,
          u = (1 << a) - 1,
          c = u >> 1,
          l = -7,
          h = n ? i - 1 : 0,
          f = n ? -1 : 1,
          p = t[e + h];

      for (h += f, o = p & (1 << -l) - 1, p >>= -l, l += a; l > 0; o = 256 * o + t[e + h], h += f, l -= 8) {
        ;
      }

      for (s = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; s = 256 * s + t[e + h], h += f, l -= 8) {
        ;
      }

      if (0 === o) o = 1 - c;else {
        if (o === u) return s ? NaN : 1 / 0 * (p ? -1 : 1);
        s += Math.pow(2, r), o -= c;
      }
      return (p ? -1 : 1) * s * Math.pow(2, o - r);
    }, e.write = function (t, e, n, r, i, o) {
      var s,
          a,
          u,
          c = 8 * o - i - 1,
          l = (1 << c) - 1,
          h = l >> 1,
          f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = r ? 0 : o - 1,
          d = r ? 1 : -1,
          y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = l) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), e += s + h >= 1 ? f / u : f * Math.pow(2, 1 - h), e * u >= 2 && (s++, u /= 2), s + h >= l ? (a = 0, s = l) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[n + p] = 255 & a, p += d, a /= 256, i -= 8) {
        ;
      }

      for (s = s << i | a, c += i; c > 0; t[n + p] = 255 & s, p += d, s /= 256, c -= 8) {
        ;
      }

      t[n + p - d] |= 128 * y;
    };
  }, function (t, e, n) {
    function r() {
      i.call(this);
    }

    t.exports = r;
    var i = n(19).EventEmitter;
    n(5)(r, i), r.Readable = n(26), r.Writable = n(82), r.Duplex = n(83), r.Transform = n(84), r.PassThrough = n(85), r.Stream = r, r.prototype.pipe = function (t, e) {
      function n(e) {
        t.writable && !1 === t.write(e) && c.pause && c.pause();
      }

      function r() {
        c.readable && c.resume && c.resume();
      }

      function o() {
        l || (l = !0, t.end());
      }

      function s() {
        l || (l = !0, "function" == typeof t.destroy && t.destroy());
      }

      function a(t) {
        if (u(), 0 === i.listenerCount(this, "error")) throw t;
      }

      function u() {
        c.removeListener("data", n), t.removeListener("drain", r), c.removeListener("end", o), c.removeListener("close", s), c.removeListener("error", a), t.removeListener("error", a), c.removeListener("end", u), c.removeListener("close", u), t.removeListener("close", u);
      }

      var c = this;
      c.on("data", n), t.on("drain", r), t._isStdio || e && !1 === e.end || (c.on("end", o), c.on("close", s));
      var l = !1;
      return c.on("error", a), t.on("error", a), c.on("end", u), c.on("close", u), t.on("close", u), t.emit("pipe", c), t;
    };
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function i(t, e, n) {
      t.copy(e, n);
    }

    var o = n(22).Buffer,
        s = n(78);
    t.exports = function () {
      function t() {
        r(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, n = "" + e.data; e = e.next;) {
          n += t + e.data;
        }

        return n;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return o.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e = o.allocUnsafe(t >>> 0), n = this.head, r = 0; n;) {
          i(n.data, e, r), r += n.data.length, n = n.next;
        }

        return e;
      }, t;
    }(), s && s.inspect && s.inspect.custom && (t.exports.prototype[s.inspect.custom] = function () {
      var t = s.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";

        function r(t) {
          "function" != typeof t && (t = new Function("" + t));

          for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
            e[n] = arguments[n + 1];
          }

          var r = {
            callback: t,
            args: e
          };
          return c[u] = r, a(u), u++;
        }

        function i(t) {
          delete c[t];
        }

        function o(t) {
          var e = t.callback,
              r = t.args;

          switch (r.length) {
            case 0:
              e();
              break;

            case 1:
              e(r[0]);
              break;

            case 2:
              e(r[0], r[1]);
              break;

            case 3:
              e(r[0], r[1], r[2]);
              break;

            default:
              e.apply(n, r);
          }
        }

        function s(t) {
          if (l) setTimeout(s, 0, t);else {
            var e = c[t];

            if (e) {
              l = !0;

              try {
                o(e);
              } finally {
                i(t), l = !1;
              }
            }
          }
        }

        if (!t.setImmediate) {
          var a,
              u = 1,
              c = {},
              l = !1,
              h = t.document,
              f = Object.getPrototypeOf && Object.getPrototypeOf(t);
          f = f && f.setTimeout ? f : t, "[object process]" === {}.toString.call(t.process) ? function () {
            a = function a(t) {
              e.nextTick(function () {
                s(t);
              });
            };
          }() : function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? function () {
            var e = "setImmediate$" + Math.random() + "$",
                n = function n(_n) {
              _n.source === t && "string" == typeof _n.data && 0 === _n.data.indexOf(e) && s(+_n.data.slice(e.length));
            };

            t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), a = function a(n) {
              t.postMessage(e + n, "*");
            };
          }() : t.MessageChannel ? function () {
            var t = new MessageChannel();
            t.port1.onmessage = function (t) {
              s(t.data);
            }, a = function a(e) {
              t.port2.postMessage(e);
            };
          }() : h && "onreadystatechange" in h.createElement("script") ? function () {
            var t = h.documentElement;

            a = function a(e) {
              var n = h.createElement("script");
              n.onreadystatechange = function () {
                s(e), n.onreadystatechange = null, t.removeChild(n), n = null;
              }, t.appendChild(n);
            };
          }() : function () {
            a = function a(t) {
              setTimeout(s, 0, t);
            };
          }(), f.setImmediate = r, f.clearImmediate = i;
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(e, n(1), n(20));
  }, function (t, e, n) {
    (function (e) {
      function n(t, e) {
        function n() {
          if (!i) {
            if (r("throwDeprecation")) throw new Error(e);
            r("traceDeprecation") ? console.trace(e) : console.warn(e), i = !0;
          }

          return t.apply(this, arguments);
        }

        if (r("noDeprecation")) return t;
        var i = !1;
        return n;
      }

      function r(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var n = e.localStorage[t];
        return null != n && "true" === String(n).toLowerCase();
      }

      t.exports = n;
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if (!(this instanceof r)) return new r(t);
      i.call(this, t);
    }

    t.exports = r;
    var i = n(40),
        o = n(6);
    o.inherits = n(5), o.inherits(r, i), r.prototype._transform = function (t, e, n) {
      n(null, t);
    };
  }, function (t, e, n) {
    t.exports = n(27);
  }, function (t, e, n) {
    t.exports = n(3);
  }, function (t, e, n) {
    t.exports = n(26).Transform;
  }, function (t, e, n) {
    t.exports = n(26).PassThrough;
  }, function (t, e) {
    (function () {
      "use strict";

      e.stripBOM = function (t) {
        return "\uFEFF" === t[0] ? t.substring(1) : t;
      };
    }).call(this);
  }, function (t, e) {
    t.exports = {
      name: "osm-request",
      description: "Request the OSM API from Javascript, with promises :)",
      version: "1.2.4",
      homepage: "https://github.com/osmlab/osm-request/",
      repository: "https://github.com/osmlab/osm-request/",
      bugs: "https://github.com/osmlab/osm-request/issues",
      author: "OpenStreetMap developers",
      license: "MIT",
      keywords: ["osm", "openstreetmap", "request", "api"],
      main: "dist/OsmRequest.js",
      files: ["dist"],
      moduleRoots: ["node_modules", "src"],
      scripts: {
        watch: "cross-env NODE_PATH=src webpack -w --progress",
        build: "cross-env NODE_ENV=production NODE_PATH=src webpack --progress",
        precommit: "lint-staged",
        test: "cross-env NODE_PATH=src jest --env=jsdom",
        "test-watch": "npm test -- --coverage --watch",
        "test-ci": "npm test -- --ci --coverage",
        "test-prettier": "prettier --single-quote --list-different 'src/**/*.{js,json}'",
        lint: "eslint 'src/**/*.{js,json}'",
        doc: "npm run doc:lint && documentation build ./src/* -f md > API.md",
        "doc:lint": "documentation lint ./src/*",
        preversion: "npm run test-ci && npm run build",
        postversion: "git push && git push --tags"
      },
      jest: {
        collectCoverageFrom: ["src/**/*.js", "!<rootDir>/node_modules/"],
        coveragePathIgnorePatterns: ["<rootDir>/src/requests.js", "<rootDir>/src/helpers/time.js", "<rootDir>/node_modules/"],
        coverageReporters: ["json", "lcov"]
      },
      prettier: {
        semi: !0,
        singleQuote: !0
      },
      "lint-staged": {
        "src/**/*.{js,json}": ["prettier --single-quote --write", "eslint", "git add"],
        "src/**/*.js": ["npm run test-ci -- --findRelatedTests", "npm run doc", "git add API.md"]
      },
      devDependencies: {
        "babel-core": "^6.26.0",
        "babel-eslint": "^8.0.1",
        "babel-loader": "^7.1.3",
        "babel-preset-env": "^1.6.0",
        "babel-preset-stage-0": "^6.24.1",
        coveralls: "^3.0.0",
        "cross-env": "^5.1.1",
        documentation: "^6.0.0",
        eslint: "^4.18.2",
        "eslint-config-prettier": "^2.6.0",
        "eslint-plugin-import": "^2.7.0",
        "eslint-plugin-jest": "^21.13.0",
        "eslint-plugin-json": "^1.2.0",
        husky: "^0.14.3",
        jest: "^22.4.2",
        "lint-staged": "^7.0.0",
        prettier: "^1.11.1",
        webpack: "^3.11.0"
      },
      dependencies: {
        "cross-fetch": "^2.1.0",
        "osm-auth": "^1.0.2",
        xml2js: "^0.4.19",
        xmlserializer: "^0.6.1"
      }
    };
  }]).default;
});